// @ts-nocheck

import type { ReactNode } from "react";
import React from 'react';
import {
  FaPaw, FaBone, FaFish, FaCat, FaDog, FaTractor, FaCartShopping,
  FaShirt, FaShoePrints, FaBagShopping, FaGem, FaRing,
  FaPalette, FaMusic, FaTicketSimple, FaBook, FaMasksTheater,
  FaBaby, FaBabyCarriage,
  FaIndustry, FaWarehouse, FaTruck, FaHelmetSafety,
  FaCamera, FaVideo, FaBinoculars,
  FaLaptop, FaMobileScreenButton, FaHeadphones, FaTv, FaPlug,
  FaAppleWhole, FaWineBottle, FaMugSaucer, FaCookieBite, FaSmoking,
  FaCouch, FaBed, FaChair, FaLightbulb,
  FaScrewdriverWrench, FaHammer, FaWrench, FaScrewdriver, FaPaintRoller,
  FaSpa, FaPumpSoap, FaScissors, FaWandMagicSparkles, FaTree, FaSeedling, FaPersonSwimming, FaUmbrellaBeach,
  FaSuitcase, FaSuitcaseRolling, FaBriefcase,
  FaTriangleExclamation,
  FaFilm, FaCompactDisc, FaGuitar,
  FaPaperclip, FaPen, FaFolder, FaPrint,
  FaCross, FaStar, FaDove,
  FaCode, FaLaptopCode, FaCloud,
  FaFutbol, FaDumbbell, FaPersonBiking, FaPersonRunning, FaCampground,
  FaGamepad, FaChess, FaPuzzlePiece, FaChild,
  FaCar, FaMotorcycle, FaCarBattery, FaCarSide,
  FaGift,
  FaCircleQuestion,
  FaBellConcierge, FaHandshakeAngle, FaTruckFast,
  FaSquarePlus,
  FaBoxesStacked, FaLayerGroup,
  FaVest, FaMitten,
  FaBolt,
  FaCrown,
  FaHeart,
  FaTag, FaBurger, FaPizzaSlice, FaBowlRice, FaBowlFood, FaHotdog, FaDrumstickBite, FaFire, FaCheese, FaBreadSlice, FaLeaf, FaShrimp, FaUtensils, FaPepperHot,
  FaEgg, FaCarrot, FaIceCream, FaBottleWater, FaBeerMugEmpty, FaCandyCane, FaToiletPaper, FaTooth,
} from "react-icons/fa6";
import { FaSnowflake, FaWind } from "react-icons/fa";
import { SiSimpleicons } from "react-icons/si";

/* ───────────────────────────────────────────────────────────
   TYPES
   ─────────────────────────────────────────────────────────── */
export type CategoryLevel = "department" | "category" | "subCategory" | "productType" | "product";

export interface Product {
  id: string;
  productTypeId: string;
  name: string;
  sku: string;
  rate: number;
}

export interface CategoryItem {
  id: string;               // zero-padded, 2-digit-per-level code
  parentId: string | null;  // id of node one level up; null only for department
  level: CategoryLevel;
  name: string;
  icon: ReactNode;
  // icon: JSX.Element;

  //icon: any;  // ← Silences the error
  //icon: React.ReactNode; 
  // icon: any;
  image?: any;
attributes?: Attribute[];
}

/* ───────────────────────────────────────────────────────────
   DEPARTMENTS  (level 1 — top of tree, parentId: null)*/

export const DEPARTMENTS: CategoryItem[] = [
  { id: "00", parentId: null, level: "department", name: "ArtCrafts",   icon: <FaPalette /> },
  { id: "01", parentId: null, level: "department", name: "Automotive",  icon: <FaCar /> },
  { id: "02", parentId: null, level: "department", name: "Aviation",    icon: <FaPlug /> },
  { id: "03", parentId: null, level: "department", name: "Baby",        icon: <FaBaby /> },
  { id: "04", parentId: null, level: "department", name: "Beauty",      icon: <FaSpa /> },
  { id: "05", parentId: null, level: "department", name: "Books",       icon: <FaBook /> },
  { id: "06", parentId: null, level: "department", name: "Electronics", icon: <FaLaptop /> },
  { id: "07", parentId: null, level: "department", name: "Apparallel",  icon: <FaShirt /> },
  { id: "08", parentId: null, level: "department", name: "Food",        icon: <FaMugSaucer /> },
  { id: "09", parentId: null, level: "department", name: "Furniture",   icon: <FaCouch /> },
  { id: "10", parentId: null, level: "department", name: "Gaming",      icon: <FaGamepad /> },
  { id: "11", parentId: null, level: "department", name: "Gifts",       icon: <FaGift /> },
  { id: "12", parentId: null, level: "department", name: "Kitchen",     icon: <FaChair /> },
  { id: "13", parentId: null, level: "department", name: "Luggage",     icon: <FaSuitcase /> },
  { id: "14", parentId: null, level: "department", name: "Pets",        icon: <FaPaw /> },
  { id: "15", parentId: null, level: "department", name: "Sports",      icon: <FaFutbol /> },
  { id: "16", parentId: null, level: "department", name: "Tools",       icon: <FaScrewdriverWrench /> },
  { id: "17", parentId: null, level: "department", name: "Toys",        icon: <FaPuzzlePiece /> },
];





/* ═══════════════════════════════════════════════════════════
   DEPARTMENT-LEVEL CATEGORY ARRAYS
   id = deptId + 2-digit suffix, level: "category", parentId: deptId
═══════════════════════════════════════════════════════════ */

/* ── 00 ArtCrafts ─────────────────────────────────────────── */
export const DEPARTMENTARTCRAFTS: CategoryItem[] = [
  { id: "0001", parentId: "00", level: "category", name: "Painting",                icon: <FaPalette /> },
  { id: "0002", parentId: "00", level: "category", name: "Drawing",                 icon: <FaPen /> },
  { id: "0003", parentId: "00", level: "category", name: "Sculpting & Pottery",     icon: <FaWandMagicSparkles /> },
  { id: "0004", parentId: "00", level: "category", name: "Craft Supplies",          icon: <FaBoxesStacked /> },
  { id: "0005", parentId: "00", level: "category", name: "Scrapbooking",            icon: <FaFolder /> },
  { id: "0006", parentId: "00", level: "category", name: "Sewing & Textile Crafts", icon: <FaScissors /> },
  { id: "0007", parentId: "00", level: "category", name: "Jewelry Making",          icon: <FaRing /> },
  { id: "0008", parentId: "00", level: "category", name: "Party & Paper Crafts",    icon: <FaGift /> },
];

/* ── 01 Automotive ────────────────────────────────────────── */
export const DEPARTMENTAUTOMOTIVE: CategoryItem[] = [
  { id: "0101", parentId: "01", level: "category", name: "Car Parts",            icon: <FaCarSide /> },
  { id: "0102", parentId: "01", level: "category", name: "Car Accessories",      icon: <FaCar /> },
  { id: "0103", parentId: "01", level: "category", name: "Car Care & Detailing", icon: <FaPumpSoap /> },
  { id: "0104", parentId: "01", level: "category", name: "Tires & Wheels",       icon: <FaCircleQuestion /> },
  { id: "0105", parentId: "01", level: "category", name: "Tools & Equipment",    icon: <FaScrewdriverWrench /> },
  { id: "0106", parentId: "01", level: "category", name: "Motorcycle Parts",     icon: <FaMotorcycle /> },
  { id: "0107", parentId: "01", level: "category", name: "Car Electronics",      icon: <FaCarBattery /> },
  { id: "0108", parentId: "01", level: "category", name: "Interior Accessories", icon: <FaChair /> },
  { id: "0109", parentId: "01", level: "category", name: "Exterior Accessories", icon: <FaCarSide /> },
  { id: "0110", parentId: "01", level: "category", name: "Oils & Fluids",        icon: <FaWineBottle /> },
];

/* ── 02 Aviation ──────────────────────────────────────────── */
export const DEPARTMENTAVIATION: CategoryItem[] = [
  { id: "0201", parentId: "02", level: "category", name: "Pilot Supplies",          icon: <FaBriefcase /> },
  { id: "0202", parentId: "02", level: "category", name: "Aircraft Parts",          icon: <FaPlug /> },
  { id: "0203", parentId: "02", level: "category", name: "Aviation Electronics",    icon: <FaLaptop /> },
  { id: "0204", parentId: "02", level: "category", name: "Model Aircraft",          icon: <FaPuzzlePiece /> },
  { id: "0205", parentId: "02", level: "category", name: "Aviation Safety Gear",    icon: <FaHelmetSafety /> },
  { id: "0206", parentId: "02", level: "category", name: "Drones & UAVs",           icon: <FaCamera /> },
  { id: "0207", parentId: "02", level: "category", name: "Aviation Books & Charts", icon: <FaBook /> },
];

/* ── 03 Baby ──────────────────────────────────────────────── */
export const DEPARTMENTBABY: CategoryItem[] = [
  { id: "0301", parentId: "03", level: "category", name: "Baby Clothing",        icon: <FaShirt /> },
  { id: "0302", parentId: "03", level: "category", name: "Baby Feeding",         icon: <FaMugSaucer /> },
  { id: "0303", parentId: "03", level: "category", name: "Baby Gear",            icon: <FaBabyCarriage /> },
  { id: "0304", parentId: "03", level: "category", name: "Nursery",              icon: <FaBed /> },
  { id: "0305", parentId: "03", level: "category", name: "Baby Bath & Skincare", icon: <FaPumpSoap /> },
  { id: "0306", parentId: "03", level: "category", name: "Diapering",            icon: <FaBaby /> },
  { id: "0307", parentId: "03", level: "category", name: "Baby Safety",          icon: <FaTriangleExclamation /> },
  { id: "0308", parentId: "03", level: "category", name: "Baby Toys",            icon: <FaPuzzlePiece /> },
  { id: "0309", parentId: "03", level: "category", name: "Maternity",            icon: <FaHeart /> },
];

/* ── 04 Beauty ────────────────────────────────────────────── */
export const DEPARTMENTBEAUTY: CategoryItem[] = [
  { id: "0401", parentId: "04", level: "category", name: "Skincare",                   icon: <FaSpa /> },
  { id: "0402", parentId: "04", level: "category", name: "Makeup",                     icon: <FaPalette /> },
  { id: "0403", parentId: "04", level: "category", name: "Haircare",                   icon: <FaScissors /> },
  { id: "0404", parentId: "04", level: "category", name: "Fragrance",                  icon: <FaWineBottle /> },
  { id: "0405", parentId: "04", level: "category", name: "Bath & Body",                icon: <FaPumpSoap /> },
  { id: "0406", parentId: "04", level: "category", name: "Nail Care",                  icon: <FaWandMagicSparkles /> },
  { id: "0407", parentId: "04", level: "category", name: "Men's Grooming",             icon: <FaScissors /> },
  { id: "0408", parentId: "04", level: "category", name: "Beauty Tools & Accessories", icon: <FaGem /> },
  { id: "0409", parentId: "04", level: "category", name: "Beauty Appliances",          icon: <FaPlug /> },
];

/* ── 05 Books ─────────────────────────────────────────────── */
export const DEPARTMENTBOOKS: CategoryItem[] = [
  { id: "0501", parentId: "05", level: "category", name: "Fiction",                 icon: <FaBook /> },
  { id: "0502", parentId: "05", level: "category", name: "Non-Fiction",             icon: <FaBook /> },
  { id: "0503", parentId: "05", level: "category", name: "Children's Books",        icon: <FaChild /> },
  { id: "0504", parentId: "05", level: "category", name: "Educational & Textbooks", icon: <FaPen /> },
  { id: "0505", parentId: "05", level: "category", name: "Comics & Graphic Novels", icon: <FaMasksTheater /> },
  { id: "0506", parentId: "05", level: "category", name: "Cookbooks",               icon: <FaMugSaucer /> },
  { id: "0507", parentId: "05", level: "category", name: "Religious & Spiritual",   icon: <FaCross /> },
  { id: "0508", parentId: "05", level: "category", name: "Magazines",               icon: <FaFolder /> },
  { id: "0509", parentId: "05", level: "category", name: "eBooks & Audiobooks",     icon: <FaHeadphones /> },
];

/* ── 06 Electronics ───────────────────────────────────────── */
export const DEPARTMENTELECTRONICS: CategoryItem[] = [
  { id: "0601", parentId: "06", level: "category", name: "TV & Home Theater",       icon: <FaTv /> },
  { id: "0602", parentId: "06", level: "category", name: "IT & Computers",          icon: <FaLaptopCode /> },
  { id: "0603", parentId: "06", level: "category", name: "Telephone & Mobile",      icon: <FaMobileScreenButton /> },
  { id: "0604", parentId: "06", level: "category", name: "Audio",                   icon: <FaHeadphones /> },
  { id: "0605", parentId: "06", level: "category", name: "Home Appliances",         icon: <FaPlug /> },
  { id: "0606", parentId: "06", level: "category", name: "Kitchen Appliances",      icon: <FaMugSaucer /> },
  { id: "0607", parentId: "06", level: "category", name: "Beauty Appliances",       icon: <FaSpa /> },
  { id: "0608", parentId: "06", level: "category", name: "Entertainment",           icon: <FaGamepad /> },
  { id: "0609", parentId: "06", level: "category", name: "Gym Appliances",          icon: <FaDumbbell /> },
  { id: "0610", parentId: "06", level: "category", name: "Health Appliances",       icon: <FaCross /> },
  { id: "0611", parentId: "06", level: "category", name: "Film & Photography",      icon: <FaCamera /> },
  { id: "0612", parentId: "06", level: "category", name: "Mobility Appliances",     icon: <FaPersonRunning /> },
  { id: "0613", parentId: "06", level: "category", name: "Housekeeping Appliances", icon: <FaBoxesStacked /> },
];

/* ── 07 Apparallel ────────────────────────────────────────── */
export const DEPARTMENTAPPAREL: CategoryItem[] = [
  { id: "0701", parentId: "07", level: "category", name: "Clothing",    icon: <FaShirt /> },
  { id: "0702", parentId: "07", level: "category", name: "Shoes",       icon: <FaShoePrints /> },
  { id: "0703", parentId: "07", level: "category", name: "Accessories", icon: <FaGem /> },
  { id: "0704", parentId: "07", level: "category", name: "Jewelry",     icon: <FaRing /> },
  { id: "0705", parentId: "07", level: "category", name: "Bags",        icon: <FaBagShopping /> },
];

/* ── 08 Food ──────────────────────────────────────────────── */
export const DEPARTMENTFOOD: CategoryItem[] = [
  { id: "0801", parentId: "08", level: "category", name: "Fast Food",    icon: <FaTruckFast /> },
  { id: "0802", parentId: "08", level: "category", name: "Grocery",      icon: <FaCartShopping /> },
  { id: "0803", parentId: "08", level: "category", name: "Farm Produce", icon: <FaTractor /> },
];

/* ── 09 Furniture ─────────────────────────────────────────── */
export const DEPARTMENTFURNITURE: CategoryItem[] = [
  { id: "0901", parentId: "09", level: "category", name: "Living Room",       icon: <FaCouch /> },
  { id: "0902", parentId: "09", level: "category", name: "Bedroom",           icon: <FaBed /> },
  { id: "0903", parentId: "09", level: "category", name: "Dining Room",       icon: <FaChair /> },
  { id: "0904", parentId: "09", level: "category", name: "Office Furniture",  icon: <FaBriefcase /> },
  { id: "0905", parentId: "09", level: "category", name: "Outdoor Furniture", icon: <FaUmbrellaBeach /> },
  { id: "0906", parentId: "09", level: "category", name: "Storage",           icon: <FaBoxesStacked /> },
  { id: "0907", parentId: "09", level: "category", name: "Kids Furniture",    icon: <FaChild /> },
];

/* ── 10 Gaming ────────────────────────────────────────────── */
export const DEPARTMENTGAMING: CategoryItem[] = [
  { id: "1001", parentId: "10", level: "category", name: "Video Games",        icon: <FaGamepad /> },
  { id: "1002", parentId: "10", level: "category", name: "Gaming Consoles",    icon: <FaTv /> },
  { id: "1003", parentId: "10", level: "category", name: "Gaming Accessories", icon: <FaHeadphones /> },
  { id: "1004", parentId: "10", level: "category", name: "PC Gaming",          icon: <FaLaptopCode /> },
  { id: "1005", parentId: "10", level: "category", name: "Board Games",        icon: <FaChess /> },
  { id: "1006", parentId: "10", level: "category", name: "Card Games",         icon: <FaSquarePlus /> },
  { id: "1007", parentId: "10", level: "category", name: "VR Gaming",          icon: <FaVideo /> },
];

/* ── 11 Gifts ─────────────────────────────────────────────── */
export const DEPARTMENTGIFTS: CategoryItem[] = [
  { id: "1101", parentId: "11", level: "category", name: "Gift Cards",              icon: <FaGift /> },
  { id: "1102", parentId: "11", level: "category", name: "Personalized Gifts",      icon: <FaWandMagicSparkles /> },
  { id: "1103", parentId: "11", level: "category", name: "Gift Sets",               icon: <FaBoxesStacked /> },
  { id: "1104", parentId: "11", level: "category", name: "Occasion Gifts",          icon: <FaStar /> },
  { id: "1105", parentId: "11", level: "category", name: "Gift Wrap & Accessories", icon: <FaTag /> },
];

/* ── 12 Kitchen ───────────────────────────────────────────── */
export const DEPARTMENTKITCHEN: CategoryItem[] = [
  { id: "1201", parentId: "12", level: "category", name: "Cookware",                 icon: <FaChair /> },
  { id: "1202", parentId: "12", level: "category", name: "Bakeware",                 icon: <FaCookieBite /> },
  { id: "1203", parentId: "12", level: "category", name: "Kitchen Utensils",         icon: <FaScrewdriver /> },
  { id: "1204", parentId: "12", level: "category", name: "Small Kitchen Appliances", icon: <FaPlug /> },
  { id: "1205", parentId: "12", level: "category", name: "Tableware",                icon: <FaMugSaucer /> },
  { id: "1206", parentId: "12", level: "category", name: "Storage & Organization",   icon: <FaBoxesStacked /> },
  { id: "1207", parentId: "12", level: "category", name: "Cutlery",                  icon: <FaScissors /> },
];

/* ── 13 Luggage ───────────────────────────────────────────── */
export const DEPARTMENTLUGGAGE: CategoryItem[] = [
  { id: "1301", parentId: "13", level: "category", name: "Suitcases",          icon: <FaSuitcaseRolling /> },
  { id: "1302", parentId: "13", level: "category", name: "Travel Bags",        icon: <FaSuitcase /> },
  { id: "1303", parentId: "13", level: "category", name: "Backpacks",          icon: <FaBagShopping /> },
  { id: "1304", parentId: "13", level: "category", name: "Travel Accessories", icon: <FaTag /> },
  { id: "1305", parentId: "13", level: "category", name: "Garment Bags",       icon: <FaShirt /> },
];

/* ── 14 Pets ──────────────────────────────────────────────── */
export const DEPARTMENTPETS: CategoryItem[] = [
  { id: "1401", parentId: "14", level: "category", name: "Dog Supplies",          icon: <FaDog /> },
  { id: "1402", parentId: "14", level: "category", name: "Cat Supplies",          icon: <FaCat /> },
  { id: "1403", parentId: "14", level: "category", name: "Fish & Aquatics",       icon: <FaFish /> },
  { id: "1404", parentId: "14", level: "category", name: "Bird Supplies",         icon: <FaDove /> },
  { id: "1405", parentId: "14", level: "category", name: "Small Animal Supplies", icon: <FaPaw /> },
  { id: "1406", parentId: "14", level: "category", name: "Pet Food",              icon: <FaBone /> },
  { id: "1407", parentId: "14", level: "category", name: "Pet Health & Wellness", icon: <FaCross /> },
];

/* ── 15 Sports ────────────────────────────────────────────── */
export const DEPARTMENTSPORTS: CategoryItem[] = [
  { id: "1501", parentId: "15", level: "category", name: "Team Sports",        icon: <FaFutbol /> },
  { id: "1502", parentId: "15", level: "category", name: "Fitness & Exercise", icon: <FaDumbbell /> },
  { id: "1503", parentId: "15", level: "category", name: "Outdoor Recreation", icon: <FaCampground /> },
  { id: "1504", parentId: "15", level: "category", name: "Cycling",            icon: <FaPersonBiking /> },
  { id: "1505", parentId: "15", level: "category", name: "Water Sports",       icon: <FaPersonSwimming /> },
  { id: "1506", parentId: "15", level: "category", name: "Winter Sports",      icon: <FaSnowflake /> },
  { id: "1507", parentId: "15", level: "category", name: "Sports Apparel",     icon: <FaShirt /> },
];

/* ── 16 Tools ─────────────────────────────────────────────── */
export const DEPARTMENTTOOLS: CategoryItem[] = [
  { id: "1601", parentId: "16", level: "category", name: "Hand Tools",       icon: <FaHammer /> },
  { id: "1602", parentId: "16", level: "category", name: "Power Tools",      icon: <FaScrewdriverWrench /> },
  { id: "1603", parentId: "16", level: "category", name: "Tool Storage",     icon: <FaBoxesStacked /> },
  { id: "1604", parentId: "16", level: "category", name: "Measuring Tools",  icon: <FaWrench /> },
  { id: "1605", parentId: "16", level: "category", name: "Safety Equipment", icon: <FaHelmetSafety /> },
  { id: "1606", parentId: "16", level: "category", name: "Plumbing Tools",   icon: <FaWrench /> },
  { id: "1607", parentId: "16", level: "category", name: "Electrical Tools", icon: <FaBolt /> },
];

/* ── 17 Toys ──────────────────────────────────────────────── */
export const DEPARTMENTTOYS: CategoryItem[] = [
  { id: "1701", parentId: "17", level: "category", name: "Action Figures",      icon: <FaChild /> },
  { id: "1702", parentId: "17", level: "category", name: "Building Toys",       icon: <FaPuzzlePiece /> },
  { id: "1703", parentId: "17", level: "category", name: "Educational Toys",    icon: <FaBook /> },
  { id: "1704", parentId: "17", level: "category", name: "Dolls",               icon: <FaChild /> },
  { id: "1705", parentId: "17", level: "category", name: "Outdoor Toys",        icon: <FaUmbrellaBeach /> },
  { id: "1706", parentId: "17", level: "category", name: "Puzzles & Games",     icon: <FaPuzzlePiece /> },
  { id: "1707", parentId: "17", level: "category", name: "Remote Control Toys", icon: <FaGamepad /> },
];




/* ═══════════════════════════════════════════════════════════
   ART & CRAFTS (dept 00)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   PAINTING   (parentId: 0001)
   ─────────────────────────────────────────────────────────── */
export const CategoryPainting: CategoryItem[] = [];
export const SubCategoryPainting: CategoryItem[] = [];
export const ProductTypePainting: CategoryItem[] = [];
export const ProductPainting: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   DRAWING   (parentId: 0002)
   ─────────────────────────────────────────────────────────── */
export const CategoryDrawing: CategoryItem[] = [];
export const SubCategoryDrawing: CategoryItem[] = [];
export const ProductTypeDrawing: CategoryItem[] = [];
export const ProductDrawing: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   SCULPTING & POTTERY   (parentId: 0003)
   ─────────────────────────────────────────────────────────── */
export const CategorySculptingPottery: CategoryItem[] = [];
export const SubCategorySculptingPottery: CategoryItem[] = [];
export const ProductTypeSculptingPottery: CategoryItem[] = [];
export const ProductSculptingPottery: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CRAFT SUPPLIES   (parentId: 0004)
   ─────────────────────────────────────────────────────────── */
export const CategoryCraftSupplies: CategoryItem[] = [];
export const SubCategoryCraftSupplies: CategoryItem[] = [];
export const ProductTypeCraftSupplies: CategoryItem[] = [];
export const ProductCraftSupplies: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   SCRAPBOOKING   (parentId: 0005)
   ─────────────────────────────────────────────────────────── */
export const CategoryScrapbooking: CategoryItem[] = [];
export const SubCategoryScrapbooking: CategoryItem[] = [];
export const ProductTypeScrapbooking: CategoryItem[] = [];
export const ProductScrapbooking: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   SEWING & TEXTILE CRAFTS   (parentId: 0006)
   ─────────────────────────────────────────────────────────── */
export const CategorySewingTextileCrafts: CategoryItem[] = [];
export const SubCategorySewingTextileCrafts: CategoryItem[] = [];
export const ProductTypeSewingTextileCrafts: CategoryItem[] = [];
export const ProductSewingTextileCrafts: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   JEWELRY MAKING   (parentId: 0007)
   ─────────────────────────────────────────────────────────── */
export const CategoryJewelryMaking: CategoryItem[] = [];
export const SubCategoryJewelryMaking: CategoryItem[] = [];
export const ProductTypeJewelryMaking: CategoryItem[] = [];
export const ProductJewelryMaking: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   PARTY & PAPER CRAFTS   (parentId: 0008)
   ─────────────────────────────────────────────────────────── */
export const CategoryPartyPaperCrafts: CategoryItem[] = [];
export const SubCategoryPartyPaperCrafts: CategoryItem[] = [];
export const ProductTypePartyPaperCrafts: CategoryItem[] = [];
export const ProductPartyPaperCrafts: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   AUTOMOTIVE (dept 01)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   CAR PARTS   (parentId: 0101)
   ─────────────────────────────────────────────────────────── */
export const CategoryCarParts: CategoryItem[] = [];
export const SubCategoryCarParts: CategoryItem[] = [];
export const ProductTypeCarParts: CategoryItem[] = [];
export const ProductCarParts: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CAR ACCESSORIES   (parentId: 0102)
   ─────────────────────────────────────────────────────────── */
export const CategoryCarAccessories: CategoryItem[] = [];
export const SubCategoryCarAccessories: CategoryItem[] = [];
export const ProductTypeCarAccessories: CategoryItem[] = [];
export const ProductCarAccessories: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CAR CARE & DETAILING   (parentId: 0103)
   ─────────────────────────────────────────────────────────── */
export const CategoryCarCareDetailing: CategoryItem[] = [];
export const SubCategoryCarCareDetailing: CategoryItem[] = [];
export const ProductTypeCarCareDetailing: CategoryItem[] = [];
export const ProductCarCareDetailing: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   TIRES & WHEELS   (parentId: 0104)
   ─────────────────────────────────────────────────────────── */
export const CategoryTiresWheels: CategoryItem[] = [];
export const SubCategoryTiresWheels: CategoryItem[] = [];
export const ProductTypeTiresWheels: CategoryItem[] = [];
export const ProductTiresWheels: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   TOOLS & EQUIPMENT   (parentId: 0105)
   ─────────────────────────────────────────────────────────── */
export const CategoryToolsEquipment: CategoryItem[] = [];
export const SubCategoryToolsEquipment: CategoryItem[] = [];
export const ProductTypeToolsEquipment: CategoryItem[] = [];
export const ProductToolsEquipment: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MOTORCYCLE PARTS   (parentId: 0106)
   ─────────────────────────────────────────────────────────── */
export const CategoryMotorcycleParts: CategoryItem[] = [];
export const SubCategoryMotorcycleParts: CategoryItem[] = [];
export const ProductTypeMotorcycleParts: CategoryItem[] = [];
export const ProductMotorcycleParts: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CAR ELECTRONICS   (parentId: 0107)
   ─────────────────────────────────────────────────────────── */
export const CategoryCarElectronics: CategoryItem[] = [];
export const SubCategoryCarElectronics: CategoryItem[] = [];
export const ProductTypeCarElectronics: CategoryItem[] = [];
export const ProductCarElectronics: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   INTERIOR ACCESSORIES   (parentId: 0108)
   ─────────────────────────────────────────────────────────── */
export const CategoryInteriorAccessories: CategoryItem[] = [];
export const SubCategoryInteriorAccessories: CategoryItem[] = [];
export const ProductTypeInteriorAccessories: CategoryItem[] = [];
export const ProductInteriorAccessories: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   EXTERIOR ACCESSORIES   (parentId: 0109)
   ─────────────────────────────────────────────────────────── */
export const CategoryExteriorAccessories: CategoryItem[] = [];
export const SubCategoryExteriorAccessories: CategoryItem[] = [];
export const ProductTypeExteriorAccessories: CategoryItem[] = [];
export const ProductExteriorAccessories: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   OILS & FLUIDS   (parentId: 0110)
   ─────────────────────────────────────────────────────────── */
export const CategoryOilsFluids: CategoryItem[] = [];
export const SubCategoryOilsFluids: CategoryItem[] = [];
export const ProductTypeOilsFluids: CategoryItem[] = [];
export const ProductOilsFluids: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   AVIATION (dept 02)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   PILOT SUPPLIES   (parentId: 0201)
   ─────────────────────────────────────────────────────────── */
export const CategoryPilotSupplies: CategoryItem[] = [];
export const SubCategoryPilotSupplies: CategoryItem[] = [];
export const ProductTypePilotSupplies: CategoryItem[] = [];
export const ProductPilotSupplies: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   AIRCRAFT PARTS   (parentId: 0202)
   ─────────────────────────────────────────────────────────── */
export const CategoryAircraftParts: CategoryItem[] = [];
export const SubCategoryAircraftParts: CategoryItem[] = [];
export const ProductTypeAircraftParts: CategoryItem[] = [];
export const ProductAircraftParts: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   AVIATION ELECTRONICS   (parentId: 0203)
   ─────────────────────────────────────────────────────────── */
export const CategoryAviationElectronics: CategoryItem[] = [];
export const SubCategoryAviationElectronics: CategoryItem[] = [];
export const ProductTypeAviationElectronics: CategoryItem[] = [];
export const ProductAviationElectronics: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MODEL AIRCRAFT   (parentId: 0204)
   ─────────────────────────────────────────────────────────── */
export const CategoryModelAircraft: CategoryItem[] = [];
export const SubCategoryModelAircraft: CategoryItem[] = [];
export const ProductTypeModelAircraft: CategoryItem[] = [];
export const ProductModelAircraft: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   AVIATION SAFETY GEAR   (parentId: 0205)
   ─────────────────────────────────────────────────────────── */
export const CategoryAviationSafetyGear: CategoryItem[] = [];
export const SubCategoryAviationSafetyGear: CategoryItem[] = [];
export const ProductTypeAviationSafetyGear: CategoryItem[] = [];
export const ProductAviationSafetyGear: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   DRONES & UAVS   (parentId: 0206)
   ─────────────────────────────────────────────────────────── */
export const CategoryDronesUAVs: CategoryItem[] = [];
export const SubCategoryDronesUAVs: CategoryItem[] = [];
export const ProductTypeDronesUAVs: CategoryItem[] = [];
export const ProductDronesUAVs: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   AVIATION BOOKS & CHARTS   (parentId: 0207)
   ─────────────────────────────────────────────────────────── */
export const CategoryAviationBooksCharts: CategoryItem[] = [];
export const SubCategoryAviationBooksCharts: CategoryItem[] = [];
export const ProductTypeAviationBooksCharts: CategoryItem[] = [];
export const ProductAviationBooksCharts: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   BABY (dept 03)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   BABY CLOTHING   (parentId: 0301)
   ─────────────────────────────────────────────────────────── */
export const CategoryBabyClothing: CategoryItem[] = [];
export const SubCategoryBabyClothing: CategoryItem[] = [];
export const ProductTypeBabyClothing: CategoryItem[] = [];
export const ProductBabyClothing: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BABY FEEDING   (parentId: 0302)
   ─────────────────────────────────────────────────────────── */
export const CategoryBabyFeeding: CategoryItem[] = [];
export const SubCategoryBabyFeeding: CategoryItem[] = [];
export const ProductTypeBabyFeeding: CategoryItem[] = [];
export const ProductBabyFeeding: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BABY GEAR   (parentId: 0303)
   ─────────────────────────────────────────────────────────── */
export const CategoryBabyGear: CategoryItem[] = [];
export const SubCategoryBabyGear: CategoryItem[] = [];
export const ProductTypeBabyGear: CategoryItem[] = [];
export const ProductBabyGear: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   NURSERY   (parentId: 0304)
   ─────────────────────────────────────────────────────────── */
export const CategoryNursery: CategoryItem[] = [];
export const SubCategoryNursery: CategoryItem[] = [];
export const ProductTypeNursery: CategoryItem[] = [];
export const ProductNursery: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   DIAPERING   (parentId: 0306)
   ─────────────────────────────────────────────────────────── */
export const CategoryDiapering: CategoryItem[] = [];
export const SubCategoryDiapering: CategoryItem[] = [];
export const ProductTypeDiapering: CategoryItem[] = [];
export const ProductDiapering: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BABY SAFETY   (parentId: 0307)
   ─────────────────────────────────────────────────────────── */
export const CategoryBabySafety: CategoryItem[] = [];
export const SubCategoryBabySafety: CategoryItem[] = [];
export const ProductTypeBabySafety: CategoryItem[] = [];
export const ProductBabySafety: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BABY TOYS   (parentId: 0308)
   ─────────────────────────────────────────────────────────── */
export const CategoryBabyToys: CategoryItem[] = [];
export const SubCategoryBabyToys: CategoryItem[] = [];
export const ProductTypeBabyToys: CategoryItem[] = [];
export const ProductBabyToys: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MATERNITY   (parentId: 0309)
   ─────────────────────────────────────────────────────────── */
export const CategoryMaternity: CategoryItem[] = [];
export const SubCategoryMaternity: CategoryItem[] = [];
export const ProductTypeMaternity: CategoryItem[] = [];
export const ProductMaternity: CategoryItem[] = [];

/* NOTE: "Baby Bath & Skincare" (0305) skipped per instructions */


/* ═══════════════════════════════════════════════════════════
   BEAUTY (dept 04)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   SKINCARE   (parentId: 0401)
   ─────────────────────────────────────────────────────────── */
export const CategorySkincare: CategoryItem[] = [];
export const SubCategorySkincare: CategoryItem[] = [];
export const ProductTypeSkincare: CategoryItem[] = [];
export const ProductSkincare: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MAKEUP   (parentId: 0402)
   ─────────────────────────────────────────────────────────── */
export const CategoryMakeup: CategoryItem[] = [];
export const SubCategoryMakeup: CategoryItem[] = [];
export const ProductTypeMakeup: CategoryItem[] = [];
export const ProductMakeup: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   HAIRCARE   (parentId: 0403)
   ─────────────────────────────────────────────────────────── */
export const CategoryHaircare: CategoryItem[] = [];
export const SubCategoryHaircare: CategoryItem[] = [];
export const ProductTypeHaircare: CategoryItem[] = [];
export const ProductHaircare: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   FRAGRANCE   (parentId: 0404)
   ─────────────────────────────────────────────────────────── */
export const CategoryFragrance: CategoryItem[] = [];
export const SubCategoryFragrance: CategoryItem[] = [];
export const ProductTypeFragrance: CategoryItem[] = [];
export const ProductFragrance: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BATH & BODY   (parentId: 0405)
   ─────────────────────────────────────────────────────────── */
export const CategoryBathBody: CategoryItem[] = [];
export const SubCategoryBathBody: CategoryItem[] = [];
export const ProductTypeBathBody: CategoryItem[] = [];
export const ProductBathBody: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   NAIL CARE   (parentId: 0406)
   ─────────────────────────────────────────────────────────── */
export const CategoryNailCare: CategoryItem[] = [];
export const SubCategoryNailCare: CategoryItem[] = [];
export const ProductTypeNailCare: CategoryItem[] = [];
export const ProductNailCare: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MEN'S GROOMING   (parentId: 0407)
   ─────────────────────────────────────────────────────────── */
export const CategoryMensGrooming: CategoryItem[] = [];
export const SubCategoryMensGrooming: CategoryItem[] = [];
export const ProductTypeMensGrooming: CategoryItem[] = [];
export const ProductMensGrooming: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BEAUTY TOOLS & ACCESSORIES   (parentId: 0408)
   ─────────────────────────────────────────────────────────── */
export const CategoryBeautyToolsAccessories: CategoryItem[] = [];
export const SubCategoryBeautyToolsAccessories: CategoryItem[] = [];
export const ProductTypeBeautyToolsAccessories: CategoryItem[] = [];
export const ProductBeautyToolsAccessories: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BEAUTY APPLIANCES   (parentId: 0409)
   ─────────────────────────────────────────────────────────── */
export const CategoryBeautyAppliances: CategoryItem[] = [];
export const SubCategoryBeautyAppliances: CategoryItem[] = [];
export const ProductTypeBeautyAppliances: CategoryItem[] = [];
export const ProductBeautyAppliances: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   BOOKS (dept 05)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   FICTION   (parentId: 0501)
   ─────────────────────────────────────────────────────────── */
export const CategoryFiction: CategoryItem[] = [];
export const SubCategoryFiction: CategoryItem[] = [];
export const ProductTypeFiction: CategoryItem[] = [];
export const ProductFiction: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   NON-FICTION   (parentId: 0502)
   ─────────────────────────────────────────────────────────── */
export const CategoryNonFiction: CategoryItem[] = [];
export const SubCategoryNonFiction: CategoryItem[] = [];
export const ProductTypeNonFiction: CategoryItem[] = [];
export const ProductNonFiction: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CHILDREN'S BOOKS   (parentId: 0503)
   ─────────────────────────────────────────────────────────── */
export const CategoryChildrensBooks: CategoryItem[] = [];
export const SubCategoryChildrensBooks: CategoryItem[] = [];
export const ProductTypeChildrensBooks: CategoryItem[] = [];
export const ProductChildrensBooks: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   EDUCATIONAL & TEXTBOOKS   (parentId: 0504)
   ─────────────────────────────────────────────────────────── */
export const CategoryEducationalTextbooks: CategoryItem[] = [];
export const SubCategoryEducationalTextbooks: CategoryItem[] = [];
export const ProductTypeEducationalTextbooks: CategoryItem[] = [];
export const ProductEducationalTextbooks: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   COMICS & GRAPHIC NOVELS   (parentId: 0505)
   ─────────────────────────────────────────────────────────── */
export const CategoryComicsGraphicNovels: CategoryItem[] = [];
export const SubCategoryComicsGraphicNovels: CategoryItem[] = [];
export const ProductTypeComicsGraphicNovels: CategoryItem[] = [];
export const ProductComicsGraphicNovels: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   COOKBOOKS   (parentId: 0506)
   ─────────────────────────────────────────────────────────── */
export const CategoryCookbooks: CategoryItem[] = [];
export const SubCategoryCookbooks: CategoryItem[] = [];
export const ProductTypeCookbooks: CategoryItem[] = [];
export const ProductCookbooks: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   RELIGIOUS & SPIRITUAL   (parentId: 0507)
   ─────────────────────────────────────────────────────────── */
export const CategoryReligiousSpiritual: CategoryItem[] = [];
export const SubCategoryReligiousSpiritual: CategoryItem[] = [];
export const ProductTypeReligiousSpiritual: CategoryItem[] = [];
export const ProductReligiousSpiritual: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MAGAZINES   (parentId: 0508)
   ─────────────────────────────────────────────────────────── */
export const CategoryMagazines: CategoryItem[] = [];
export const SubCategoryMagazines: CategoryItem[] = [];
export const ProductTypeMagazines: CategoryItem[] = [];
export const ProductMagazines: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   EBOOKS & AUDIOBOOKS   (parentId: 0509)
   ─────────────────────────────────────────────────────────── */
export const CategoryEBooksAudiobooks: CategoryItem[] = [];
export const SubCategoryEBooksAudiobooks: CategoryItem[] = [];
export const ProductTypeEBooksAudiobooks: CategoryItem[] = [];
export const ProductEBooksAudiobooks: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   ELECTRONICS (dept 06)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   TV & HOME THEATER   (parentId: 0601)
   ─────────────────────────────────────────────────────────── */
export const CategoryTVHomeTheater: CategoryItem[] = [];
export const SubCategoryTVHomeTheater: CategoryItem[] = [];
export const ProductTypeTVHomeTheater: CategoryItem[] = [];
export const ProductTVHomeTheater: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   IT & COMPUTERS   (parentId: 0602)
   ─────────────────────────────────────────────────────────── */
export const CategoryITComputers: CategoryItem[] = [];
export const SubCategoryITComputers: CategoryItem[] = [];
export const ProductTypeITComputers: CategoryItem[] = [];
export const ProductITComputers: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   TELEPHONE & MOBILE   (parentId: 0603)
   ─────────────────────────────────────────────────────────── */
export const CategoryTelephoneMobile: CategoryItem[] = [];
export const SubCategoryTelephoneMobile: CategoryItem[] = [];
export const ProductTypeTelephoneMobile: CategoryItem[] = [];
export const ProductTelephoneMobile: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   AUDIO   (parentId: 0604)
   ─────────────────────────────────────────────────────────── */
export const CategoryAudio: CategoryItem[] = [];
export const SubCategoryAudio: CategoryItem[] = [];
export const ProductTypeAudio: CategoryItem[] = [];
export const ProductAudio: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   HOME APPLIANCES   (parentId: 0605)
   ─────────────────────────────────────────────────────────── */
export const CategoryHomeAppliances: CategoryItem[] = [];
export const SubCategoryHomeAppliances: CategoryItem[] = [];
export const ProductTypeHomeAppliances: CategoryItem[] = [];
export const ProductHomeAppliances: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   KITCHEN APPLIANCES   (parentId: 0606)
   ─────────────────────────────────────────────────────────── */
export const CategoryKitchenAppliances: CategoryItem[] = [];
export const SubCategoryKitchenAppliances: CategoryItem[] = [];
export const ProductTypeKitchenAppliances: CategoryItem[] = [];
export const ProductKitchenAppliances: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   ENTERTAINMENT   (parentId: 0608)
   ─────────────────────────────────────────────────────────── */
export const CategoryEntertainment: CategoryItem[] = [];
export const SubCategoryEntertainment: CategoryItem[] = [];
export const ProductTypeEntertainment: CategoryItem[] = [];
export const ProductEntertainment: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   GYM APPLIANCES   (parentId: 0609)
   ─────────────────────────────────────────────────────────── */
export const CategoryGymAppliances: CategoryItem[] = [];
export const SubCategoryGymAppliances: CategoryItem[] = [];
export const ProductTypeGymAppliances: CategoryItem[] = [];
export const ProductGymAppliances: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   HEALTH APPLIANCES   (parentId: 0610)
   ─────────────────────────────────────────────────────────── */
export const CategoryHealthAppliances: CategoryItem[] = [];
export const SubCategoryHealthAppliances: CategoryItem[] = [];
export const ProductTypeHealthAppliances: CategoryItem[] = [];
export const ProductHealthAppliances: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   FILM & PHOTOGRAPHY   (parentId: 0611)
   ─────────────────────────────────────────────────────────── */
export const CategoryFilmPhotography: CategoryItem[] = [];
export const SubCategoryFilmPhotography: CategoryItem[] = [];
export const ProductTypeFilmPhotography: CategoryItem[] = [];
export const ProductFilmPhotography: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MOBILITY APPLIANCES   (parentId: 0612)
   ─────────────────────────────────────────────────────────── */
export const CategoryMobilityAppliances: CategoryItem[] = [];
export const SubCategoryMobilityAppliances: CategoryItem[] = [];
export const ProductTypeMobilityAppliances: CategoryItem[] = [];
export const ProductMobilityAppliances: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   HOUSEKEEPING APPLIANCES   (parentId: 0613)
   ─────────────────────────────────────────────────────────── */
export const CategoryHousekeepingAppliances: CategoryItem[] = [];
export const SubCategoryHousekeepingAppliances: CategoryItem[] = [];
export const ProductTypeHousekeepingAppliances: CategoryItem[] = [];
export const ProductHousekeepingAppliances: CategoryItem[] = [];

/* NOTE: "Beauty Appliances" (0607) skipped here — already exported above for 0409 */

/* ───────────────────────────────────────────────────────────
 APPARALEL==  CLOTHING   (parentId: 0701)
   ─────────────────────────────────────────────────────────── */

export const CategoryClothing: CategoryItem[] = [
  { id: "070101", parentId: "0701", level: "category", name: "School Uniforms", icon: <FaBriefcase /> },
  { id: "070102", parentId: "0701", level: "category", name: "Dresses",         icon: <FaHeart /> },
  { id: "070103", parentId: "0701", level: "category", name: "Tops",            icon: <FaShirt /> },
  { id: "070104", parentId: "0701", level: "category", name: "T-Shirts",        icon: <FaShirt /> },
  { id: "070105", parentId: "0701", level: "category", name: "Vests",           icon: <FaVest /> },
  { id: "070106", parentId: "0701", level: "category", name: "Shirts",          icon: <FaShirt /> },
  { id: "070107", parentId: "0701", level: "category", name: "Polo Shirts",     icon: <FaShirt /> },
  { id: "070108", parentId: "0701", level: "category", name: "Knitwear",        icon: <FaLayerGroup /> },
  { id: "070109", parentId: "0701", level: "category", name: "Sweaters",        icon: <FaLayerGroup /> },
  { id: "070110", parentId: "0701", level: "category", name: "Hoodies",         icon: <FaTag /> },
  { id: "070111", parentId: "0701", level: "category", name: "Sweatshirts",     icon: <FaTag /> },
  { id: "070112", parentId: "0701", level: "category", name: "Jackets",         icon: <FaWind /> },
  { id: "070113", parentId: "0701", level: "category", name: "Coats",           icon: <FaSnowflake /> },
  { id: "070114", parentId: "0701", level: "category", name: "Skiwear",         icon: <FaSnowflake /> },
  { id: "070115", parentId: "0701", level: "category", name: "Trousers",        icon: <FaLayerGroup /> },
  { id: "070116", parentId: "0701", level: "category", name: "Denim",           icon: <FaLayerGroup /> },
  { id: "070117", parentId: "0701", level: "category", name: "Skirts",          icon: <FaCircleQuestion /> },
  { id: "070118", parentId: "0701", level: "category", name: "Shorts",          icon: <FaScissors /> },
  { id: "070119", parentId: "0701", level: "category", name: "Tracksuits",      icon: <FaBolt /> },
  { id: "070120", parentId: "0701", level: "category", name: "Activewear",      icon: <FaBolt /> },
  { id: "070121", parentId: "0701", level: "category", name: "Suits",           icon: <FaBriefcase /> },
  { id: "070122", parentId: "0701", level: "category", name: "Blazers",         icon: <FaBriefcase /> },
  { id: "070123", parentId: "0701", level: "category", name: "Formal Wear",     icon: <FaStar /> },
  { id: "070124", parentId: "0701", level: "category", name: "Jumpsuits",       icon: <FaTag /> },
  { id: "070125", parentId: "0701", level: "category", name: "Playsuits",       icon: <FaTag /> },
  { id: "070126", parentId: "0701", level: "category", name: "Lingerie",        icon: <FaHeart /> },
  { id: "070127", parentId: "0701", level: "category", name: "Underwear",       icon: <FaHeart /> },
  { id: "070128", parentId: "0701", level: "category", name: "Loungewear",      icon: <FaHeart /> },
  { id: "070129", parentId: "0701", level: "category", name: "Pyjamas",         icon: <FaStar /> },
  { id: "070130", parentId: "0701", level: "category", name: "Nightwear",       icon: <FaStar /> },
  { id: "070131", parentId: "0701", level: "category", name: "Swimwear",        icon: <FaUmbrellaBeach /> },
  { id: "070132", parentId: "0701", level: "category", name: "Beachwear",       icon: <FaUmbrellaBeach /> },
  { id: "070133", parentId: "0701", level: "category", name: "Bridal",          icon: <FaCrown /> },
];



export const SubCategoryClothing: CategoryItem[] = [
  // School Uniforms (070101)
  { id: "07010101", parentId: "070101", level: "subCategory", name: "Uniform Shirts",   icon: <FaShirt /> },
  { id: "07010102", parentId: "070101", level: "subCategory", name: "Uniform Trousers", icon: <FaLayerGroup /> },
  { id: "07010103", parentId: "070101", level: "subCategory", name: "Uniform Skirts",   icon: <FaCircleQuestion /> },

  // Dresses (070102)
  { id: "07010201", parentId: "070102", level: "subCategory", name: "Maxi Dresses",  icon: <FaHeart /> },
  { id: "07010202", parentId: "070102", level: "subCategory", name: "Midi Dresses",  icon: <FaHeart /> },
  { id: "07010203", parentId: "070102", level: "subCategory", name: "Mini Dresses",  icon: <FaHeart /> },
  { id: "07010204", parentId: "070102", level: "subCategory", name: "Shift Dresses", icon: <FaHeart /> },

  // Tops (070103)
  { id: "07010301", parentId: "070103", level: "subCategory", name: "Blouses",    icon: <FaShirt /> },
  { id: "07010302", parentId: "070103", level: "subCategory", name: "Camisoles",  icon: <FaShirt /> },
  { id: "07010303", parentId: "070103", level: "subCategory", name: "Tank Tops",  icon: <FaShirt /> },

  // T-Shirts (070104)
  { id: "07010401", parentId: "070104", level: "subCategory", name: "Crew Neck",    icon: <FaShirt /> },
  { id: "07010402", parentId: "070104", level: "subCategory", name: "V-Neck",       icon: <FaShirt /> },
  { id: "07010403", parentId: "070104", level: "subCategory", name: "Graphic Tees", icon: <FaShirt /> },
  { id: "07010404", parentId: "070104", level: "subCategory", name: "Long Sleeve",  icon: <FaShirt /> },

  // Vests (070105)
  { id: "07010501", parentId: "070105", level: "subCategory", name: "Padded Vests", icon: <FaVest /> },
  { id: "07010502", parentId: "070105", level: "subCategory", name: "Gilets",       icon: <FaVest /> },

  // Shirts (070106)
  { id: "07010601", parentId: "070106", level: "subCategory", name: "Formal Shirts",  icon: <FaShirt /> },
  { id: "07010602", parentId: "070106", level: "subCategory", name: "Casual Shirts",  icon: <FaShirt /> },
  { id: "07010603", parentId: "070106", level: "subCategory", name: "Flannel Shirts", icon: <FaShirt /> },

  // Polo Shirts (070107)
  { id: "07010701", parentId: "070107", level: "subCategory", name: "Short Sleeve Polos", icon: <FaShirt /> },
  { id: "07010702", parentId: "070107", level: "subCategory", name: "Long Sleeve Polos",  icon: <FaShirt /> },

  // Knitwear (070108)
  { id: "07010801", parentId: "070108", level: "subCategory", name: "Cardigans",   icon: <FaLayerGroup /> },
  { id: "07010802", parentId: "070108", level: "subCategory", name: "Turtlenecks", icon: <FaLayerGroup /> },

  // Sweaters (070109)
  { id: "07010901", parentId: "070109", level: "subCategory", name: "Pullovers",         icon: <FaLayerGroup /> },
  { id: "07010902", parentId: "070109", level: "subCategory", name: "Crewneck Sweaters", icon: <FaLayerGroup /> },

  // Hoodies (070110)
  { id: "07011001", parentId: "070110", level: "subCategory", name: "Pullover Hoodies", icon: <FaTag /> },
  { id: "07011002", parentId: "070110", level: "subCategory", name: "Zip-Up Hoodies",   icon: <FaTag /> },

  // Sweatshirts (070111)
  { id: "07011101", parentId: "070111", level: "subCategory", name: "Crewneck Sweatshirts", icon: <FaTag /> },
  { id: "07011102", parentId: "070111", level: "subCategory", name: "Fleece Sweatshirts",   icon: <FaTag /> },

  // Jackets (070112)
  { id: "07011201", parentId: "070112", level: "subCategory", name: "Denim Jackets",  icon: <FaWind /> },
  { id: "07011202", parentId: "070112", level: "subCategory", name: "Bomber Jackets", icon: <FaWind /> },
  { id: "07011203", parentId: "070112", level: "subCategory", name: "Windbreakers",   icon: <FaWind /> },

  // Coats (070113)
  { id: "07011301", parentId: "070113", level: "subCategory", name: "Trench Coats", icon: <FaSnowflake /> },
  { id: "07011302", parentId: "070113", level: "subCategory", name: "Puffer Coats", icon: <FaSnowflake /> },
  { id: "07011303", parentId: "070113", level: "subCategory", name: "Wool Coats",   icon: <FaSnowflake /> },

  // Skiwear (070114)
  { id: "07011401", parentId: "070114", level: "subCategory", name: "Ski Jackets", icon: <FaSnowflake /> },
  { id: "07011402", parentId: "070114", level: "subCategory", name: "Ski Pants",   icon: <FaSnowflake /> },

  // Trousers (070115)
  { id: "07011501", parentId: "070115", level: "subCategory", name: "Chinos",      icon: <FaLayerGroup /> },
  { id: "07011502", parentId: "070115", level: "subCategory", name: "Dress Pants", icon: <FaLayerGroup /> },
  { id: "07011503", parentId: "070115", level: "subCategory", name: "Cargo Pants", icon: <FaLayerGroup /> },

  // Denim (070116)
  { id: "07011601", parentId: "070116", level: "subCategory", name: "Skinny Jeans",   icon: <FaLayerGroup /> },
  { id: "07011602", parentId: "070116", level: "subCategory", name: "Straight Jeans", icon: <FaLayerGroup /> },
  { id: "07011603", parentId: "070116", level: "subCategory", name: "Wide Leg Jeans", icon: <FaLayerGroup /> },

  // Skirts (070117)
  { id: "07011701", parentId: "070117", level: "subCategory", name: "Mini Skirts",    icon: <FaCircleQuestion /> },
  { id: "07011702", parentId: "070117", level: "subCategory", name: "Midi Skirts",    icon: <FaCircleQuestion /> },
  { id: "07011703", parentId: "070117", level: "subCategory", name: "Pleated Skirts", icon: <FaCircleQuestion /> },

  // Shorts (070118)
  { id: "07011801", parentId: "070118", level: "subCategory", name: "Denim Shorts",    icon: <FaScissors /> },
  { id: "07011802", parentId: "070118", level: "subCategory", name: "Chino Shorts",    icon: <FaScissors /> },
  { id: "07011803", parentId: "070118", level: "subCategory", name: "Athletic Shorts", icon: <FaScissors /> },

  // Tracksuits (070119)
  { id: "07011901", parentId: "070119", level: "subCategory", name: "Full Zip Tracksuits", icon: <FaBolt /> },
  { id: "07011902", parentId: "070119", level: "subCategory", name: "Jogger Sets",         icon: <FaBolt /> },

  // Activewear (070120)
  { id: "07012001", parentId: "070120", level: "subCategory", name: "Leggings",        icon: <FaBolt /> },
  { id: "07012002", parentId: "070120", level: "subCategory", name: "Sports Bras",      icon: <FaBolt /> },
  { id: "07012003", parentId: "070120", level: "subCategory", name: "Performance Tees", icon: <FaBolt /> },

  // Suits (070121)
  { id: "07012101", parentId: "070121", level: "subCategory", name: "Two-Piece Suits",   icon: <FaBriefcase /> },
  { id: "07012102", parentId: "070121", level: "subCategory", name: "Three-Piece Suits", icon: <FaBriefcase /> },

  // Blazers (070122)
  { id: "07012201", parentId: "070122", level: "subCategory", name: "Single-Breasted Blazers", icon: <FaBriefcase /> },
  { id: "07012202", parentId: "070122", level: "subCategory", name: "Double-Breasted Blazers", icon: <FaBriefcase /> },

  // Formal Wear (070123)
  { id: "07012301", parentId: "070123", level: "subCategory", name: "Tuxedos", icon: <FaStar /> },
  { id: "07012302", parentId: "070123", level: "subCategory", name: "Gowns",   icon: <FaStar /> },

  // Jumpsuits (070124)
  { id: "07012401", parentId: "070124", level: "subCategory", name: "Wide Leg Jumpsuits", icon: <FaTag /> },
  { id: "07012402", parentId: "070124", level: "subCategory", name: "Fitted Jumpsuits",   icon: <FaTag /> },

  // Playsuits (070125)
  { id: "07012501", parentId: "070125", level: "subCategory", name: "Casual Playsuits", icon: <FaTag /> },
  { id: "07012502", parentId: "070125", level: "subCategory", name: "Party Playsuits",  icon: <FaTag /> },

  // Lingerie (070126)
  { id: "07012601", parentId: "070126", level: "subCategory", name: "Bras",      icon: <FaHeart /> },
  { id: "07012602", parentId: "070126", level: "subCategory", name: "Bodysuits", icon: <FaHeart /> },

  // Underwear (070127)
  { id: "07012701", parentId: "070127", level: "subCategory", name: "Briefs", icon: <FaHeart /> },
  { id: "07012702", parentId: "070127", level: "subCategory", name: "Boxers", icon: <FaHeart /> },

  // Loungewear (070128)
  { id: "07012801", parentId: "070128", level: "subCategory", name: "Lounge Sets", icon: <FaHeart /> },
  { id: "07012802", parentId: "070128", level: "subCategory", name: "Robes",       icon: <FaHeart /> },

  // Pyjamas (070129)
  { id: "07012901", parentId: "070129", level: "subCategory", name: "Pyjama Sets", icon: <FaStar /> },
  { id: "07012902", parentId: "070129", level: "subCategory", name: "Nightgowns",  icon: <FaStar /> },

  // Nightwear (070130)
  { id: "07013001", parentId: "070130", level: "subCategory", name: "Sleep Shirts", icon: <FaStar /> },
  { id: "07013002", parentId: "070130", level: "subCategory", name: "Sleep Sets",   icon: <FaStar /> },

  // Swimwear (070131)
  { id: "07013101", parentId: "070131", level: "subCategory", name: "Bikinis",            icon: <FaUmbrellaBeach /> },
  { id: "07013102", parentId: "070131", level: "subCategory", name: "One-Piece Swimsuits", icon: <FaUmbrellaBeach /> },
  { id: "07013103", parentId: "070131", level: "subCategory", name: "Board Shorts",        icon: <FaUmbrellaBeach /> },

  // Beachwear (070132)
  { id: "07013201", parentId: "070132", level: "subCategory", name: "Cover-Ups", icon: <FaUmbrellaBeach /> },
  { id: "07013202", parentId: "070132", level: "subCategory", name: "Sarongs",   icon: <FaUmbrellaBeach /> },

  // Bridal (070133)
  { id: "07013301", parentId: "070133", level: "subCategory", name: "Wedding Dresses",    icon: <FaCrown /> },
  { id: "07013302", parentId: "070133", level: "subCategory", name: "Bridesmaid Dresses", icon: <FaCrown /> },
];

/**
 * PRODUCT TYPE - Specific product names under each subcategory
 * Example: Under "Crew Neck" (07010401), products are "Classic Crew Neck Tee", "Premium Crew Neck Tee"
 */
export const ProductTypeClothing: CategoryItem[] = [
  // Dresses - Maxi Dresses (07010201)
  { id: "PT-07010201-01", parentId: "07010201", level: "productType", name: "Summer Maxi Dress", icon: <FaHeart /> },
  { id: "PT-07010201-02", parentId: "07010201", level: "productType", name: "Evening Maxi Gown", icon: <FaHeart /> },
  { id: "PT-07010201-03", parentId: "07010201", level: "productType", name: "Casual Maxi Dress", icon: <FaHeart /> },

  // Dresses - Midi Dresses (07010202)
  { id: "PT-07010202-01", parentId: "07010202", level: "productType", name: "Work Midi Dress", icon: <FaHeart /> },
  { id: "PT-07010202-02", parentId: "07010202", level: "productType", name: "Casual Midi Dress", icon: <FaHeart /> },
  { id: "PT-07010202-03", parentId: "07010202", level: "productType", name: "Party Midi Dress", icon: <FaHeart /> },

  // T-Shirts - Crew Neck (07010401)
  { id: "PT-07010401-01", parentId: "07010401", level: "productType", name: "Classic Crew Neck Tee", icon: <FaShirt /> },
  { id: "PT-07010401-02", parentId: "07010401", level: "productType", name: "Premium Cotton Crew Tee", icon: <FaShirt /> },
  { id: "PT-07010401-03", parentId: "07010401", level: "productType", name: "Vintage Crew Neck Tee", icon: <FaShirt /> },

  // Jeans - Skinny (07011601)
  { id: "PT-07011601-01", parentId: "07011601", level: "productType", name: "High Waist Skinny Jeans", icon: <FaLayerGroup /> },
  { id: "PT-07011601-02", parentId: "07011601", level: "productType", name: "Black Skinny Denim", icon: <FaLayerGroup /> },
  { id: "PT-07011601-03", parentId: "07011601", level: "productType", name: "Distressed Skinny Jeans", icon: <FaLayerGroup /> },

  // Jeans - Straight (07011602)
  { id: "PT-07011602-01", parentId: "07011602", level: "productType", name: "Classic Straight Jeans", icon: <FaLayerGroup /> },
  { id: "PT-07011602-02", parentId: "07011602", level: "productType", name: "Vintage Straight Leg", icon: <FaLayerGroup /> },
  { id: "PT-07011602-03", parentId: "07011602", level: "productType", name: "Premium Straight Denim", icon: <FaLayerGroup /> },

  // Hoodies - Pullover (07011001)
  { id: "PT-07011001-01", parentId: "07011001", level: "productType", name: "Classic Pullover Hoodie", icon: <FaTag /> },
  { id: "PT-07011001-02", parentId: "07011001", level: "productType", name: "Oversized Hoodie", icon: <FaTag /> },
  { id: "PT-07011001-03", parentId: "07011001", level: "productType", name: "Premium Pullover", icon: <FaTag /> },

  // Jackets - Denim (07011201)
  { id: "PT-07011201-01", parentId: "07011201", level: "productType", name: "Classic Denim Jacket", icon: <FaWind /> },
  { id: "PT-07011201-02", parentId: "07011201", level: "productType", name: "Distressed Denim Jacket", icon: <FaWind /> },
  { id: "PT-07011201-03", parentId: "07011201", level: "productType", name: "Trucker Denim Jacket", icon: <FaWind /> },

  // Swimwear - Bikinis (07013101)
  { id: "PT-07013101-01", parentId: "07013101", level: "productType", name: "Triangle Bikini", icon: <FaUmbrellaBeach /> },
  { id: "PT-07013101-02", parentId: "07013101", level: "productType", name: "High Waist Bikini", icon: <FaUmbrellaBeach /> },
  { id: "PT-07013101-03", parentId: "07013101", level: "productType", name: "Bandeau Bikini", icon: <FaUmbrellaBeach /> },

  // Activewear - Leggings (07012001)
  { id: "PT-07012001-01", parentId: "07012001", level: "productType", name: "High-Waist Leggings", icon: <FaBolt /> },
  { id: "PT-07012001-02", parentId: "07012001", level: "productType", name: "Capri Yoga Leggings", icon: <FaBolt /> },
  { id: "PT-07012001-03", parentId: "07012001", level: "productType", name: "Full Length Leggings", icon: <FaBolt /> },
];

/**
 * PRODUCTS - Actual product SKU/names under each ProductType
 * Hierarchy: SubCategory > ProductType > Product
 */
export const ProductClothing: CategoryItem[] = [
  // Maxi Dresses - Summer Maxi (PT-07010201-01)
  { id: "PRD-0701020101-01", parentId: "PT-07010201-01", level: "product", name: "Summer Maxi Dress Blue", icon: <FaHeart /> },
  { id: "PRD-0701020101-02", parentId: "PT-07010201-01", level: "product", name: "Summer Maxi Dress Floral", icon: <FaHeart /> },
  { id: "PRD-0701020101-03", parentId: "PT-07010201-01", level: "product", name: "Summer Maxi Dress White", icon: <FaHeart /> },

  // Maxi Dresses - Evening Maxi (PT-07010201-02)
  { id: "PRD-0701020102-01", parentId: "PT-07010201-02", level: "product", name: "Evening Maxi Gown Black", icon: <FaHeart /> },
  { id: "PRD-0701020102-02", parentId: "PT-07010201-02", level: "product", name: "Evening Maxi Gown Gold", icon: <FaHeart /> },
  { id: "PRD-0701020102-03", parentId: "PT-07010201-02", level: "product", name: "Evening Maxi Gown Navy", icon: <FaHeart /> },

  // Midi Dresses - Work Midi (PT-07010202-01)
  { id: "PRD-0701020201-01", parentId: "PT-07010202-01", level: "product", name: "Work Midi Dress Grey", icon: <FaHeart /> },
  { id: "PRD-0701020201-02", parentId: "PT-07010202-01", level: "product", name: "Work Midi Dress Black", icon: <FaHeart /> },
  { id: "PRD-0701020201-03", parentId: "PT-07010202-01", level: "product", name: "Work Midi Dress Navy", icon: <FaHeart /> },

  // Crew Neck T-Shirts - Classic (PT-07010401-01)
  { id: "PRD-0701040101-01", parentId: "PT-07010401-01", level: "product", name: "Classic Crew Neck White", icon: <FaShirt /> },
  { id: "PRD-0701040101-02", parentId: "PT-07010401-01", level: "product", name: "Classic Crew Neck Black", icon: <FaShirt /> },
  { id: "PRD-0701040101-03", parentId: "PT-07010401-01", level: "product", name: "Classic Crew Neck Grey", icon: <FaShirt /> },

  // Crew Neck T-Shirts - Premium (PT-07010401-02)
  { id: "PRD-0701040102-01", parentId: "PT-07010401-02", level: "product", name: "Premium Cotton Crew White", icon: <FaShirt /> },
  { id: "PRD-0701040102-02", parentId: "PT-07010401-02", level: "product", name: "Premium Cotton Crew Black", icon: <FaShirt /> },
  { id: "PRD-0701040102-03", parentId: "PT-07010401-02", level: "product", name: "Premium Cotton Crew Navy", icon: <FaShirt /> },

  // Skinny Jeans - High Waist (PT-07011601-01)
  { id: "PRD-0701160101-01", parentId: "PT-07011601-01", level: "product", name: "High Waist Skinny Black", icon: <FaLayerGroup /> },
  { id: "PRD-0701160101-02", parentId: "PT-07011601-01", level: "product", name: "High Waist Skinny Blue", icon: <FaLayerGroup /> },
  { id: "PRD-0701160101-03", parentId: "PT-07011601-01", level: "product", name: "High Waist Skinny Indigo", icon: <FaLayerGroup /> },

  // Skinny Jeans - Black (PT-07011601-02)
  { id: "PRD-0701160102-01", parentId: "PT-07011601-02", level: "product", name: "Black Skinny Denim Slim", icon: <FaLayerGroup /> },
  { id: "PRD-0701160102-02", parentId: "PT-07011601-02", level: "product", name: "Black Skinny Denim Distressed", icon: <FaLayerGroup /> },
  { id: "PRD-0701160102-03", parentId: "PT-07011601-02", level: "product", name: "Black Skinny Denim Premium", icon: <FaLayerGroup /> },

  // Straight Jeans - Classic (PT-07011602-01)
  { id: "PRD-0701160201-01", parentId: "PT-07011602-01", level: "product", name: "Classic Straight Blue", icon: <FaLayerGroup /> },
  { id: "PRD-0701160201-02", parentId: "PT-07011602-01", level: "product", name: "Classic Straight Black", icon: <FaLayerGroup /> },
  { id: "PRD-0701160201-03", parentId: "PT-07011602-01", level: "product", name: "Classic Straight Indigo", icon: <FaLayerGroup /> },

  // Pullover Hoodies - Classic (PT-07011001-01)
  { id: "PRD-0701100101-01", parentId: "PT-07011001-01", level: "product", name: "Classic Pullover Grey", icon: <FaTag /> },
  { id: "PRD-0701100101-02", parentId: "PT-07011001-01", level: "product", name: "Classic Pullover Black", icon: <FaTag /> },
  { id: "PRD-0701100101-03", parentId: "PT-07011001-01", level: "product", name: "Classic Pullover White", icon: <FaTag /> },

  // Pullover Hoodies - Oversized (PT-07011001-02)
  { id: "PRD-0701100102-01", parentId: "PT-07011001-02", level: "product", name: "Oversized Hoodie Grey", icon: <FaTag /> },
  { id: "PRD-0701100102-02", parentId: "PT-07011001-02", level: "product", name: "Oversized Hoodie Black", icon: <FaTag /> },
  { id: "PRD-0701100102-03", parentId: "PT-07011001-02", level: "product", name: "Oversized Hoodie Navy", icon: <FaTag /> },

  // Denim Jackets - Classic (PT-07011201-01)
  { id: "PRD-0701120101-01", parentId: "PT-07011201-01", level: "product", name: "Classic Denim Light Blue", icon: <FaWind /> },
  { id: "PRD-0701120101-02", parentId: "PT-07011201-01", level: "product", name: "Classic Denim Dark Blue", icon: <FaWind /> },
  { id: "PRD-0701120101-03", parentId: "PT-07011201-01", level: "product", name: "Classic Denim Black", icon: <FaWind /> },

  // Denim Jackets - Distressed (PT-07011201-02)
  { id: "PRD-0701120102-01", parentId: "PT-07011201-02", level: "product", name: "Distressed Denim Light", icon: <FaWind /> },
  { id: "PRD-0701120102-02", parentId: "PT-07011201-02", level: "product", name: "Distressed Denim Dark", icon: <FaWind /> },
  { id: "PRD-0701120102-03", parentId: "PT-07011201-02", level: "product", name: "Distressed Denim Ripped", icon: <FaWind /> },

  // Bikinis - Triangle (PT-07013101-01)
  { id: "PRD-0701310101-01", parentId: "PT-07013101-01", level: "product", name: "Triangle Bikini Blue", icon: <FaUmbrellaBeach /> },
  { id: "PRD-0701310101-02", parentId: "PT-07013101-01", level: "product", name: "Triangle Bikini Black", icon: <FaUmbrellaBeach /> },
  { id: "PRD-0701310101-03", parentId: "PT-07013101-01", level: "product", name: "Triangle Bikini Pink", icon: <FaUmbrellaBeach /> },

  // Bikinis - High Waist (PT-07013101-02)
  { id: "PRD-0701310102-01", parentId: "PT-07013101-02", level: "product", name: "High Waist Bikini Blue", icon: <FaUmbrellaBeach /> },
  { id: "PRD-0701310102-02", parentId: "PT-07013101-02", level: "product", name: "High Waist Bikini Red", icon: <FaUmbrellaBeach /> },
  { id: "PRD-0701310102-03", parentId: "PT-07013101-02", level: "product", name: "High Waist Bikini White", icon: <FaUmbrellaBeach /> },

  // Leggings - High Waist (PT-07012001-01)
  { id: "PRD-0701200101-01", parentId: "PT-07012001-01", level: "product", name: "High Waist Leggings Black", icon: <FaBolt /> },
  { id: "PRD-0701200101-02", parentId: "PT-07012001-01", level: "product", name: "High Waist Leggings Navy", icon: <FaBolt /> },
  { id: "PRD-0701200101-03", parentId: "PT-07012001-01", level: "product", name: "High Waist Leggings Grey", icon: <FaBolt /> },

  // Leggings - Capri (PT-07012001-02)
  { id: "PRD-0701200102-01", parentId: "PT-07012001-02", level: "product", name: "Capri Yoga Leggings Black", icon: <FaBolt /> },
  { id: "PRD-0701200102-02", parentId: "PT-07012001-02", level: "product", name: "Capri Yoga Leggings Navy", icon: <FaBolt /> },
  { id: "PRD-0701200102-03", parentId: "PT-07012001-02", level: "product", name: "Capri Yoga Leggings Purple", icon: <FaBolt /> },
];



/* ───────────────────────────────────────────────────────────
   SHOES   (parentId: 0702)
   ─────────────────────────────────────────────────────────── */
export const CategoryShoes: CategoryItem[] = [];
export const SubCategoryShoes: CategoryItem[] = [];
export const ProductTypeShoes: CategoryItem[] = [];
export const ProductShoes: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   ACCESSORIES   (parentId: 0703)
   ─────────────────────────────────────────────────────────── */
export const CategoryAccessories: CategoryItem[] = [];
export const SubCategoryAccessories: CategoryItem[] = [];
export const ProductTypeAccessories: CategoryItem[] = [];
export const ProductAccessories: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   JEWELRY   (parentId: 0704)
   ─────────────────────────────────────────────────────────── */
export const CategoryJewelry: CategoryItem[] = [];
export const SubCategoryJewelry: CategoryItem[] = [];
export const ProductTypeJewelry: CategoryItem[] = [];
export const ProductJewelry: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BAGS   (parentId: 0705)
   ─────────────────────────────────────────────────────────── */
export const CategoryBags: CategoryItem[] = [];
export const SubCategoryBags: CategoryItem[] = [];
export const ProductTypeBags: CategoryItem[] = [];
export const ProductBags: CategoryItem[] = [];




/* ───────────────────────────────────────────────────────────
   FOOD 08
   ─────────────────────────────────────────────────────────── */
/* ───────────────────────────────────────────────────────────
   FAST FOOD   (parentId: 0801)
   Categories organized by cuisine / culture
   ─────────────────────────────────────────────────────────── */
export const CategoryFastFood: CategoryItem[] = [
  { id: "080101", parentId: "0801", level: "category", name: "American",         icon: <FaBurger /> },
  { id: "080102", parentId: "0801", level: "category", name: "Mexican",          icon: <FaPepperHot /> },
  { id: "080103", parentId: "0801", level: "category", name: "Italian",          icon: <FaPizzaSlice /> },
  { id: "080104", parentId: "0801", level: "category", name: "Chinese",          icon: <FaBowlRice /> },
  { id: "080105", parentId: "0801", level: "category", name: "Japanese",         icon: <FaFish /> },
  { id: "080106", parentId: "0801", level: "category", name: "Indian",           icon: <FaPepperHot /> },
  { id: "080107", parentId: "0801", level: "category", name: "Middle Eastern",   icon: <FaBreadSlice /> },
  { id: "080108", parentId: "0801", level: "category", name: "Korean",           icon: <FaDrumstickBite /> },
  { id: "080109", parentId: "0801", level: "category", name: "Thai",             icon: <FaBowlFood /> },
  { id: "080110", parentId: "0801", level: "category", name: "Mediterranean",    icon: <FaLeaf /> },
  { id: "080111", parentId: "0801", level: "category", name: "Vietnamese",       icon: <FaBowlFood /> },
  { id: "080112", parentId: "0801", level: "category", name: "Filipino",         icon: <FaBowlRice /> },
  { id: "080113", parentId: "0801", level: "category", name: "Caribbean",        icon: <FaPepperHot /> },
  { id: "080114", parentId: "0801", level: "category", name: "African",         icon: <FaDrumstickBite /> },
  { id: "080115", parentId: "0801", level: "category", name: "Greek",            icon: <FaBreadSlice /> },
  { id: "080116", parentId: "0801", level: "category", name: "Spanish",          icon: <FaShrimp /> },
  { id: "080117", parentId: "0801", level: "category", name: "French",           icon: <FaBreadSlice /> },
  { id: "080118", parentId: "0801", level: "category", name: "Brazilian",        icon: <FaDrumstickBite /> },
  { id: "080119", parentId: "0801", level: "category", name: "German",           icon: <FaHotdog /> },
  { id: "080120", parentId: "0801", level: "category", name: "British",          icon: <FaFish /> },
  { id: "080121", parentId: "0801", level: "category", name: "Peruvian",         icon: <FaShrimp /> },
  { id: "080122", parentId: "0801", level: "category", name: "Ethiopian",        icon: <FaBowlFood /> },
  { id: "080123", parentId: "0801", level: "category", name: "Turkish",          icon: <FaDrumstickBite /> },
  { id: "080124", parentId: "0801", level: "category", name: "Hawaiian",         icon: <FaUmbrellaBeach /> },
];


export const SubCategoryFastFood: CategoryItem[] = [
  // American (080101)
  { id: "08010101", parentId: "080101", level: "subCategory", name: "Burgers",        icon: <FaBurger /> },
  { id: "08010102", parentId: "080101", level: "subCategory", name: "Fried Chicken",  icon: <FaDrumstickBite /> },
  { id: "08010103", parentId: "080101", level: "subCategory", name: "Hot Dogs",       icon: <FaHotdog /> },
  { id: "08010104", parentId: "080101", level: "subCategory", name: "BBQ",            icon: <FaFire /> },
  { id: "08010105", parentId: "080101", level: "subCategory", name: "Diner Classics", icon: <FaUtensils /> },

  // Mexican (080102)
  { id: "08010201", parentId: "080102", level: "subCategory", name: "Tacos",       icon: <FaPepperHot /> },
  { id: "08010202", parentId: "080102", level: "subCategory", name: "Burritos",    icon: <FaBreadSlice /> },
  { id: "08010203", parentId: "080102", level: "subCategory", name: "Quesadillas", icon: <FaCheese /> },
  { id: "08010204", parentId: "080102", level: "subCategory", name: "Nachos",      icon: <FaBowlFood /> },

  // Italian (080103)
  { id: "08010301", parentId: "080103", level: "subCategory", name: "Pizza",    icon: <FaPizzaSlice /> },
  { id: "08010302", parentId: "080103", level: "subCategory", name: "Pasta",    icon: <FaBowlFood /> },
  { id: "08010303", parentId: "080103", level: "subCategory", name: "Calzones", icon: <FaBreadSlice /> },

  // Chinese (080104)
  { id: "08010401", parentId: "080104", level: "subCategory", name: "Noodles",    icon: <FaBowlRice /> },
  { id: "08010402", parentId: "080104", level: "subCategory", name: "Fried Rice", icon: <FaBowlRice /> },
  { id: "08010403", parentId: "080104", level: "subCategory", name: "Dim Sum",    icon: <FaBowlFood /> },
  { id: "08010404", parentId: "080104", level: "subCategory", name: "Stir Fry",   icon: <FaFire /> },

  // Japanese (080105)
  { id: "08010501", parentId: "080105", level: "subCategory", name: "Sushi", icon: <FaFish /> },
  { id: "08010502", parentId: "080105", level: "subCategory", name: "Ramen", icon: <FaBowlFood /> },
  { id: "08010503", parentId: "080105", level: "subCategory", name: "Bento", icon: <FaBoxesStacked /> },

  // Indian (080106)
  { id: "08010601", parentId: "080106", level: "subCategory", name: "Curry",             icon: <FaPepperHot /> },
  { id: "08010602", parentId: "080106", level: "subCategory", name: "Biryani",           icon: <FaBowlRice /> },
  { id: "08010603", parentId: "080106", level: "subCategory", name: "Naan & Flatbreads", icon: <FaBreadSlice /> },

  // Middle Eastern (080107)
  { id: "08010701", parentId: "080107", level: "subCategory", name: "Shawarma", icon: <FaDrumstickBite /> },
  { id: "08010702", parentId: "080107", level: "subCategory", name: "Falafel",  icon: <FaBowlFood /> },
  { id: "08010703", parentId: "080107", level: "subCategory", name: "Kebabs",   icon: <FaFire /> },

  // Korean (080108)
  { id: "08010801", parentId: "080108", level: "subCategory", name: "Korean BBQ",             icon: <FaFire /> },
  { id: "08010802", parentId: "080108", level: "subCategory", name: "Bibimbap",               icon: <FaBowlRice /> },
  { id: "08010803", parentId: "080108", level: "subCategory", name: "Fried Chicken (Korean)",  icon: <FaDrumstickBite /> },

  // Thai (080109)
  { id: "08010901", parentId: "080109", level: "subCategory", name: "Pad Thai",   icon: <FaBowlFood /> },
  { id: "08010902", parentId: "080109", level: "subCategory", name: "Thai Curry", icon: <FaPepperHot /> },

  // Mediterranean (080110)
  { id: "08011001", parentId: "080110", level: "subCategory", name: "Gyros",         icon: <FaBreadSlice /> },
  { id: "08011002", parentId: "080110", level: "subCategory", name: "Hummus & Dips", icon: <FaBowlFood /> },

  // Vietnamese (080111)
  { id: "08011101", parentId: "080111", level: "subCategory", name: "Pho",       icon: <FaBowlFood /> },
  { id: "08011102", parentId: "080111", level: "subCategory", name: "Banh Mi",   icon: <FaBreadSlice /> },
  { id: "08011103", parentId: "080111", level: "subCategory", name: "Spring Rolls", icon: <FaLeaf /> },

  // Filipino (080112)
  { id: "08011201", parentId: "080112", level: "subCategory", name: "Adobo",     icon: <FaDrumstickBite /> },
  { id: "08011202", parentId: "080112", level: "subCategory", name: "Lumpia",    icon: <FaLeaf /> },
  { id: "08011203", parentId: "080112", level: "subCategory", name: "Sinigang",  icon: <FaBowlFood /> },

  // Caribbean (080113)
  { id: "08011301", parentId: "080113", level: "subCategory", name: "Jerk Chicken",  icon: <FaPepperHot /> },
  { id: "08011302", parentId: "080113", level: "subCategory", name: "Curry Goat",    icon: <FaPepperHot /> },
  { id: "08011303", parentId: "080113", level: "subCategory", name: "Rice & Peas",   icon: <FaBowlRice /> },

  // African (080114)
  { id: "08011401", parentId: "080114", level: "subCategory", name: "Jollof Rice",   icon: <FaBowlRice /> },
  { id: "08011402", parentId: "080114", level: "subCategory", name: "Suya",          icon: <FaFire /> },
  { id: "08011403", parentId: "080114", level: "subCategory", name: "Stews",         icon: <FaBowlFood /> },

  // Greek (080115)
  { id: "08011501", parentId: "080115", level: "subCategory", name: "Souvlaki", icon: <FaDrumstickBite /> },
  { id: "08011502", parentId: "080115", level: "subCategory", name: "Gyro Wraps", icon: <FaBreadSlice /> },
  { id: "08011503", parentId: "080115", level: "subCategory", name: "Greek Salad", icon: <FaLeaf /> },

  // Spanish (080116)
  { id: "08011601", parentId: "080116", level: "subCategory", name: "Tapas",   icon: <FaShrimp /> },
  { id: "08011602", parentId: "080116", level: "subCategory", name: "Paella",  icon: <FaBowlRice /> },
  { id: "08011603", parentId: "080116", level: "subCategory", name: "Churros", icon: <FaBreadSlice /> },

  // French (080117)
  { id: "08011701", parentId: "080117", level: "subCategory", name: "Crepes",     icon: <FaBreadSlice /> },
  { id: "08011702", parentId: "080117", level: "subCategory", name: "Baguette Sandwiches", icon: <FaBreadSlice /> },
  { id: "08011703", parentId: "080117", level: "subCategory", name: "Pastries",   icon: <FaCookieBite /> },

  // Brazilian (080118)
  { id: "08011801", parentId: "080118", level: "subCategory", name: "Churrasco", icon: <FaFire /> },
  { id: "08011802", parentId: "080118", level: "subCategory", name: "Feijoada",  icon: <FaBowlFood /> },
  { id: "08011803", parentId: "080118", level: "subCategory", name: "Pão de Queijo", icon: <FaBreadSlice /> },

  // German (080119)
  { id: "08011901", parentId: "080119", level: "subCategory", name: "Bratwurst", icon: <FaHotdog /> },
  { id: "08011902", parentId: "080119", level: "subCategory", name: "Schnitzel", icon: <FaDrumstickBite /> },
  { id: "08011903", parentId: "080119", level: "subCategory", name: "Pretzels",  icon: <FaBreadSlice /> },

  // British (080120)
  { id: "08012001", parentId: "080120", level: "subCategory", name: "Fish & Chips", icon: <FaFish /> },
  { id: "08012002", parentId: "080120", level: "subCategory", name: "Meat Pies",    icon: <FaBreadSlice /> },
  { id: "08012003", parentId: "080120", level: "subCategory", name: "Sunday Roast", icon: <FaDrumstickBite /> },

  // Peruvian (080121)
  { id: "08012101", parentId: "080121", level: "subCategory", name: "Ceviche",       icon: <FaShrimp /> },
  { id: "08012102", parentId: "080121", level: "subCategory", name: "Lomo Saltado",  icon: <FaBowlFood /> },

  // Ethiopian (080122)
  { id: "08012201", parentId: "080122", level: "subCategory", name: "Injera Platters", icon: <FaBowlFood /> },
  { id: "08012202", parentId: "080122", level: "subCategory", name: "Wat (Stews)",     icon: <FaPepperHot /> },

  // Turkish (080123)
  { id: "08012301", parentId: "080123", level: "subCategory", name: "Doner Kebab", icon: <FaDrumstickBite /> },
  { id: "08012302", parentId: "080123", level: "subCategory", name: "Pide",        icon: <FaBreadSlice /> },
  { id: "08012303", parentId: "080123", level: "subCategory", name: "Baklava",     icon: <FaCookieBite /> },

  // Hawaiian (080124)
  { id: "08012401", parentId: "080124", level: "subCategory", name: "Poke Bowls", icon: <FaFish /> },
  { id: "08012402", parentId: "080124", level: "subCategory", name: "Plate Lunch", icon: <FaBowlRice /> },
  { id: "08012403", parentId: "080124", level: "subCategory", name: "Loco Moco",  icon: <FaBowlFood /> },
];

export const ProductTypeFastFood: CategoryItem[] = [
  // Burgers (08010101) — already provided
  { id: "PT-08010101-01", parentId: "08010101", level: "productType", name: "Classic Cheeseburger", icon: <FaBurger /> },
  { id: "PT-08010101-02", parentId: "08010101", level: "productType", name: "Double Bacon Burger",  icon: <FaBurger /> },
  { id: "PT-08010101-03", parentId: "08010101", level: "productType", name: "Veggie Burger",        icon: <FaBurger /> },

  // Fried Chicken (08010102)
  { id: "PT-08010102-01", parentId: "08010102", level: "productType", name: "Crispy Fried Chicken Bucket", icon: <FaDrumstickBite /> },
  { id: "PT-08010102-02", parentId: "08010102", level: "productType", name: "Spicy Fried Chicken Sandwich", icon: <FaDrumstickBite /> },

  // Hot Dogs (08010103)
  { id: "PT-08010103-01", parentId: "08010103", level: "productType", name: "Classic Hot Dog",  icon: <FaHotdog /> },
  { id: "PT-08010103-02", parentId: "08010103", level: "productType", name: "Chili Cheese Dog",  icon: <FaHotdog /> },

  // BBQ (08010104)
  { id: "PT-08010104-01", parentId: "08010104", level: "productType", name: "Pulled Pork Platter", icon: <FaFire /> },
  { id: "PT-08010104-02", parentId: "08010104", level: "productType", name: "BBQ Ribs",            icon: <FaFire /> },

  // Diner Classics (08010105)
  { id: "PT-08010105-01", parentId: "08010105", level: "productType", name: "Club Sandwich", icon: <FaUtensils /> },
  { id: "PT-08010105-02", parentId: "08010105", level: "productType", name: "All-Day Breakfast Plate", icon: <FaUtensils /> },

  // Tacos (08010201)
  { id: "PT-08010201-01", parentId: "08010201", level: "productType", name: "Carne Asada Taco", icon: <FaPepperHot /> },
  { id: "PT-08010201-02", parentId: "08010201", level: "productType", name: "Al Pastor Taco",    icon: <FaPepperHot /> },

  // Burritos (08010202)
  { id: "PT-08010202-01", parentId: "08010202", level: "productType", name: "Chicken Burrito", icon: <FaBreadSlice /> },
  { id: "PT-08010202-02", parentId: "08010202", level: "productType", name: "Bean & Rice Burrito", icon: <FaBreadSlice /> },

  // Quesadillas (08010203)
  { id: "PT-08010203-01", parentId: "08010203", level: "productType", name: "Cheese Quesadilla",   icon: <FaCheese /> },
  { id: "PT-08010203-02", parentId: "08010203", level: "productType", name: "Chicken Quesadilla",  icon: <FaCheese /> },

  // Nachos (08010204)
  { id: "PT-08010204-01", parentId: "08010204", level: "productType", name: "Loaded Nachos",  icon: <FaBowlFood /> },
  { id: "PT-08010204-02", parentId: "08010204", level: "productType", name: "Nachos Supreme", icon: <FaBowlFood /> },

  // Pizza (08010301) — already provided
  { id: "PT-08010301-01", parentId: "08010301", level: "productType", name: "Margherita Pizza", icon: <FaPizzaSlice /> },
  { id: "PT-08010301-02", parentId: "08010301", level: "productType", name: "Pepperoni Pizza",  icon: <FaPizzaSlice /> },
  { id: "PT-08010301-03", parentId: "08010301", level: "productType", name: "Vegetarian Pizza", icon: <FaPizzaSlice /> },

  // Pasta (08010302)
  { id: "PT-08010302-01", parentId: "08010302", level: "productType", name: "Spaghetti Bolognese", icon: <FaBowlFood /> },
  { id: "PT-08010302-02", parentId: "08010302", level: "productType", name: "Fettuccine Alfredo",  icon: <FaBowlFood /> },

  // Calzones (08010303)
  { id: "PT-08010303-01", parentId: "08010303", level: "productType", name: "Classic Calzone", icon: <FaBreadSlice /> },
  { id: "PT-08010303-02", parentId: "08010303", level: "productType", name: "Spinach & Ricotta Calzone", icon: <FaBreadSlice /> },

  // Noodles (08010401)
  { id: "PT-08010401-01", parentId: "08010401", level: "productType", name: "Lo Mein",   icon: <FaBowlRice /> },
  { id: "PT-08010401-02", parentId: "08010401", level: "productType", name: "Chow Mein", icon: <FaBowlRice /> },

  // Fried Rice (08010402)
  { id: "PT-08010402-01", parentId: "08010402", level: "productType", name: "Egg Fried Rice",    icon: <FaBowlRice /> },
  { id: "PT-08010402-02", parentId: "08010402", level: "productType", name: "Shrimp Fried Rice",  icon: <FaBowlRice /> },

  // Dim Sum (08010403)
  { id: "PT-08010403-01", parentId: "08010403", level: "productType", name: "Pork Dumplings",  icon: <FaBowlFood /> },
  { id: "PT-08010403-02", parentId: "08010403", level: "productType", name: "Shrimp Har Gow",  icon: <FaBowlFood /> },

  // Stir Fry (08010404)
  { id: "PT-08010404-01", parentId: "08010404", level: "productType", name: "Beef & Broccoli Stir Fry", icon: <FaFire /> },
  { id: "PT-08010404-02", parentId: "08010404", level: "productType", name: "Kung Pao Chicken",         icon: <FaFire /> },

  // Sushi (08010501)
  { id: "PT-08010501-01", parentId: "08010501", level: "productType", name: "California Roll", icon: <FaFish /> },
  { id: "PT-08010501-02", parentId: "08010501", level: "productType", name: "Salmon Nigiri Set", icon: <FaFish /> },

  // Ramen (08010502)
  { id: "PT-08010502-01", parentId: "08010502", level: "productType", name: "Tonkotsu Ramen", icon: <FaBowlFood /> },
  { id: "PT-08010502-02", parentId: "08010502", level: "productType", name: "Miso Ramen",      icon: <FaBowlFood /> },

  // Bento (08010503)
  { id: "PT-08010503-01", parentId: "08010503", level: "productType", name: "Chicken Teriyaki Bento", icon: <FaBoxesStacked /> },
  { id: "PT-08010503-02", parentId: "08010503", level: "productType", name: "Salmon Bento",           icon: <FaBoxesStacked /> },

  // Curry (08010601)
  { id: "PT-08010601-01", parentId: "08010601", level: "productType", name: "Butter Chicken Curry", icon: <FaPepperHot /> },
  { id: "PT-08010601-02", parentId: "08010601", level: "productType", name: "Chickpea Curry",        icon: <FaPepperHot /> },

  // Biryani (08010602)
  { id: "PT-08010602-01", parentId: "08010602", level: "productType", name: "Chicken Biryani", icon: <FaBowlRice /> },
  { id: "PT-08010602-02", parentId: "08010602", level: "productType", name: "Vegetable Biryani", icon: <FaBowlRice /> },

  // Naan & Flatbreads (08010603)
  { id: "PT-08010603-01", parentId: "08010603", level: "productType", name: "Garlic Naan",  icon: <FaBreadSlice /> },
  { id: "PT-08010603-02", parentId: "08010603", level: "productType", name: "Plain Naan",   icon: <FaBreadSlice /> },

  // Shawarma (08010701)
  { id: "PT-08010701-01", parentId: "08010701", level: "productType", name: "Chicken Shawarma Wrap", icon: <FaDrumstickBite /> },
  { id: "PT-08010701-02", parentId: "08010701", level: "productType", name: "Beef Shawarma Plate",   icon: <FaDrumstickBite /> },

  // Falafel (08010702)
  { id: "PT-08010702-01", parentId: "08010702", level: "productType", name: "Falafel Wrap",  icon: <FaBowlFood /> },
  { id: "PT-08010702-02", parentId: "08010702", level: "productType", name: "Falafel Plate", icon: <FaBowlFood /> },

  // Kebabs (08010703)
  { id: "PT-08010703-01", parentId: "08010703", level: "productType", name: "Chicken Kebab Skewer", icon: <FaFire /> },
  { id: "PT-08010703-02", parentId: "08010703", level: "productType", name: "Lamb Kebab Skewer",    icon: <FaFire /> },

  // Korean BBQ (08010801)
  { id: "PT-08010801-01", parentId: "08010801", level: "productType", name: "Bulgogi",   icon: <FaFire /> },
  { id: "PT-08010801-02", parentId: "08010801", level: "productType", name: "Galbi Short Ribs", icon: <FaFire /> },

  // Bibimbap (08010802)
  { id: "PT-08010802-01", parentId: "08010802", level: "productType", name: "Beef Bibimbap", icon: <FaBowlRice /> },
  { id: "PT-08010802-02", parentId: "08010802", level: "productType", name: "Vegetable Bibimbap", icon: <FaBowlRice /> },

  // Fried Chicken (Korean) (08010803)
  { id: "PT-08010803-01", parentId: "08010803", level: "productType", name: "Yangnyeom Fried Chicken", icon: <FaDrumstickBite /> },
  { id: "PT-08010803-02", parentId: "08010803", level: "productType", name: "Soy Garlic Fried Chicken", icon: <FaDrumstickBite /> },

  // Pad Thai (08010901)
  { id: "PT-08010901-01", parentId: "08010901", level: "productType", name: "Chicken Pad Thai", icon: <FaBowlFood /> },
  { id: "PT-08010901-02", parentId: "08010901", level: "productType", name: "Shrimp Pad Thai",  icon: <FaBowlFood /> },

  // Thai Curry (08010902)
  { id: "PT-08010902-01", parentId: "08010902", level: "productType", name: "Green Curry", icon: <FaPepperHot /> },
  { id: "PT-08010902-02", parentId: "08010902", level: "productType", name: "Red Curry",   icon: <FaPepperHot /> },

  // Gyros (08011001)
  { id: "PT-08011001-01", parentId: "08011001", level: "productType", name: "Chicken Gyro", icon: <FaBreadSlice /> },
  { id: "PT-08011001-02", parentId: "08011001", level: "productType", name: "Lamb Gyro",     icon: <FaBreadSlice /> },

  // Hummus & Dips (08011002)
  { id: "PT-08011002-01", parentId: "08011002", level: "productType", name: "Classic Hummus", icon: <FaBowlFood /> },
  { id: "PT-08011002-02", parentId: "08011002", level: "productType", name: "Baba Ganoush",   icon: <FaBowlFood /> },

  // Pho (08011101)
  { id: "PT-08011101-01", parentId: "08011101", level: "productType", name: "Beef Pho",    icon: <FaBowlFood /> },
  { id: "PT-08011101-02", parentId: "08011101", level: "productType", name: "Chicken Pho", icon: <FaBowlFood /> },

  // Banh Mi (08011102)
  { id: "PT-08011102-01", parentId: "08011102", level: "productType", name: "Grilled Pork Banh Mi", icon: <FaBreadSlice /> },
  { id: "PT-08011102-02", parentId: "08011102", level: "productType", name: "Tofu Banh Mi",         icon: <FaBreadSlice /> },

  // Spring Rolls (08011103)
  { id: "PT-08011103-01", parentId: "08011103", level: "productType", name: "Fresh Spring Rolls", icon: <FaLeaf /> },
  { id: "PT-08011103-02", parentId: "08011103", level: "productType", name: "Fried Spring Rolls",  icon: <FaLeaf /> },

  // Adobo (08011201)
  { id: "PT-08011201-01", parentId: "08011201", level: "productType", name: "Chicken Adobo", icon: <FaDrumstickBite /> },
  { id: "PT-08011201-02", parentId: "08011201", level: "productType", name: "Pork Adobo",     icon: <FaDrumstickBite /> },

  // Lumpia (08011202)
  { id: "PT-08011202-01", parentId: "08011202", level: "productType", name: "Pork Lumpia",      icon: <FaLeaf /> },
  { id: "PT-08011202-02", parentId: "08011202", level: "productType", name: "Vegetable Lumpia",  icon: <FaLeaf /> },

  // Sinigang (08011203)
  { id: "PT-08011203-01", parentId: "08011203", level: "productType", name: "Pork Sinigang", icon: <FaBowlFood /> },
  { id: "PT-08011203-02", parentId: "08011203", level: "productType", name: "Shrimp Sinigang", icon: <FaBowlFood /> },

  // Jerk Chicken (08011301)
  { id: "PT-08011301-01", parentId: "08011301", level: "productType", name: "Jerk Chicken Plate", icon: <FaPepperHot /> },
  { id: "PT-08011301-02", parentId: "08011301", level: "productType", name: "Jerk Chicken Wrap",  icon: <FaPepperHot /> },

  // Curry Goat (08011302)
  { id: "PT-08011302-01", parentId: "08011302", level: "productType", name: "Curry Goat Plate", icon: <FaPepperHot /> },

  // Rice & Peas (08011303)
  { id: "PT-08011303-01", parentId: "08011303", level: "productType", name: "Rice & Peas Side", icon: <FaBowlRice /> },

  // Jollof Rice (08011401)
  { id: "PT-08011401-01", parentId: "08011401", level: "productType", name: "Chicken Jollof Rice", icon: <FaBowlRice /> },
  { id: "PT-08011401-02", parentId: "08011401", level: "productType", name: "Vegetable Jollof Rice", icon: <FaBowlRice /> },

  // Suya (08011402)
  { id: "PT-08011402-01", parentId: "08011402", level: "productType", name: "Beef Suya Skewers", icon: <FaFire /> },
  { id: "PT-08011402-02", parentId: "08011402", level: "productType", name: "Chicken Suya Skewers", icon: <FaFire /> },

  // Stews (08011403)
  { id: "PT-08011403-01", parentId: "08011403", level: "productType", name: "Peanut Stew",  icon: <FaBowlFood /> },
  { id: "PT-08011403-02", parentId: "08011403", level: "productType", name: "Egusi Stew",   icon: <FaBowlFood /> },

  // Souvlaki (08011501)
  { id: "PT-08011501-01", parentId: "08011501", level: "productType", name: "Chicken Souvlaki Skewer", icon: <FaDrumstickBite /> },
  { id: "PT-08011501-02", parentId: "08011501", level: "productType", name: "Pork Souvlaki Skewer",    icon: <FaDrumstickBite /> },

  // Gyro Wraps (08011502)
  { id: "PT-08011502-01", parentId: "08011502", level: "productType", name: "Classic Gyro Wrap", icon: <FaBreadSlice /> },

  // Greek Salad (08011503)
  { id: "PT-08011503-01", parentId: "08011503", level: "productType", name: "Traditional Greek Salad", icon: <FaLeaf /> },

  // Tapas (08011601)
  { id: "PT-08011601-01", parentId: "08011601", level: "productType", name: "Patatas Bravas", icon: <FaShrimp /> },
  { id: "PT-08011601-02", parentId: "08011601", level: "productType", name: "Gambas al Ajillo", icon: <FaShrimp /> },

  // Paella (08011602)
  { id: "PT-08011602-01", parentId: "08011602", level: "productType", name: "Seafood Paella", icon: <FaBowlRice /> },
  { id: "PT-08011602-02", parentId: "08011602", level: "productType", name: "Chicken Paella",  icon: <FaBowlRice /> },

  // Churros (08011603)
  { id: "PT-08011603-01", parentId: "08011603", level: "productType", name: "Classic Churros", icon: <FaBreadSlice /> },

  // Crepes (08011701)
  { id: "PT-08011701-01", parentId: "08011701", level: "productType", name: "Sweet Crepe",  icon: <FaBreadSlice /> },
  { id: "PT-08011701-02", parentId: "08011701", level: "productType", name: "Savory Crepe",  icon: <FaBreadSlice /> },

  // Baguette Sandwiches (08011702)
  { id: "PT-08011702-01", parentId: "08011702", level: "productType", name: "Ham & Cheese Baguette", icon: <FaBreadSlice /> },

  // Pastries (08011703)
  { id: "PT-08011703-01", parentId: "08011703", level: "productType", name: "Croissant",  icon: <FaCookieBite /> },
  { id: "PT-08011703-02", parentId: "08011703", level: "productType", name: "Pain au Chocolat", icon: <FaCookieBite /> },

  // Churrasco (08011801)
  { id: "PT-08011801-01", parentId: "08011801", level: "productType", name: "Picanha Skewer", icon: <FaFire /> },
  { id: "PT-08011801-02", parentId: "08011801", level: "productType", name: "Mixed Grill Platter", icon: <FaFire /> },

  // Feijoada (08011802)
  { id: "PT-08011802-01", parentId: "08011802", level: "productType", name: "Traditional Feijoada", icon: <FaBowlFood /> },

  // Pão de Queijo (08011803)
  { id: "PT-08011803-01", parentId: "08011803", level: "productType", name: "Classic Pão de Queijo", icon: <FaBreadSlice /> },

  // Bratwurst (08011901)
  { id: "PT-08011901-01", parentId: "08011901", level: "productType", name: "Grilled Bratwurst",  icon: <FaHotdog /> },
  { id: "PT-08011901-02", parentId: "08011901", level: "productType", name: "Currywurst",          icon: <FaHotdog /> },

  // Schnitzel (08011902)
  { id: "PT-08011902-01", parentId: "08011902", level: "productType", name: "Pork Schnitzel",    icon: <FaDrumstickBite /> },
  { id: "PT-08011902-02", parentId: "08011902", level: "productType", name: "Chicken Schnitzel", icon: <FaDrumstickBite /> },

  // Pretzels (08011903)
  { id: "PT-08011903-01", parentId: "08011903", level: "productType", name: "Classic Soft Pretzel", icon: <FaBreadSlice /> },

  // Fish & Chips (08012001)
  { id: "PT-08012001-01", parentId: "08012001", level: "productType", name: "Cod Fish & Chips",   icon: <FaFish /> },
  { id: "PT-08012001-02", parentId: "08012001", level: "productType", name: "Haddock Fish & Chips", icon: <FaFish /> },

  // Meat Pies (08012002)
  { id: "PT-08012002-01", parentId: "08012002", level: "productType", name: "Steak & Ale Pie", icon: <FaBreadSlice /> },
  { id: "PT-08012002-02", parentId: "08012002", level: "productType", name: "Chicken & Mushroom Pie", icon: <FaBreadSlice /> },

  // Sunday Roast (08012003)
  { id: "PT-08012003-01", parentId: "08012003", level: "productType", name: "Roast Beef Dinner", icon: <FaDrumstickBite /> },
  { id: "PT-08012003-02", parentId: "08012003", level: "productType", name: "Roast Chicken Dinner", icon: <FaDrumstickBite /> },

  // Ceviche (08012101)
  { id: "PT-08012101-01", parentId: "08012101", level: "productType", name: "Classic Fish Ceviche", icon: <FaShrimp /> },
  { id: "PT-08012101-02", parentId: "08012101", level: "productType", name: "Mixed Seafood Ceviche", icon: <FaShrimp /> },

  // Lomo Saltado (08012102)
  { id: "PT-08012102-01", parentId: "08012102", level: "productType", name: "Beef Lomo Saltado", icon: <FaBowlFood /> },

  // Injera Platters (08012201)
  { id: "PT-08012201-01", parentId: "08012201", level: "productType", name: "Vegetarian Combo Platter", icon: <FaBowlFood /> },
  { id: "PT-08012201-02", parentId: "08012201", level: "productType", name: "Meat Combo Platter",        icon: <FaBowlFood /> },

  // Wat (Stews) (08012202)
  { id: "PT-08012202-01", parentId: "08012202", level: "productType", name: "Doro Wat",  icon: <FaPepperHot /> },
  { id: "PT-08012202-02", parentId: "08012202", level: "productType", name: "Misir Wat", icon: <FaPepperHot /> },

  // Doner Kebab (08012301)
  { id: "PT-08012301-01", parentId: "08012301", level: "productType", name: "Doner Kebab Wrap", icon: <FaDrumstickBite /> },
  { id: "PT-08012301-02", parentId: "08012301", level: "productType", name: "Doner Kebab Plate", icon: <FaDrumstickBite /> },

  // Pide (08012302)
  { id: "PT-08012302-01", parentId: "08012302", level: "productType", name: "Cheese Pide", icon: <FaBreadSlice /> },
  { id: "PT-08012302-02", parentId: "08012302", level: "productType", name: "Ground Beef Pide", icon: <FaBreadSlice /> },

  // Baklava (08012303)
  { id: "PT-08012303-01", parentId: "08012303", level: "productType", name: "Classic Baklava", icon: <FaCookieBite /> },

  // Poke Bowls (08012401)
  { id: "PT-08012401-01", parentId: "08012401", level: "productType", name: "Ahi Tuna Poke Bowl", icon: <FaFish /> },
  { id: "PT-08012401-02", parentId: "08012401", level: "productType", name: "Salmon Poke Bowl",    icon: <FaFish /> },

  // Plate Lunch (08012402)
  { id: "PT-08012402-01", parentId: "08012402", level: "productType", name: "Kalua Pork Plate", icon: <FaBowlRice /> },
  { id: "PT-08012402-02", parentId: "08012402", level: "productType", name: "Teriyaki Chicken Plate", icon: <FaBowlRice /> },

  // Loco Moco (08012403)
  { id: "PT-08012403-01", parentId: "08012403", level: "productType", name: "Classic Loco Moco", icon: <FaBowlFood /> },
];

export const ProductFastFood: CategoryItem[] = [
  // Fried Chicken
  { id: "PRD-0801010201-01", parentId: "PT-08010102-01", level: "product", name: "Fried Chicken Bucket 8pc", icon: <FaDrumstickBite /> },
  { id: "PRD-0801010202-01", parentId: "PT-08010102-02", level: "product", name: "Spicy Chicken Sandwich Meal", icon: <FaDrumstickBite /> },

  // Hot Dogs
  { id: "PRD-0801010301-01", parentId: "PT-08010103-01", level: "product", name: "Classic Hot Dog Single", icon: <FaHotdog /> },
  { id: "PRD-0801010302-01", parentId: "PT-08010103-02", level: "product", name: "Chili Cheese Dog Combo", icon: <FaHotdog /> },

  // BBQ
  { id: "PRD-0801010401-01", parentId: "PT-08010104-01", level: "product", name: "Pulled Pork Sandwich Platter", icon: <FaFire /> },
  { id: "PRD-0801010402-01", parentId: "PT-08010104-02", level: "product", name: "Half Rack BBQ Ribs", icon: <FaFire /> },

  // Diner Classics
  { id: "PRD-0801010501-01", parentId: "PT-08010105-01", level: "product", name: "Turkey Club Sandwich", icon: <FaUtensils /> },
  { id: "PRD-0801010502-01", parentId: "PT-08010105-02", level: "product", name: "Breakfast Platter Deluxe", icon: <FaUtensils /> },

  // Tacos
  { id: "PRD-0801020101-01", parentId: "PT-08010201-01", level: "product", name: "Carne Asada Taco (2pc)", icon: <FaPepperHot /> },
  { id: "PRD-0801020102-01", parentId: "PT-08010201-02", level: "product", name: "Al Pastor Taco (2pc)", icon: <FaPepperHot /> },

  // Burritos
  { id: "PRD-0801020201-01", parentId: "PT-08010202-01", level: "product", name: "Chicken Burrito Large", icon: <FaBreadSlice /> },
  { id: "PRD-0801020202-01", parentId: "PT-08010202-02", level: "product", name: "Bean & Rice Burrito Regular", icon: <FaBreadSlice /> },

  // Quesadillas
  { id: "PRD-0801020301-01", parentId: "PT-08010203-01", level: "product", name: "Cheese Quesadilla Full", icon: <FaCheese /> },
  { id: "PRD-0801020302-01", parentId: "PT-08010203-02", level: "product", name: "Chicken Quesadilla Full", icon: <FaCheese /> },

  // Nachos
  { id: "PRD-0801020401-01", parentId: "PT-08010204-01", level: "product", name: "Loaded Nachos Sharing Size", icon: <FaBowlFood /> },
  { id: "PRD-0801020402-01", parentId: "PT-08010204-02", level: "product", name: "Nachos Supreme Individual", icon: <FaBowlFood /> },

  // Pasta
  { id: "PRD-0801030201-01", parentId: "PT-08010302-01", level: "product", name: "Spaghetti Bolognese Regular", icon: <FaBowlFood /> },
  { id: "PRD-0801030202-01", parentId: "PT-08010302-02", level: "product", name: "Fettuccine Alfredo Regular", icon: <FaBowlFood /> },

  // Calzones
  { id: "PRD-0801030301-01", parentId: "PT-08010303-01", level: "product", name: "Classic Calzone Individual", icon: <FaBreadSlice /> },
  { id: "PRD-0801030302-01", parentId: "PT-08010303-02", level: "product", name: "Spinach & Ricotta Calzone Individual", icon: <FaBreadSlice /> },

  // Noodles
  { id: "PRD-0801040101-01", parentId: "PT-08010401-01", level: "product", name: "Lo Mein Regular", icon: <FaBowlRice /> },
  { id: "PRD-0801040102-01", parentId: "PT-08010401-02", level: "product", name: "Chow Mein Regular", icon: <FaBowlRice /> },

  // Fried Rice
  { id: "PRD-0801040201-01", parentId: "PT-08010402-01", level: "product", name: "Egg Fried Rice Regular", icon: <FaBowlRice /> },
  { id: "PRD-0801040202-01", parentId: "PT-08010402-02", level: "product", name: "Shrimp Fried Rice Regular", icon: <FaBowlRice /> },

  // Dim Sum
  { id: "PRD-0801040301-01", parentId: "PT-08010403-01", level: "product", name: "Pork Dumplings (6pc)", icon: <FaBowlFood /> },
  { id: "PRD-0801040302-01", parentId: "PT-08010403-02", level: "product", name: "Shrimp Har Gow (6pc)", icon: <FaBowlFood /> },

  // Stir Fry
  { id: "PRD-0801040401-01", parentId: "PT-08010404-01", level: "product", name: "Beef & Broccoli Stir Fry Regular", icon: <FaFire /> },
  { id: "PRD-0801040402-01", parentId: "PT-08010404-02", level: "product", name: "Kung Pao Chicken Regular", icon: <FaFire /> },

  // Sushi
  { id: "PRD-0801050101-01", parentId: "PT-08010501-01", level: "product", name: "California Roll (8pc)", icon: <FaFish /> },
  { id: "PRD-0801050102-01", parentId: "PT-08010501-02", level: "product", name: "Salmon Nigiri Set (6pc)", icon: <FaFish /> },

  // Ramen
  { id: "PRD-0801050201-01", parentId: "PT-08010502-01", level: "product", name: "Tonkotsu Ramen Bowl", icon: <FaBowlFood /> },
  { id: "PRD-0801050202-01", parentId: "PT-08010502-02", level: "product", name: "Miso Ramen Bowl", icon: <FaBowlFood /> },

  // Bento
  { id: "PRD-0801050301-01", parentId: "PT-08010503-01", level: "product", name: "Chicken Teriyaki Bento Box", icon: <FaBoxesStacked /> },
  { id: "PRD-0801050302-01", parentId: "PT-08010503-02", level: "product", name: "Salmon Bento Box", icon: <FaBoxesStacked /> },

  // Curry
  { id: "PRD-0801060101-01", parentId: "PT-08010601-01", level: "product", name: "Butter Chicken Curry Regular", icon: <FaPepperHot /> },
  { id: "PRD-0801060102-01", parentId: "PT-08010601-02", level: "product", name: "Chickpea Curry Regular", icon: <FaPepperHot /> },

  // Biryani
  { id: "PRD-0801060201-01", parentId: "PT-08010602-01", level: "product", name: "Chicken Biryani Regular", icon: <FaBowlRice /> },
  { id: "PRD-0801060202-01", parentId: "PT-08010602-02", level: "product", name: "Vegetable Biryani Regular", icon: <FaBowlRice /> },

  // Naan
  { id: "PRD-0801060301-01", parentId: "PT-08010603-01", level: "product", name: "Garlic Naan Single", icon: <FaBreadSlice /> },
  { id: "PRD-0801060302-01", parentId: "PT-08010603-02", level: "product", name: "Plain Naan Single", icon: <FaBreadSlice /> },

  // Shawarma
  { id: "PRD-0801070101-01", parentId: "PT-08010701-01", level: "product", name: "Chicken Shawarma Wrap Regular", icon: <FaDrumstickBite /> },
  { id: "PRD-0801070102-01", parentId: "PT-08010701-02", level: "product", name: "Beef Shawarma Plate Regular", icon: <FaDrumstickBite /> },

  // Falafel
  { id: "PRD-0801070201-01", parentId: "PT-08010702-01", level: "product", name: "Falafel Wrap Regular", icon: <FaBowlFood /> },
  { id: "PRD-0801070202-01", parentId: "PT-08010702-02", level: "product", name: "Falafel Plate Regular", icon: <FaBowlFood /> },

  // Kebabs
  { id: "PRD-0801070301-01", parentId: "PT-08010703-01", level: "product", name: "Chicken Kebab Skewer Single", icon: <FaFire /> },
  { id: "PRD-0801070302-01", parentId: "PT-08010703-02", level: "product", name: "Lamb Kebab Skewer Single", icon: <FaFire /> },

  // Korean BBQ
  { id: "PRD-0801080101-01", parentId: "PT-08010801-01", level: "product", name: "Bulgogi Plate", icon: <FaFire /> },
  { id: "PRD-0801080102-01", parentId: "PT-08010801-02", level: "product", name: "Galbi Short Ribs Plate", icon: <FaFire /> },

  // Bibimbap
  { id: "PRD-0801080201-01", parentId: "PT-08010802-01", level: "product", name: "Beef Bibimbap Bowl", icon: <FaBowlRice /> },
  { id: "PRD-0801080202-01", parentId: "PT-08010802-02", level: "product", name: "Vegetable Bibimbap Bowl", icon: <FaBowlRice /> },

  // Fried Chicken (Korean)
  { id: "PRD-0801080301-01", parentId: "PT-08010803-01", level: "product", name: "Yangnyeom Fried Chicken Bucket", icon: <FaDrumstickBite /> },
  { id: "PRD-0801080302-01", parentId: "PT-08010803-02", level: "product", name: "Soy Garlic Fried Chicken Bucket", icon: <FaDrumstickBite /> },

  // Pad Thai
  { id: "PRD-0801090101-01", parentId: "PT-08010901-01", level: "product", name: "Chicken Pad Thai Regular", icon: <FaBowlFood /> },
  { id: "PRD-0801090102-01", parentId: "PT-08010901-02", level: "product", name: "Shrimp Pad Thai Regular", icon: <FaBowlFood /> },

  // Thai Curry
  { id: "PRD-0801090201-01", parentId: "PT-08010902-01", level: "product", name: "Green Curry Regular", icon: <FaPepperHot /> },
  { id: "PRD-0801090202-01", parentId: "PT-08010902-02", level: "product", name: "Red Curry Regular", icon: <FaPepperHot /> },

  // Gyros
  { id: "PRD-0801100101-01", parentId: "PT-08011001-01", level: "product", name: "Chicken Gyro Regular", icon: <FaBreadSlice /> },
  { id: "PRD-0801100102-01", parentId: "PT-08011001-02", level: "product", name: "Lamb Gyro Regular", icon: <FaBreadSlice /> },

  // Hummus & Dips
  { id: "PRD-0801100201-01", parentId: "PT-08011002-01", level: "product", name: "Classic Hummus Small Tub", icon: <FaBowlFood /> },
  { id: "PRD-0801100202-01", parentId: "PT-08011002-02", level: "product", name: "Baba Ganoush Small Tub", icon: <FaBowlFood /> },

  // Pho
  { id: "PRD-0801110101-01", parentId: "PT-08011101-01", level: "product", name: "Beef Pho Bowl", icon: <FaBowlFood /> },
  { id: "PRD-0801110102-01", parentId: "PT-08011101-02", level: "product", name: "Chicken Pho Bowl", icon: <FaBowlFood /> },

  // Banh Mi
  { id: "PRD-0801110201-01", parentId: "PT-08011102-01", level: "product", name: "Grilled Pork Banh Mi Regular", icon: <FaBreadSlice /> },
  { id: "PRD-0801110202-01", parentId: "PT-08011102-02", level: "product", name: "Tofu Banh Mi Regular", icon: <FaBreadSlice /> },

  // Spring Rolls
  { id: "PRD-0801110301-01", parentId: "PT-08011103-01", level: "product", name: "Fresh Spring Rolls (4pc)", icon: <FaLeaf /> },
  { id: "PRD-0801110302-01", parentId: "PT-08011103-02", level: "product", name: "Fried Spring Rolls (4pc)", icon: <FaLeaf /> },

  // Adobo
  { id: "PRD-0801120101-01", parentId: "PT-08011201-01", level: "product", name: "Chicken Adobo Plate", icon: <FaDrumstickBite /> },
  { id: "PRD-0801120102-01", parentId: "PT-08011201-02", level: "product", name: "Pork Adobo Plate", icon: <FaDrumstickBite /> },

  // Lumpia
  { id: "PRD-0801120201-01", parentId: "PT-08011202-01", level: "product", name: "Pork Lumpia (6pc)", icon: <FaLeaf /> },
  { id: "PRD-0801120202-01", parentId: "PT-08011202-02", level: "product", name: "Vegetable Lumpia (6pc)", icon: <FaLeaf /> },

  // Sinigang
  { id: "PRD-0801120301-01", parentId: "PT-08011203-01", level: "product", name: "Pork Sinigang Bowl", icon: <FaBowlFood /> },
  { id: "PRD-0801120302-01", parentId: "PT-08011203-02", level: "product", name: "Shrimp Sinigang Bowl", icon: <FaBowlFood /> },

  // Jerk Chicken
  { id: "PRD-0801130101-01", parentId: "PT-08011301-01", level: "product", name: "Jerk Chicken Plate Regular", icon: <FaPepperHot /> },
  { id: "PRD-0801130102-01", parentId: "PT-08011301-02", level: "product", name: "Jerk Chicken Wrap Regular", icon: <FaPepperHot /> },

  // Curry Goat
  { id: "PRD-0801130201-01", parentId: "PT-08011302-01", level: "product", name: "Curry Goat Plate Regular", icon: <FaPepperHot /> },

  // Rice & Peas
  { id: "PRD-0801130301-01", parentId: "PT-08011303-01", level: "product", name: "Rice & Peas Side Regular", icon: <FaBowlRice /> },

  // Jollof Rice
  { id: "PRD-0801140101-01", parentId: "PT-08011401-01", level: "product", name: "Chicken Jollof Rice Regular", icon: <FaBowlRice /> },
  { id: "PRD-0801140102-01", parentId: "PT-08011401-02", level: "product", name: "Vegetable Jollof Rice Regular", icon: <FaBowlRice /> },

  // Suya
  { id: "PRD-0801140201-01", parentId: "PT-08011402-01", level: "product", name: "Beef Suya Skewers (4pc)", icon: <FaFire /> },
  { id: "PRD-0801140202-01", parentId: "PT-08011402-02", level: "product", name: "Chicken Suya Skewers (4pc)", icon: <FaFire /> },

  // Stews
  { id: "PRD-0801140301-01", parentId: "PT-08011403-01", level: "product", name: "Peanut Stew Bowl", icon: <FaBowlFood /> },
  { id: "PRD-0801140302-01", parentId: "PT-08011403-02", level: "product", name: "Egusi Stew Bowl", icon: <FaBowlFood /> },

  // Souvlaki
  { id: "PRD-0801150101-01", parentId: "PT-08011501-01", level: "product", name: "Chicken Souvlaki Skewer Single", icon: <FaDrumstickBite /> },
  { id: "PRD-0801150102-01", parentId: "PT-08011501-02", level: "product", name: "Pork Souvlaki Skewer Single", icon: <FaDrumstickBite /> },

  // Gyro Wraps
  { id: "PRD-0801150201-01", parentId: "PT-08011502-01", level: "product", name: "Classic Gyro Wrap Regular", icon: <FaBreadSlice /> },

  // Greek Salad
  { id: "PRD-0801150301-01", parentId: "PT-08011503-01", level: "product", name: "Traditional Greek Salad Regular", icon: <FaLeaf /> },

  // Tapas
  { id: "PRD-0801160101-01", parentId: "PT-08011601-01", level: "product", name: "Patatas Bravas Small Plate", icon: <FaShrimp /> },
  { id: "PRD-0801160102-01", parentId: "PT-08011601-02", level: "product", name: "Gambas al Ajillo Small Plate", icon: <FaShrimp /> },

  // Paella
  { id: "PRD-0801160201-01", parentId: "PT-08011602-01", level: "product", name: "Seafood Paella Regular", icon: <FaBowlRice /> },
  { id: "PRD-0801160202-01", parentId: "PT-08011602-02", level: "product", name: "Chicken Paella Regular", icon: <FaBowlRice /> },

  // Churros
  { id: "PRD-0801160301-01", parentId: "PT-08011603-01", level: "product", name: "Classic Churros (6pc)", icon: <FaBreadSlice /> },

  // Crepes
  { id: "PRD-0801170101-01", parentId: "PT-08011701-01", level: "product", name: "Nutella Sweet Crepe", icon: <FaBreadSlice /> },
  { id: "PRD-0801170102-01", parentId: "PT-08011701-02", level: "product", name: "Ham & Cheese Savory Crepe", icon: <FaBreadSlice /> },

  // Baguette Sandwiches
  { id: "PRD-0801170201-01", parentId: "PT-08011702-01", level: "product", name: "Ham & Cheese Baguette Regular", icon: <FaBreadSlice /> },

  // Pastries
  { id: "PRD-0801170301-01", parentId: "PT-08011703-01", level: "product", name: "Butter Croissant", icon: <FaCookieBite /> },
  { id: "PRD-0801170302-01", parentId: "PT-08011703-02", level: "product", name: "Pain au Chocolat Single", icon: <FaCookieBite /> },

  // Churrasco
  { id: "PRD-0801180101-01", parentId: "PT-08011801-01", level: "product", name: "Picanha Skewer Single", icon: <FaFire /> },
  { id: "PRD-0801180102-01", parentId: "PT-08011801-02", level: "product", name: "Mixed Grill Platter Regular", icon: <FaFire /> },

  // Feijoada
  { id: "PRD-0801180201-01", parentId: "PT-08011802-01", level: "product", name: "Traditional Feijoada Bowl", icon: <FaBowlFood /> },

  // Pão de Queijo
  { id: "PRD-0801180301-01", parentId: "PT-08011803-01", level: "product", name: "Pão de Queijo (6pc)", icon: <FaBreadSlice /> },

  // Bratwurst
  { id: "PRD-0801190101-01", parentId: "PT-08011901-01", level: "product", name: "Grilled Bratwurst Single", icon: <FaHotdog /> },
  { id: "PRD-0801190102-01", parentId: "PT-08011901-02", level: "product", name: "Currywurst Regular", icon: <FaHotdog /> },

  // Schnitzel
  { id: "PRD-0801190201-01", parentId: "PT-08011902-01", level: "product", name: "Pork Schnitzel Plate", icon: <FaDrumstickBite /> },
  { id: "PRD-0801190202-01", parentId: "PT-08011902-02", level: "product", name: "Chicken Schnitzel Plate", icon: <FaDrumstickBite /> },

  // Pretzels
  { id: "PRD-0801190301-01", parentId: "PT-08011903-01", level: "product", name: "Classic Soft Pretzel Single", icon: <FaBreadSlice /> },

  // Fish & Chips
  { id: "PRD-0801200101-01", parentId: "PT-08012001-01", level: "product", name: "Cod Fish & Chips Regular", icon: <FaFish /> },
  { id: "PRD-0801200102-01", parentId: "PT-08012001-02", level: "product", name: "Haddock Fish & Chips Regular", icon: <FaFish /> },

  // Meat Pies
  { id: "PRD-0801200201-01", parentId: "PT-08012002-01", level: "product", name: "Steak & Ale Pie Regular", icon: <FaBreadSlice /> },
  { id: "PRD-0801200202-01", parentId: "PT-08012002-02", level: "product", name: "Chicken & Mushroom Pie Regular", icon: <FaBreadSlice /> },

  // Sunday Roast
  { id: "PRD-0801200301-01", parentId: "PT-08012003-01", level: "product", name: "Roast Beef Dinner Regular", icon: <FaDrumstickBite /> },
  { id: "PRD-0801200302-01", parentId: "PT-08012003-02", level: "product", name: "Roast Chicken Dinner Regular", icon: <FaDrumstickBite /> },

  // Ceviche
  { id: "PRD-0801210101-01", parentId: "PT-08012101-01", level: "product", name: "Classic Fish Ceviche Regular", icon: <FaShrimp /> },
  { id: "PRD-0801210102-01", parentId: "PT-08012101-02", level: "product", name: "Mixed Seafood Ceviche Regular", icon: <FaShrimp /> },

  // Lomo Saltado
  { id: "PRD-0801210201-01", parentId: "PT-08012102-01", level: "product", name: "Beef Lomo Saltado Regular", icon: <FaBowlFood /> },

  // Injera Platters
  { id: "PRD-0801220101-01", parentId: "PT-08012201-01", level: "product", name: "Vegetarian Combo Platter Regular", icon: <FaBowlFood /> },
  { id: "PRD-0801220102-01", parentId: "PT-08012201-02", level: "product", name: "Meat Combo Platter Regular", icon: <FaBowlFood /> },

  // Wat (Stews)
  { id: "PRD-0801220201-01", parentId: "PT-08012202-01", level: "product", name: "Doro Wat Bowl", icon: <FaPepperHot /> },
  { id: "PRD-0801220202-01", parentId: "PT-08012202-02", level: "product", name: "Misir Wat Bowl", icon: <FaPepperHot /> },

  // Doner Kebab
  { id: "PRD-0801230101-01", parentId: "PT-08012301-01", level: "product", name: "Doner Kebab Wrap Regular", icon: <FaDrumstickBite /> },
  { id: "PRD-0801230102-01", parentId: "PT-08012301-02", level: "product", name: "Doner Kebab Plate Regular", icon: <FaDrumstickBite /> },

  // Pide
  { id: "PRD-0801230201-01", parentId: "PT-08012302-01", level: "product", name: "Cheese Pide Regular", icon: <FaBreadSlice /> },
  { id: "PRD-0801230202-01", parentId: "PT-08012302-02", level: "product", name: "Ground Beef Pide Regular", icon: <FaBreadSlice /> },

  // Baklava
  { id: "PRD-0801230301-01", parentId: "PT-08012303-01", level: "product", name: "Classic Baklava (4pc)", icon: <FaCookieBite /> },

  // Poke Bowls
  { id: "PRD-0801240101-01", parentId: "PT-08012401-01", level: "product", name: "Ahi Tuna Poke Bowl Regular", icon: <FaFish /> },
  { id: "PRD-0801240102-01", parentId: "PT-08012401-02", level: "product", name: "Salmon Poke Bowl Regular", icon: <FaFish /> },

  // Plate Lunch
  { id: "PRD-0801240201-01", parentId: "PT-08012402-01", level: "product", name: "Kalua Pork Plate Regular", icon: <FaBowlRice /> },
  { id: "PRD-0801240202-01", parentId: "PT-08012402-02", level: "product", name: "Teriyaki Chicken Plate Regular", icon: <FaBowlRice /> },

  // Loco Moco
  { id: "PRD-0801240301-01", parentId: "PT-08012403-01", level: "product", name: "Classic Loco Moco Regular", icon: <FaBowlFood /> },
];

/* ───────────────────────────────────────────────────────────
   GROCERY   (parentId: 0802)
   Full supermarket-style category range
   ─────────────────────────────────────────────────────────── */
export const CategoryGrocery: CategoryItem[] = [
  { id: "080201", parentId: "0802", level: "category", name: "Fresh Produce",        icon: <FaAppleWhole /> },
  { id: "080202", parentId: "0802", level: "category", name: "Dairy",                icon: <FaCheese /> },
  { id: "080203", parentId: "0802", level: "category", name: "Eggs",                 icon: <FaEgg /> },
  { id: "080204", parentId: "0802", level: "category", name: "Meat",                 icon: <FaDrumstickBite /> },
  { id: "080205", parentId: "0802", level: "category", name: "Poultry",              icon: <FaDrumstickBite /> },
  { id: "080206", parentId: "0802", level: "category", name: "Seafood",              icon: <FaFish /> },
  { id: "080207", parentId: "0802", level: "category", name: "Bakery",               icon: <FaBreadSlice /> },
  { id: "080208", parentId: "0802", level: "category", name: "Grains",               icon: <FaBowlRice /> },
  { id: "080209", parentId: "0802", level: "category", name: "Pasta",                icon: <FaBowlFood /> },
  { id: "080210", parentId: "0802", level: "category", name: "Canned Goods",         icon: <FaBoxesStacked /> },
  { id: "080211", parentId: "0802", level: "category", name: "Cooking Oils",         icon: <FaWineBottle /> },
  { id: "080212", parentId: "0802", level: "category", name: "Spices",               icon: <FaPepperHot /> },
  { id: "080213", parentId: "0802", level: "category", name: "Sauces",               icon: <FaWineBottle /> },
  { id: "080214", parentId: "0802", level: "category", name: "Condiments",           icon: <FaWineBottle /> },
  { id: "080215", parentId: "0802", level: "category", name: "Frozen Foods",         icon: <FaSnowflake /> },
  { id: "080216", parentId: "0802", level: "category", name: "Beverages",            icon: <FaBottleWater /> },
  { id: "080217", parentId: "0802", level: "category", name: "Snacks",               icon: <FaBowlFood /> },
  { id: "080218", parentId: "0802", level: "category", name: "Confectionery",        icon: <FaCandyCane /> },
  { id: "080219", parentId: "0802", level: "category", name: "Cleaning Supplies",    icon: <FaPumpSoap /> },
  { id: "080220", parentId: "0802", level: "category", name: "Paper Products",       icon: <FaToiletPaper /> },
  { id: "080221", parentId: "0802", level: "category", name: "Laundry Care",         icon: <FaPumpSoap /> },
  { id: "080222", parentId: "0802", level: "category", name: "Kitchen Supplies",     icon: <FaUtensils /> },
  { id: "080223", parentId: "0802", level: "category", name: "Sanitary Products",    icon: <FaHeart /> },
  { id: "080224", parentId: "0802", level: "category", name: "Personal Care",        icon: <FaPumpSoap /> },
  { id: "080225", parentId: "0802", level: "category", name: "Oral Care",            icon: <FaTooth /> },
  { id: "080226", parentId: "0802", level: "category", name: "Skin Care",            icon: <FaSpa /> },
  { id: "080227", parentId: "0802", level: "category", name: "Baby Food",            icon: <FaBaby /> },
  { id: "080228", parentId: "0802", level: "category", name: "Diapers",              icon: <FaBaby /> },
  { id: "080229", parentId: "0802", level: "category", name: "Health",               icon: <FaCross /> },
  { id: "080230", parentId: "0802", level: "category", name: "Pharmacy",             icon: <FaCross /> },
];

export const SubCategoryGrocery: CategoryItem[] = [
  // Fresh Produce (080201)
  { id: "08020101", parentId: "080201", level: "subCategory", name: "Fruits",           icon: <FaAppleWhole /> },
  { id: "08020102", parentId: "080201", level: "subCategory", name: "Vegetables",       icon: <FaCarrot /> },
  { id: "08020103", parentId: "080201", level: "subCategory", name: "Fresh Herbs",      icon: <FaLeaf /> },
  { id: "08020104", parentId: "080201", level: "subCategory", name: "Organic Produce",  icon: <FaSeedling /> },
  { id: "08020105", parentId: "080201", level: "subCategory", name: "Tubers",           icon: <FaCarrot /> },
  { id: "08020106", parentId: "080201", level: "subCategory", name: "Legumes",          icon: <FaSeedling /> },

  // Dairy (080202)
  { id: "08020201", parentId: "080202", level: "subCategory", name: "Milk",         icon: <FaBottleWater /> },
  { id: "08020202", parentId: "080202", level: "subCategory", name: "Cheese",       icon: <FaCheese /> },
  { id: "08020203", parentId: "080202", level: "subCategory", name: "Yogurt",       icon: <FaBowlFood /> },
  { id: "08020204", parentId: "080202", level: "subCategory", name: "Butter",       icon: <FaCheese /> },
  { id: "08020205", parentId: "080202", level: "subCategory", name: "Cream",        icon: <FaBottleWater /> },
  { id: "08020206", parentId: "080202", level: "subCategory", name: "Margarine",    icon: <FaCheese /> },

  // Eggs (080203)
  { id: "08020301", parentId: "080203", level: "subCategory", name: "Chicken Eggs", icon: <FaEgg /> },
  { id: "08020302", parentId: "080203", level: "subCategory", name: "Duck Eggs",    icon: <FaEgg /> },
  { id: "08020303", parentId: "080203", level: "subCategory", name: "Quail Eggs",   icon: <FaEgg /> },
  { id: "08020304", parentId: "080203", level: "subCategory", name: "Ostrich Eggs", icon: <FaEgg /> },

  // Meat (080204)
  { id: "08020401", parentId: "080204", level: "subCategory", name: "Beef",     icon: <FaDrumstickBite /> },
  { id: "08020402", parentId: "080204", level: "subCategory", name: "Goat",     icon: <FaDrumstickBite /> },
  { id: "08020403", parentId: "080204", level: "subCategory", name: "Mutton",   icon: <FaDrumstickBite /> },
  { id: "08020404", parentId: "080204", level: "subCategory", name: "Pork",     icon: <FaDrumstickBite /> },
  { id: "08020405", parentId: "080204", level: "subCategory", name: "Ostrich",  icon: <FaDrumstickBite /> },
  { id: "08020406", parentId: "080204", level: "subCategory", name: "Rabbit",   icon: <FaDrumstickBite /> },
  { id: "08020407", parentId: "080204", level: "subCategory", name: "Game Meat", icon: <FaDrumstickBite /> },
  { id: "08020408", parentId: "080204", level: "subCategory", name: "Offal",    icon: <FaDrumstickBite /> },
  { id: "08020409", parentId: "080204", level: "subCategory", name: "Sausages", icon: <FaHotdog /> },
  { id: "08020410", parentId: "080204", level: "subCategory", name: "Bacon",    icon: <FaDrumstickBite /> },
  { id: "08020411", parentId: "080204", level: "subCategory", name: "Processed Meat", icon: <FaDrumstickBite /> },

  // Poultry (080205)
  { id: "08020501", parentId: "080205", level: "subCategory", name: "Chicken",       icon: <FaDrumstickBite /> },
  { id: "08020502", parentId: "080205", level: "subCategory", name: "Turkey",        icon: <FaDrumstickBite /> },
  { id: "08020503", parentId: "080205", level: "subCategory", name: "Duck",          icon: <FaDrumstickBite /> },
  { id: "08020504", parentId: "080205", level: "subCategory", name: "Quail",         icon: <FaDrumstickBite /> },
  { id: "08020505", parentId: "080205", level: "subCategory", name: "Guinea Fowl",   icon: <FaDrumstickBite /> },
  { id: "08020506", parentId: "080205", level: "subCategory", name: "Chicken Wings", icon: <FaDrumstickBite /> },
  { id: "08020507", parentId: "080205", level: "subCategory", name: "Chicken Breast", icon: <FaDrumstickBite /> },

  // Seafood (080206)
  { id: "08020601", parentId: "080206", level: "subCategory", name: "Fresh Fish",  icon: <FaFish /> },
  { id: "08020602", parentId: "080206", level: "subCategory", name: "Dried Fish",  icon: <FaFish /> },
  { id: "08020603", parentId: "080206", level: "subCategory", name: "Prawns",      icon: <FaShrimp /> },
  { id: "08020604", parentId: "080206", level: "subCategory", name: "Crab",        icon: <FaShrimp /> },
  { id: "08020605", parentId: "080206", level: "subCategory", name: "Lobster",     icon: <FaShrimp /> },
  { id: "08020606", parentId: "080206", level: "subCategory", name: "Tilapia",     icon: <FaFish /> },
  { id: "08020607", parentId: "080206", level: "subCategory", name: "Nile Perch",  icon: <FaFish /> },
  { id: "08020608", parentId: "080206", level: "subCategory", name: "Omena",       icon: <FaFish /> },

  // Bakery (080207)
  { id: "08020701", parentId: "080207", level: "subCategory", name: "Bread",        icon: <FaBreadSlice /> },
  { id: "08020702", parentId: "080207", level: "subCategory", name: "Buns",         icon: <FaBreadSlice /> },
  { id: "08020703", parentId: "080207", level: "subCategory", name: "Pastries",     icon: <FaCookieBite /> },
  { id: "08020704", parentId: "080207", level: "subCategory", name: "Cakes",        icon: <FaCookieBite /> },
  { id: "08020705", parentId: "080207", level: "subCategory", name: "Cookies",      icon: <FaCookieBite /> },
  { id: "08020706", parentId: "080207", level: "subCategory", name: "Doughnuts",    icon: <FaCookieBite /> },
  { id: "08020707", parentId: "080207", level: "subCategory", name: "Chapati",      icon: <FaBreadSlice /> },
  { id: "08020708", parentId: "080207", level: "subCategory", name: "Mandazi",      icon: <FaBreadSlice /> },

  // Grains (080208)
  { id: "08020801", parentId: "080208", level: "subCategory", name: "Rice",         icon: <FaBowlRice /> },
  { id: "08020802", parentId: "080208", level: "subCategory", name: "Maize Flour",  icon: <FaBowlRice /> },
  { id: "08020803", parentId: "080208", level: "subCategory", name: "Wheat Flour",  icon: <FaBowlRice /> },
  { id: "08020804", parentId: "080208", level: "subCategory", name: "Millet",       icon: <FaBowlRice /> },
  { id: "08020805", parentId: "080208", level: "subCategory", name: "Sorghum",      icon: <FaBowlRice /> },
  { id: "08020806", parentId: "080208", level: "subCategory", name: "Oats",         icon: <FaBowlRice /> },
  { id: "08020807", parentId: "080208", level: "subCategory", name: "Cereal",       icon: <FaBowlRice /> },

  // Pasta (080209)
  { id: "08020901", parentId: "080209", level: "subCategory", name: "Spaghetti",    icon: <FaBowlFood /> },
  { id: "08020902", parentId: "080209", level: "subCategory", name: "Macaroni",     icon: <FaBowlFood /> },
  { id: "08020903", parentId: "080209", level: "subCategory", name: "Noodles",      icon: <FaBowlFood /> },

  // Canned Goods (080210)
  { id: "08021001", parentId: "080210", level: "subCategory", name: "Canned Vegetables", icon: <FaBoxesStacked /> },
  { id: "08021002", parentId: "080210", level: "subCategory", name: "Canned Fish",       icon: <FaBoxesStacked /> },
  { id: "08021003", parentId: "080210", level: "subCategory", name: "Canned Meat",       icon: <FaBoxesStacked /> },
  { id: "08021004", parentId: "080210", level: "subCategory", name: "Canned Beans",      icon: <FaBoxesStacked /> },
  { id: "08021005", parentId: "080210", level: "subCategory", name: "Canned Fruit",      icon: <FaBoxesStacked /> },

  // Cooking Oils (080211)
  { id: "08021101", parentId: "080211", level: "subCategory", name: "Vegetable Oil", icon: <FaWineBottle /> },
  { id: "08021102", parentId: "080211", level: "subCategory", name: "Sunflower Oil", icon: <FaWineBottle /> },
  { id: "08021103", parentId: "080211", level: "subCategory", name: "Olive Oil",     icon: <FaWineBottle /> },
  { id: "08021104", parentId: "080211", level: "subCategory", name: "Coconut Oil",   icon: <FaWineBottle /> },
  { id: "08021105", parentId: "080211", level: "subCategory", name: "Cooking Fat",   icon: <FaWineBottle /> },
  { id: "08021106", parentId: "080211", level: "subCategory", name: "Ghee",          icon: <FaWineBottle /> },

  // Spices (080212)
  { id: "08021201", parentId: "080212", level: "subCategory", name: "Whole Spices",     icon: <FaPepperHot /> },
  { id: "08021202", parentId: "080212", level: "subCategory", name: "Ground Spices",    icon: <FaPepperHot /> },
  { id: "08021203", parentId: "080212", level: "subCategory", name: "Seasoning Blends", icon: <FaPepperHot /> },
  { id: "08021204", parentId: "080212", level: "subCategory", name: "Salt",             icon: <FaPepperHot /> },
  { id: "08021205", parentId: "080212", level: "subCategory", name: "Pepper",           icon: <FaPepperHot /> },
  { id: "08021206", parentId: "080212", level: "subCategory", name: "Stock Cubes",      icon: <FaPepperHot /> },

  // Sauces (080213)
  { id: "08021301", parentId: "080213", level: "subCategory", name: "Tomato Sauce",    icon: <FaWineBottle /> },
  { id: "08021302", parentId: "080213", level: "subCategory", name: "Soy Sauce",       icon: <FaWineBottle /> },
  { id: "08021303", parentId: "080213", level: "subCategory", name: "Hot Sauce",       icon: <FaPepperHot /> },
  { id: "08021304", parentId: "080213", level: "subCategory", name: "Barbecue Sauce",  icon: <FaWineBottle /> },
  { id: "08021305", parentId: "080213", level: "subCategory", name: "Cooking Sauces",  icon: <FaWineBottle /> },

  // Condiments (080214)
  { id: "08021401", parentId: "080214", level: "subCategory", name: "Ketchup",     icon: <FaWineBottle /> },
  { id: "08021402", parentId: "080214", level: "subCategory", name: "Mayonnaise",  icon: <FaWineBottle /> },
  { id: "08021403", parentId: "080214", level: "subCategory", name: "Mustard",     icon: <FaWineBottle /> },
  { id: "08021404", parentId: "080214", level: "subCategory", name: "Vinegar",     icon: <FaWineBottle /> },
  { id: "08021405", parentId: "080214", level: "subCategory", name: "Jam",         icon: <FaWineBottle /> },
  { id: "08021406", parentId: "080214", level: "subCategory", name: "Honey",       icon: <FaWineBottle /> },
  { id: "08021407", parentId: "080214", level: "subCategory", name: "Peanut Butter", icon: <FaWineBottle /> },

  // Frozen Foods (080215)
  { id: "08021501", parentId: "080215", level: "subCategory", name: "Frozen Meals",         icon: <FaSnowflake /> },
  { id: "08021502", parentId: "080215", level: "subCategory", name: "Frozen Vegetables",     icon: <FaSnowflake /> },
  { id: "08021503", parentId: "080215", level: "subCategory", name: "Frozen Fruit",          icon: <FaSnowflake /> },
  { id: "08021504", parentId: "080215", level: "subCategory", name: "Ice Cream",             icon: <FaIceCream /> },
  { id: "08021505", parentId: "080215", level: "subCategory", name: "Frozen Meat",           icon: <FaSnowflake /> },
  { id: "08021506", parentId: "080215", level: "subCategory", name: "Frozen Seafood",        icon: <FaSnowflake /> },
  { id: "08021507", parentId: "080215", level: "subCategory", name: "Frozen Fries",          icon: <FaSnowflake /> },

  // Beverages (080216)
  { id: "08021601", parentId: "080216", level: "subCategory", name: "Soft Drinks",        icon: <FaBottleWater /> },
  { id: "08021602", parentId: "080216", level: "subCategory", name: "Juices",              icon: <FaBottleWater /> },
  { id: "08021603", parentId: "080216", level: "subCategory", name: "Water",               icon: <FaBottleWater /> },
  { id: "08021604", parentId: "080216", level: "subCategory", name: "Coffee",              icon: <FaMugSaucer /> },
  { id: "08021605", parentId: "080216", level: "subCategory", name: "Tea",                 icon: <FaMugSaucer /> },
  { id: "08021606", parentId: "080216", level: "subCategory", name: "Energy Drinks",       icon: <FaBottleWater /> },
  { id: "08021607", parentId: "080216", level: "subCategory", name: "Beer",                icon: <FaBeerMugEmpty /> },
  { id: "08021608", parentId: "080216", level: "subCategory", name: "Wine",                icon: <FaWineBottle /> },
  { id: "08021609", parentId: "080216", level: "subCategory", name: "Spirits",             icon: <FaWineBottle /> },

  // Snacks (080217)
  { id: "08021701", parentId: "080217", level: "subCategory", name: "Chips",           icon: <FaBowlFood /> },
  { id: "08021702", parentId: "080217", level: "subCategory", name: "Crisps",          icon: <FaBowlFood /> },
  { id: "08021703", parentId: "080217", level: "subCategory", name: "Popcorn",         icon: <FaBowlFood /> },
  { id: "08021704", parentId: "080217", level: "subCategory", name: "Crackers",        icon: <FaBowlFood /> },
  { id: "08021705", parentId: "080217", level: "subCategory", name: "Nuts",            icon: <FaSeedling /> },
  { id: "08021706", parentId: "080217", level: "subCategory", name: "Trail Mix",       icon: <FaSeedling /> },
  { id: "08021707", parentId: "080217", level: "subCategory", name: "Dried Fruit",     icon: <FaAppleWhole /> },

  // Confectionery (080218)
  { id: "08021801", parentId: "080218", level: "subCategory", name: "Chocolate",   icon: <FaCookieBite /> },
  { id: "08021802", parentId: "080218", level: "subCategory", name: "Candy",       icon: <FaCandyCane /> },
  { id: "08021803", parentId: "080218", level: "subCategory", name: "Gum",         icon: <FaCandyCane /> },
  { id: "08021804", parentId: "080218", level: "subCategory", name: "Mints",       icon: <FaCandyCane /> },

  // Cleaning Supplies (080219)
  { id: "08021901", parentId: "080219", level: "subCategory", name: "Detergents",     icon: <FaPumpSoap /> },
  { id: "08021902", parentId: "080219", level: "subCategory", name: "Dishwashing",    icon: <FaPumpSoap /> },
  { id: "08021903", parentId: "080219", level: "subCategory", name: "Disinfectants",  icon: <FaPumpSoap /> },
  { id: "08021904", parentId: "080219", level: "subCategory", name: "Air Fresheners", icon: <FaPumpSoap /> },
  { id: "08021905", parentId: "080219", level: "subCategory", name: "Insecticides",   icon: <FaPumpSoap /> },
  { id: "08021906", parentId: "080219", level: "subCategory", name: "Toilet Cleaners", icon: <FaPumpSoap /> },
  { id: "08021907", parentId: "080219", level: "subCategory", name: "Floor Cleaners", icon: <FaPumpSoap /> },
  { id: "08021908", parentId: "080219", level: "subCategory", name: "Bleach",         icon: <FaPumpSoap /> },

  // Paper Products (080220)
  { id: "08022001", parentId: "080220", level: "subCategory", name: "Toilet Paper",  icon: <FaToiletPaper /> },
  { id: "08022002", parentId: "080220", level: "subCategory", name: "Paper Towels",  icon: <FaToiletPaper /> },
  { id: "08022003", parentId: "080220", level: "subCategory", name: "Tissues",       icon: <FaToiletPaper /> },
  { id: "08022004", parentId: "080220", level: "subCategory", name: "Napkins",       icon: <FaToiletPaper /> },
  { id: "08022005", parentId: "080220", level: "subCategory", name: "Foil",          icon: <FaToiletPaper /> },
  { id: "08022006", parentId: "080220", level: "subCategory", name: "Cling Wrap",    icon: <FaToiletPaper /> },

  // Laundry Care (080221)
  { id: "08022101", parentId: "080221", level: "subCategory", name: "Washing Powder", icon: <FaPumpSoap /> },
  { id: "08022102", parentId: "080221", level: "subCategory", name: "Fabric Softener", icon: <FaPumpSoap /> },
  { id: "08022103", parentId: "080221", level: "subCategory", name: "Stain Remover",  icon: <FaPumpSoap /> },
  { id: "08022104", parentId: "080221", level: "subCategory", name: "Bar Soap",       icon: <FaPumpSoap /> },

  // Kitchen Supplies (080222)
  { id: "08022201", parentId: "080222", level: "subCategory", name: "Storage Containers", icon: <FaBoxesStacked /> },
  { id: "08022202", parentId: "080222", level: "subCategory", name: "Disposable Utensils", icon: <FaUtensils /> },
  { id: "08022203", parentId: "080222", level: "subCategory", name: "Trash Bags",         icon: <FaBoxesStacked /> },
  { id: "08022204", parentId: "080222", level: "subCategory", name: "Sponges",            icon: <FaPumpSoap /> },

  // Sanitary Products (080223)
  { id: "08022301", parentId: "080223", level: "subCategory", name: "Sanitary Pads",    icon: <FaHeart /> },
  { id: "08022302", parentId: "080223", level: "subCategory", name: "Tampons",          icon: <FaHeart /> },
  { id: "08022303", parentId: "080223", level: "subCategory", name: "Panty Liners",     icon: <FaHeart /> },
  { id: "08022304", parentId: "080223", level: "subCategory", name: "Menstrual Cups",   icon: <FaHeart /> },

  // Personal Care (080224)
  { id: "08022401", parentId: "080224", level: "subCategory", name: "Body Wash",     icon: <FaPumpSoap /> },
  { id: "08022402", parentId: "080224", level: "subCategory", name: "Deodorant",     icon: <FaPumpSoap /> },
  { id: "08022403", parentId: "080224", level: "subCategory", name: "Shampoo",       icon: <FaPumpSoap /> },
  { id: "08022404", parentId: "080224", level: "subCategory", name: "Conditioner",   icon: <FaPumpSoap /> },
  { id: "08022405", parentId: "080224", level: "subCategory", name: "Shaving Care",  icon: <FaPumpSoap /> },
  { id: "08022406", parentId: "080224", level: "subCategory", name: "Hand Wash",     icon: <FaPumpSoap /> },

  // Oral Care (080225)
  { id: "08022501", parentId: "080225", level: "subCategory", name: "Toothpaste",   icon: <FaTooth /> },
  { id: "08022502", parentId: "080225", level: "subCategory", name: "Toothbrushes", icon: <FaTooth /> },
  { id: "08022503", parentId: "080225", level: "subCategory", name: "Mouthwash",    icon: <FaTooth /> },
  { id: "08022504", parentId: "080225", level: "subCategory", name: "Dental Floss", icon: <FaTooth /> },

  // Skin Care (080226)
  { id: "08022601", parentId: "080226", level: "subCategory", name: "Moisturizers", icon: <FaSpa /> },
  { id: "08022602", parentId: "080226", level: "subCategory", name: "Sunscreen",    icon: <FaSpa /> },
  { id: "08022603", parentId: "080226", level: "subCategory", name: "Face Wash",    icon: <FaSpa /> },
  { id: "08022604", parentId: "080226", level: "subCategory", name: "Petroleum Jelly", icon: <FaSpa /> },
  { id: "08022605", parentId: "080226", level: "subCategory", name: "Body Lotion",  icon: <FaSpa /> },

  // Baby Food (080227)
  { id: "08022701", parentId: "080227", level: "subCategory", name: "Infant Formula", icon: <FaBaby /> },
  { id: "08022702", parentId: "080227", level: "subCategory", name: "Baby Cereal",    icon: <FaBaby /> },
  { id: "08022703", parentId: "080227", level: "subCategory", name: "Baby Puree",     icon: <FaBaby /> },
  { id: "08022704", parentId: "080227", level: "subCategory", name: "Baby Snacks",    icon: <FaBaby /> },

  // Diapers (080228)
  { id: "08022801", parentId: "080228", level: "subCategory", name: "Baby Diapers", icon: <FaBaby /> },
  { id: "08022802", parentId: "080228", level: "subCategory", name: "Baby Wipes",   icon: <FaBaby /> },
  { id: "08022803", parentId: "080228", level: "subCategory", name: "Adult Diapers", icon: <FaBaby /> },
  { id: "08022804", parentId: "080228", level: "subCategory", name: "Training Pants", icon: <FaBaby /> },

  // Health (080229)
  { id: "08022901", parentId: "080229", level: "subCategory", name: "Vitamins",         icon: <FaCross /> },
  { id: "08022902", parentId: "080229", level: "subCategory", name: "Supplements",      icon: <FaCross /> },
  { id: "08022903", parentId: "080229", level: "subCategory", name: "First Aid",        icon: <FaCross /> },
  { id: "08022904", parentId: "080229", level: "subCategory", name: "Medical Supplies", icon: <FaCross /> },

  // Pharmacy (080230)
  { id: "08023001", parentId: "080230", level: "subCategory", name: "Pain Relief",     icon: <FaCross /> },
  { id: "08023002", parentId: "080230", level: "subCategory", name: "Cold & Flu",      icon: <FaCross /> },
  { id: "08023003", parentId: "080230", level: "subCategory", name: "Digestive Health", icon: <FaCross /> },
  { id: "08023004", parentId: "080230", level: "subCategory", name: "Prescription Medicine", icon: <FaCross /> },
];



/* ───────────────────────────────────────────────────────────
   FARM PRODUCE   (parentId: 0803)
   Categories organized by farm output type
   ─────────────────────────────────────────────────────────── */
export const CategoryFarmProduce: CategoryItem[] = [
  { id: "080301", parentId: "0803", level: "category", name: "Vegetables",       icon: <FaCarrot /> },
  { id: "080302", parentId: "0803", level: "category", name: "Fruits",           icon: <FaAppleWhole /> },
  { id: "080303", parentId: "0803", level: "category", name: "Grains",           icon: <FaBowlRice /> },
  { id: "080304", parentId: "0803", level: "category", name: "Legumes",         icon: <FaSeedling /> },
  { id: "080305", parentId: "0803", level: "category", name: "Tubers",          icon: <FaCarrot /> },
  { id: "080306", parentId: "0803", level: "category", name: "Herbs",           icon: <FaLeaf /> },
  { id: "080307", parentId: "0803", level: "category", name: "Nuts",            icon: <FaSeedling /> },
  { id: "080308", parentId: "0803", level: "category", name: "Seeds",           icon: <FaSeedling /> },
  { id: "080309", parentId: "0803", level: "category", name: "Cattle",          icon: <FaDrumstickBite /> },
  { id: "080310", parentId: "0803", level: "category", name: "Goats",           icon: <FaDrumstickBite /> },
  { id: "080311", parentId: "0803", level: "category", name: "Sheep",           icon: <FaDrumstickBite /> },
  { id: "080312", parentId: "0803", level: "category", name: "Pigs",            icon: <FaDrumstickBite /> },
  { id: "080313", parentId: "0803", level: "category", name: "Poultry",         icon: <FaDrumstickBite /> },
  { id: "080314", parentId: "0803", level: "category", name: "Ostrich",         icon: <FaDrumstickBite /> },
  { id: "080315", parentId: "0803", level: "category", name: "Rabbits",         icon: <FaDrumstickBite /> },
  { id: "080316", parentId: "0803", level: "category", name: "Fish Farming",    icon: <FaFish /> },
  { id: "080317", parentId: "0803", level: "category", name: "Bee Products",    icon: <FaWineBottle /> },
  { id: "080318", parentId: "0803", level: "category", name: "Raw Dairy",       icon: <FaCheese /> },
  { id: "080319", parentId: "0803", level: "category", name: "Eggs",            icon: <FaEgg /> },
  { id: "080320", parentId: "0803", level: "category", name: "Coffee",          icon: <FaMugSaucer /> },
  { id: "080321", parentId: "0803", level: "category", name: "Tea",             icon: <FaMugSaucer /> },
  { id: "080322", parentId: "0803", level: "category", name: "Sugarcane",       icon: <FaSeedling /> },
  { id: "080323", parentId: "0803", level: "category", name: "Cotton",          icon: <FaSeedling /> },
  { id: "080324", parentId: "0803", level: "category", name: "Flowers",         icon: <FaLeaf /> },
];

export const SubCategoryFarmProduce: CategoryItem[] = [
  // Vegetables (080301)
  { id: "08030101", parentId: "080301", level: "subCategory", name: "Leafy Greens",  icon: <FaLeaf /> },
  { id: "08030102", parentId: "080301", level: "subCategory", name: "Tomatoes",      icon: <FaCarrot /> },
  { id: "08030103", parentId: "080301", level: "subCategory", name: "Peppers",       icon: <FaPepperHot /> },
  { id: "08030104", parentId: "080301", level: "subCategory", name: "Onions",        icon: <FaCarrot /> },
  { id: "08030105", parentId: "080301", level: "subCategory", name: "Cabbages",      icon: <FaLeaf /> },
  { id: "08030106", parentId: "080301", level: "subCategory", name: "Carrots",       icon: <FaCarrot /> },
  { id: "08030107", parentId: "080301", level: "subCategory", name: "Cucumbers",     icon: <FaLeaf /> },

  // Fruits (080302)
  { id: "08030201", parentId: "080302", level: "subCategory", name: "Citrus",        icon: <FaAppleWhole /> },
  { id: "08030202", parentId: "080302", level: "subCategory", name: "Bananas",       icon: <FaAppleWhole /> },
  { id: "08030203", parentId: "080302", level: "subCategory", name: "Mangoes",       icon: <FaAppleWhole /> },
  { id: "08030204", parentId: "080302", level: "subCategory", name: "Avocados",      icon: <FaAppleWhole /> },
  { id: "08030205", parentId: "080302", level: "subCategory", name: "Berries",       icon: <FaAppleWhole /> },
  { id: "08030206", parentId: "080302", level: "subCategory", name: "Melons",        icon: <FaAppleWhole /> },
  { id: "08030207", parentId: "080302", level: "subCategory", name: "Pineapples",    icon: <FaAppleWhole /> },

  // Grains (080303)
  { id: "08030301", parentId: "080303", level: "subCategory", name: "Maize",         icon: <FaBowlRice /> },
  { id: "08030302", parentId: "080303", level: "subCategory", name: "Rice",          icon: <FaBowlRice /> },
  { id: "08030303", parentId: "080303", level: "subCategory", name: "Wheat",         icon: <FaBowlRice /> },
  { id: "08030304", parentId: "080303", level: "subCategory", name: "Millet",        icon: <FaBowlRice /> },
  { id: "08030305", parentId: "080303", level: "subCategory", name: "Sorghum",       icon: <FaBowlRice /> },

  // Legumes (080304)
  { id: "08030401", parentId: "080304", level: "subCategory", name: "Beans",         icon: <FaSeedling /> },
  { id: "08030402", parentId: "080304", level: "subCategory", name: "Lentils",       icon: <FaSeedling /> },
  { id: "08030403", parentId: "080304", level: "subCategory", name: "Peas",          icon: <FaSeedling /> },
  { id: "08030404", parentId: "080304", level: "subCategory", name: "Groundnuts",    icon: <FaSeedling /> },
  { id: "08030405", parentId: "080304", level: "subCategory", name: "Soybeans",      icon: <FaSeedling /> },

  // Tubers (080305)
  { id: "08030501", parentId: "080305", level: "subCategory", name: "Potatoes",      icon: <FaCarrot /> },
  { id: "08030502", parentId: "080305", level: "subCategory", name: "Sweet Potatoes", icon: <FaCarrot /> },
  { id: "08030503", parentId: "080305", level: "subCategory", name: "Cassava",       icon: <FaCarrot /> },
  { id: "08030504", parentId: "080305", level: "subCategory", name: "Yams",          icon: <FaCarrot /> },
  { id: "08030505", parentId: "080305", level: "subCategory", name: "Arrowroot",     icon: <FaCarrot /> },

  // Herbs (080306)
  { id: "08030601", parentId: "080306", level: "subCategory", name: "Basil",         icon: <FaLeaf /> },
  { id: "08030602", parentId: "080306", level: "subCategory", name: "Coriander",     icon: <FaLeaf /> },
  { id: "08030603", parentId: "080306", level: "subCategory", name: "Mint",          icon: <FaLeaf /> },
  { id: "08030604", parentId: "080306", level: "subCategory", name: "Rosemary",      icon: <FaLeaf /> },
  { id: "08030605", parentId: "080306", level: "subCategory", name: "Thyme",         icon: <FaLeaf /> },

  // Nuts (080307)
  { id: "08030701", parentId: "080307", level: "subCategory", name: "Macadamia",     icon: <FaSeedling /> },
  { id: "08030702", parentId: "080307", level: "subCategory", name: "Cashew",        icon: <FaSeedling /> },
  { id: "08030703", parentId: "080307", level: "subCategory", name: "Peanuts",       icon: <FaSeedling /> },
  { id: "08030704", parentId: "080307", level: "subCategory", name: "Almonds",       icon: <FaSeedling /> },

  // Seeds (080308)
  { id: "08030801", parentId: "080308", level: "subCategory", name: "Sunflower Seeds", icon: <FaSeedling /> },
  { id: "08030802", parentId: "080308", level: "subCategory", name: "Sesame Seeds",    icon: <FaSeedling /> },
  { id: "08030803", parentId: "080308", level: "subCategory", name: "Pumpkin Seeds",   icon: <FaSeedling /> },
  { id: "08030804", parentId: "080308", level: "subCategory", name: "Chia Seeds",      icon: <FaSeedling /> },

  // Cattle (080309)
  { id: "08030901", parentId: "080309", level: "subCategory", name: "Dairy Cattle",  icon: <FaDrumstickBite /> },
  { id: "08030902", parentId: "080309", level: "subCategory", name: "Beef Cattle",   icon: <FaDrumstickBite /> },
  { id: "08030903", parentId: "080309", level: "subCategory", name: "Calves",        icon: <FaDrumstickBite /> },

  // Goats (080310)
  { id: "08031001", parentId: "080310", level: "subCategory", name: "Dairy Goats",   icon: <FaDrumstickBite /> },
  { id: "08031002", parentId: "080310", level: "subCategory", name: "Meat Goats",    icon: <FaDrumstickBite /> },

  // Sheep (080311)
  { id: "08031101", parentId: "080311", level: "subCategory", name: "Wool Sheep",    icon: <FaDrumstickBite /> },
  { id: "08031102", parentId: "080311", level: "subCategory", name: "Meat Sheep",    icon: <FaDrumstickBite /> },

  // Pigs (080312)
  { id: "08031201", parentId: "080312", level: "subCategory", name: "Piglets",       icon: <FaDrumstickBite /> },
  { id: "08031202", parentId: "080312", level: "subCategory", name: "Breeding Pigs", icon: <FaDrumstickBite /> },
  { id: "08031203", parentId: "080312", level: "subCategory", name: "Market Pigs",   icon: <FaDrumstickBite /> },

  // Poultry (080313)
  { id: "08031301", parentId: "080313", level: "subCategory", name: "Layers",        icon: <FaDrumstickBite /> },
  { id: "08031302", parentId: "080313", level: "subCategory", name: "Broilers",      icon: <FaDrumstickBite /> },
  { id: "08031303", parentId: "080313", level: "subCategory", name: "Kienyeji Chicken", icon: <FaDrumstickBite /> },
  { id: "08031304", parentId: "080313", level: "subCategory", name: "Turkeys",       icon: <FaDrumstickBite /> },
  { id: "08031305", parentId: "080313", level: "subCategory", name: "Ducks",         icon: <FaDrumstickBite /> },
  { id: "08031306", parentId: "080313", level: "subCategory", name: "Quail",         icon: <FaDrumstickBite /> },
  { id: "08031307", parentId: "080313", level: "subCategory", name: "Guinea Fowl",   icon: <FaDrumstickBite /> },

  // Ostrich (080314)
  { id: "08031401", parentId: "080314", level: "subCategory", name: "Ostrich Chicks", icon: <FaDrumstickBite /> },
  { id: "08031402", parentId: "080314", level: "subCategory", name: "Breeding Ostrich", icon: <FaDrumstickBite /> },
  { id: "08031403", parentId: "080314", level: "subCategory", name: "Market Ostrich", icon: <FaDrumstickBite /> },

  // Rabbits (080315)
  { id: "08031501", parentId: "080315", level: "subCategory", name: "Breeding Rabbits", icon: <FaDrumstickBite /> },
  { id: "08031502", parentId: "080315", level: "subCategory", name: "Meat Rabbits",     icon: <FaDrumstickBite /> },

  // Fish Farming (080316)
  { id: "08031601", parentId: "080316", level: "subCategory", name: "Tilapia Fingerlings", icon: <FaFish /> },
  { id: "08031602", parentId: "080316", level: "subCategory", name: "Catfish Fingerlings", icon: <FaFish /> },
  { id: "08031603", parentId: "080316", level: "subCategory", name: "Market Fish",         icon: <FaFish /> },

  // Bee Products (080317)
  { id: "08031701", parentId: "080317", level: "subCategory", name: "Raw Honey",     icon: <FaWineBottle /> },
  { id: "08031702", parentId: "080317", level: "subCategory", name: "Beeswax",       icon: <FaWineBottle /> },
  { id: "08031703", parentId: "080317", level: "subCategory", name: "Propolis",      icon: <FaWineBottle /> },

  // Raw Dairy (080318)
  { id: "08031801", parentId: "080318", level: "subCategory", name: "Raw Cow Milk",  icon: <FaCheese /> },
  { id: "08031802", parentId: "080318", level: "subCategory", name: "Raw Goat Milk", icon: <FaCheese /> },
  { id: "08031803", parentId: "080318", level: "subCategory", name: "Farmhouse Cheese", icon: <FaCheese /> },
  { id: "08031804", parentId: "080318", level: "subCategory", name: "Farmhouse Yogurt", icon: <FaCheese /> },

  // Eggs (080319)
  { id: "08031901", parentId: "080319", level: "subCategory", name: "Farm Chicken Eggs", icon: <FaEgg /> },
  { id: "08031902", parentId: "080319", level: "subCategory", name: "Farm Duck Eggs",    icon: <FaEgg /> },
  { id: "08031903", parentId: "080319", level: "subCategory", name: "Farm Quail Eggs",   icon: <FaEgg /> },

  // Coffee (080320)
  { id: "08032001", parentId: "080320", level: "subCategory", name: "Arabica Beans",  icon: <FaMugSaucer /> },
  { id: "08032002", parentId: "080320", level: "subCategory", name: "Robusta Beans",  icon: <FaMugSaucer /> },
  { id: "08032003", parentId: "080320", level: "subCategory", name: "Green Coffee Beans", icon: <FaMugSaucer /> },

  // Tea (080321)
  { id: "08032101", parentId: "080321", level: "subCategory", name: "Tea Leaves",    icon: <FaMugSaucer /> },
  { id: "08032102", parentId: "080321", level: "subCategory", name: "Black Tea",     icon: <FaMugSaucer /> },
  { id: "08032103", parentId: "080321", level: "subCategory", name: "Green Tea",     icon: <FaMugSaucer /> },

  // Sugarcane (080322)
  { id: "08032201", parentId: "080322", level: "subCategory", name: "Raw Sugarcane", icon: <FaSeedling /> },
  { id: "08032202", parentId: "080322", level: "subCategory", name: "Sugarcane Seedlings", icon: <FaSeedling /> },

  // Cotton (080323)
  { id: "08032301", parentId: "080323", level: "subCategory", name: "Raw Cotton",    icon: <FaSeedling /> },
  { id: "08032302", parentId: "080323", level: "subCategory", name: "Cotton Seed",   icon: <FaSeedling /> },

  // Flowers (080324)
  { id: "08032401", parentId: "080324", level: "subCategory", name: "Cut Flowers",   icon: <FaLeaf /> },
  { id: "08032402", parentId: "080324", level: "subCategory", name: "Roses",         icon: <FaLeaf /> },
  { id: "08032403", parentId: "080324", level: "subCategory", name: "Ornamental Plants", icon: <FaLeaf /> },
];


/* ═══════════════════════════════════════════════════════════
   FURNITURE (dept 09)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   LIVING ROOM   (parentId: 0901)
   ─────────────────────────────────────────────────────────── */
export const CategoryLivingRoom: CategoryItem[] = [];
export const SubCategoryLivingRoom: CategoryItem[] = [];
export const ProductTypeLivingRoom: CategoryItem[] = [];
export const ProductLivingRoom: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BEDROOM   (parentId: 0902)
   ─────────────────────────────────────────────────────────── */
export const CategoryBedroom: CategoryItem[] = [];
export const SubCategoryBedroom: CategoryItem[] = [];
export const ProductTypeBedroom: CategoryItem[] = [];
export const ProductBedroom: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   DINING ROOM   (parentId: 0903)
   ─────────────────────────────────────────────────────────── */
export const CategoryDiningRoom: CategoryItem[] = [];
export const SubCategoryDiningRoom: CategoryItem[] = [];
export const ProductTypeDiningRoom: CategoryItem[] = [];
export const ProductDiningRoom: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   OFFICE FURNITURE   (parentId: 0904)
   ─────────────────────────────────────────────────────────── */
export const CategoryOfficeFurniture: CategoryItem[] = [];
export const SubCategoryOfficeFurniture: CategoryItem[] = [];
export const ProductTypeOfficeFurniture: CategoryItem[] = [];
export const ProductOfficeFurniture: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   OUTDOOR FURNITURE   (parentId: 0905)
   ─────────────────────────────────────────────────────────── */
export const CategoryOutdoorFurniture: CategoryItem[] = [];
export const SubCategoryOutdoorFurniture: CategoryItem[] = [];
export const ProductTypeOutdoorFurniture: CategoryItem[] = [];
export const ProductOutdoorFurniture: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   STORAGE   (parentId: 0906)
   ─────────────────────────────────────────────────────────── */
export const CategoryStorage: CategoryItem[] = [];
export const SubCategoryStorage: CategoryItem[] = [];
export const ProductTypeStorage: CategoryItem[] = [];
export const ProductStorage: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   KIDS FURNITURE   (parentId: 0907)
   ─────────────────────────────────────────────────────────── */
export const CategoryKidsFurniture: CategoryItem[] = [];
export const SubCategoryKidsFurniture: CategoryItem[] = [];
export const ProductTypeKidsFurniture: CategoryItem[] = [];
export const ProductKidsFurniture: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   GAMING (dept 10)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   VIDEO GAMES   (parentId: 1001)
   ─────────────────────────────────────────────────────────── */
export const CategoryVideoGames: CategoryItem[] = [];
export const SubCategoryVideoGames: CategoryItem[] = [];
export const ProductTypeVideoGames: CategoryItem[] = [];
export const ProductVideoGames: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   GAMING CONSOLES   (parentId: 1002)
   ─────────────────────────────────────────────────────────── */
export const CategoryGamingConsoles: CategoryItem[] = [];
export const SubCategoryGamingConsoles: CategoryItem[] = [];
export const ProductTypeGamingConsoles: CategoryItem[] = [];
export const ProductGamingConsoles: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   GAMING ACCESSORIES   (parentId: 1003)
   ─────────────────────────────────────────────────────────── */
export const CategoryGamingAccessories: CategoryItem[] = [];
export const SubCategoryGamingAccessories: CategoryItem[] = [];
export const ProductTypeGamingAccessories: CategoryItem[] = [];
export const ProductGamingAccessories: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   PC GAMING   (parentId: 1004)
   ─────────────────────────────────────────────────────────── */
export const CategoryPCGaming: CategoryItem[] = [];
export const SubCategoryPCGaming: CategoryItem[] = [];
export const ProductTypePCGaming: CategoryItem[] = [];
export const ProductPCGaming: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BOARD GAMES   (parentId: 1005)
   ─────────────────────────────────────────────────────────── */
export const CategoryBoardGames: CategoryItem[] = [];
export const SubCategoryBoardGames: CategoryItem[] = [];
export const ProductTypeBoardGames: CategoryItem[] = [];
export const ProductBoardGames: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CARD GAMES   (parentId: 1006)
   ─────────────────────────────────────────────────────────── */
export const CategoryCardGames: CategoryItem[] = [];
export const SubCategoryCardGames: CategoryItem[] = [];
export const ProductTypeCardGames: CategoryItem[] = [];
export const ProductCardGames: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   VR GAMING   (parentId: 1007)
   ─────────────────────────────────────────────────────────── */
export const CategoryVRGaming: CategoryItem[] = [];
export const SubCategoryVRGaming: CategoryItem[] = [];
export const ProductTypeVRGaming: CategoryItem[] = [];
export const ProductVRGaming: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   GIFTS (dept 11)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   GIFT CARDS   (parentId: 1101)
   ─────────────────────────────────────────────────────────── */
export const CategoryGiftCards: CategoryItem[] = [];
export const SubCategoryGiftCards: CategoryItem[] = [];
export const ProductTypeGiftCards: CategoryItem[] = [];
export const ProductGiftCards: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   PERSONALIZED GIFTS   (parentId: 1102)
   ─────────────────────────────────────────────────────────── */
export const CategoryPersonalizedGifts: CategoryItem[] = [];
export const SubCategoryPersonalizedGifts: CategoryItem[] = [];
export const ProductTypePersonalizedGifts: CategoryItem[] = [];
export const ProductPersonalizedGifts: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   GIFT SETS   (parentId: 1103)
   ─────────────────────────────────────────────────────────── */
export const CategoryGiftSets: CategoryItem[] = [];
export const SubCategoryGiftSets: CategoryItem[] = [];
export const ProductTypeGiftSets: CategoryItem[] = [];
export const ProductGiftSets: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   OCCASION GIFTS   (parentId: 1104)
   ─────────────────────────────────────────────────────────── */
export const CategoryOccasionGifts: CategoryItem[] = [];
export const SubCategoryOccasionGifts: CategoryItem[] = [];
export const ProductTypeOccasionGifts: CategoryItem[] = [];
export const ProductOccasionGifts: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   GIFT WRAP & ACCESSORIES   (parentId: 1105)
   ─────────────────────────────────────────────────────────── */
export const CategoryGiftWrapAccessories: CategoryItem[] = [];
export const SubCategoryGiftWrapAccessories: CategoryItem[] = [];
export const ProductTypeGiftWrapAccessories: CategoryItem[] = [];
export const ProductGiftWrapAccessories: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   KITCHEN (dept 12)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   COOKWARE   (parentId: 1201)
   ─────────────────────────────────────────────────────────── */
export const CategoryCookware: CategoryItem[] = [];
export const SubCategoryCookware: CategoryItem[] = [];
export const ProductTypeCookware: CategoryItem[] = [];
export const ProductCookware: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BAKEWARE   (parentId: 1202)
   ─────────────────────────────────────────────────────────── */
export const CategoryBakeware: CategoryItem[] = [];
export const SubCategoryBakeware: CategoryItem[] = [];
export const ProductTypeBakeware: CategoryItem[] = [];
export const ProductBakeware: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   KITCHEN UTENSILS   (parentId: 1203)
   ─────────────────────────────────────────────────────────── */
export const CategoryKitchenUtensils: CategoryItem[] = [];
export const SubCategoryKitchenUtensils: CategoryItem[] = [];
export const ProductTypeKitchenUtensils: CategoryItem[] = [];
export const ProductKitchenUtensils: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   SMALL KITCHEN APPLIANCES   (parentId: 1204)
   ─────────────────────────────────────────────────────────── */
export const CategorySmallKitchenAppliances: CategoryItem[] = [];
export const SubCategorySmallKitchenAppliances: CategoryItem[] = [];
export const ProductTypeSmallKitchenAppliances: CategoryItem[] = [];
export const ProductSmallKitchenAppliances: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   TABLEWARE   (parentId: 1205)
   ─────────────────────────────────────────────────────────── */
export const CategoryTableware: CategoryItem[] = [];
export const SubCategoryTableware: CategoryItem[] = [];
export const ProductTypeTableware: CategoryItem[] = [];
export const ProductTableware: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   STORAGE & ORGANIZATION   (parentId: 1206)
   ─────────────────────────────────────────────────────────── */
export const CategoryStorageOrganization: CategoryItem[] = [];
export const SubCategoryStorageOrganization: CategoryItem[] = [];
export const ProductTypeStorageOrganization: CategoryItem[] = [];
export const ProductStorageOrganization: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CUTLERY   (parentId: 1207)
   ─────────────────────────────────────────────────────────── */
export const CategoryCutlery: CategoryItem[] = [];
export const SubCategoryCutlery: CategoryItem[] = [];
export const ProductTypeCutlery: CategoryItem[] = [];
export const ProductCutlery: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   LUGGAGE (dept 13)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   SUITCASES   (parentId: 1301)
   ─────────────────────────────────────────────────────────── */
export const CategorySuitcases: CategoryItem[] = [];
export const SubCategorySuitcases: CategoryItem[] = [];
export const ProductTypeSuitcases: CategoryItem[] = [];
export const ProductSuitcases: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   TRAVEL BAGS   (parentId: 1302)
   ─────────────────────────────────────────────────────────── */
export const CategoryTravelBags: CategoryItem[] = [];
export const SubCategoryTravelBags: CategoryItem[] = [];
export const ProductTypeTravelBags: CategoryItem[] = [];
export const ProductTravelBags: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BACKPACKS   (parentId: 1303)
   ─────────────────────────────────────────────────────────── */
export const CategoryBackpacks: CategoryItem[] = [];
export const SubCategoryBackpacks: CategoryItem[] = [];
export const ProductTypeBackpacks: CategoryItem[] = [];
export const ProductBackpacks: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   TRAVEL ACCESSORIES   (parentId: 1304)
   ─────────────────────────────────────────────────────────── */
export const CategoryTravelAccessories: CategoryItem[] = [];
export const SubCategoryTravelAccessories: CategoryItem[] = [];
export const ProductTypeTravelAccessories: CategoryItem[] = [];
export const ProductTravelAccessories: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   GARMENT BAGS   (parentId: 1305)
   ─────────────────────────────────────────────────────────── */
export const CategoryGarmentBags: CategoryItem[] = [];
export const SubCategoryGarmentBags: CategoryItem[] = [];
export const ProductTypeGarmentBags: CategoryItem[] = [];
export const ProductGarmentBags: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   PETS (dept 14)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   DOG SUPPLIES   (parentId: 1401)
   ─────────────────────────────────────────────────────────── */
export const CategoryDogSupplies: CategoryItem[] = [];
export const SubCategoryDogSupplies: CategoryItem[] = [];
export const ProductTypeDogSupplies: CategoryItem[] = [];
export const ProductDogSupplies: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CAT SUPPLIES   (parentId: 1402)
   ─────────────────────────────────────────────────────────── */
export const CategoryCatSupplies: CategoryItem[] = [];
export const SubCategoryCatSupplies: CategoryItem[] = [];
export const ProductTypeCatSupplies: CategoryItem[] = [];
export const ProductCatSupplies: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   FISH & AQUATICS   (parentId: 1403)
   ─────────────────────────────────────────────────────────── */
export const CategoryFishAquatics: CategoryItem[] = [];
export const SubCategoryFishAquatics: CategoryItem[] = [];
export const ProductTypeFishAquatics: CategoryItem[] = [];
export const ProductFishAquatics: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BIRD SUPPLIES   (parentId: 1404)
   ─────────────────────────────────────────────────────────── */
export const CategoryBirdSupplies: CategoryItem[] = [];
export const SubCategoryBirdSupplies: CategoryItem[] = [];
export const ProductTypeBirdSupplies: CategoryItem[] = [];
export const ProductBirdSupplies: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   SMALL ANIMAL SUPPLIES   (parentId: 1405)
   ─────────────────────────────────────────────────────────── */
export const CategorySmallAnimalSupplies: CategoryItem[] = [];
export const SubCategorySmallAnimalSupplies: CategoryItem[] = [];
export const ProductTypeSmallAnimalSupplies: CategoryItem[] = [];
export const ProductSmallAnimalSupplies: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   PET FOOD   (parentId: 1406)
   ─────────────────────────────────────────────────────────── */
export const CategoryPetFood: CategoryItem[] = [];
export const SubCategoryPetFood: CategoryItem[] = [];
export const ProductTypePetFood: CategoryItem[] = [];
export const ProductPetFood: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   PET HEALTH & WELLNESS   (parentId: 1407)
   ─────────────────────────────────────────────────────────── */
export const CategoryPetHealthWellness: CategoryItem[] = [];
export const SubCategoryPetHealthWellness: CategoryItem[] = [];
export const ProductTypePetHealthWellness: CategoryItem[] = [];
export const ProductPetHealthWellness: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   SPORTS (dept 15)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   TEAM SPORTS   (parentId: 1501)
   ─────────────────────────────────────────────────────────── */
export const CategoryTeamSports: CategoryItem[] = [];
export const SubCategoryTeamSports: CategoryItem[] = [];
export const ProductTypeTeamSports: CategoryItem[] = [];
export const ProductTeamSports: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   FITNESS & EXERCISE   (parentId: 1502)
   ─────────────────────────────────────────────────────────── */
export const CategoryFitnessExercise: CategoryItem[] = [];
export const SubCategoryFitnessExercise: CategoryItem[] = [];
export const ProductTypeFitnessExercise: CategoryItem[] = [];
export const ProductFitnessExercise: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   OUTDOOR RECREATION   (parentId: 1503)
   ─────────────────────────────────────────────────────────── */
export const CategoryOutdoorRecreation: CategoryItem[] = [];
export const SubCategoryOutdoorRecreation: CategoryItem[] = [];
export const ProductTypeOutdoorRecreation: CategoryItem[] = [];
export const ProductOutdoorRecreation: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   CYCLING   (parentId: 1504)
   ─────────────────────────────────────────────────────────── */
export const CategoryCycling: CategoryItem[] = [];
export const SubCategoryCycling: CategoryItem[] = [];
export const ProductTypeCycling: CategoryItem[] = [];
export const ProductCycling: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   WATER SPORTS   (parentId: 1505)
   ─────────────────────────────────────────────────────────── */
export const CategoryWaterSports: CategoryItem[] = [];
export const SubCategoryWaterSports: CategoryItem[] = [];
export const ProductTypeWaterSports: CategoryItem[] = [];
export const ProductWaterSports: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   WINTER SPORTS   (parentId: 1506)
   ─────────────────────────────────────────────────────────── */
export const CategoryWinterSports: CategoryItem[] = [];
export const SubCategoryWinterSports: CategoryItem[] = [];
export const ProductTypeWinterSports: CategoryItem[] = [];
export const ProductWinterSports: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   SPORTS APPAREL   (parentId: 1507)
   ─────────────────────────────────────────────────────────── */
export const CategorySportsApparel: CategoryItem[] = [];
export const SubCategorySportsApparel: CategoryItem[] = [];
export const ProductTypeSportsApparel: CategoryItem[] = [];
export const ProductSportsApparel: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   TOOLS (dept 16)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   HAND TOOLS   (parentId: 1601)
   ─────────────────────────────────────────────────────────── */
export const CategoryHandTools: CategoryItem[] = [];
export const SubCategoryHandTools: CategoryItem[] = [];
export const ProductTypeHandTools: CategoryItem[] = [];
export const ProductHandTools: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   POWER TOOLS   (parentId: 1602)
   ─────────────────────────────────────────────────────────── */
export const CategoryPowerTools: CategoryItem[] = [];
export const SubCategoryPowerTools: CategoryItem[] = [];
export const ProductTypePowerTools: CategoryItem[] = [];
export const ProductPowerTools: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   TOOL STORAGE   (parentId: 1603)
   ─────────────────────────────────────────────────────────── */
export const CategoryToolStorage: CategoryItem[] = [];
export const SubCategoryToolStorage: CategoryItem[] = [];
export const ProductTypeToolStorage: CategoryItem[] = [];
export const ProductToolStorage: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   MEASURING TOOLS   (parentId: 1604)
   ─────────────────────────────────────────────────────────── */
export const CategoryMeasuringTools: CategoryItem[] = [];
export const SubCategoryMeasuringTools: CategoryItem[] = [];
export const ProductTypeMeasuringTools: CategoryItem[] = [];
export const ProductMeasuringTools: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   SAFETY EQUIPMENT   (parentId: 1605)
   ─────────────────────────────────────────────────────────── */
export const CategorySafetyEquipment: CategoryItem[] = [];
export const SubCategorySafetyEquipment: CategoryItem[] = [];
export const ProductTypeSafetyEquipment: CategoryItem[] = [];
export const ProductSafetyEquipment: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   PLUMBING TOOLS   (parentId: 1606)
   ─────────────────────────────────────────────────────────── */
export const CategoryPlumbingTools: CategoryItem[] = [];
export const SubCategoryPlumbingTools: CategoryItem[] = [];
export const ProductTypePlumbingTools: CategoryItem[] = [];
export const ProductPlumbingTools: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   ELECTRICAL TOOLS   (parentId: 1607)
   ─────────────────────────────────────────────────────────── */
export const CategoryElectricalTools: CategoryItem[] = [];
export const SubCategoryElectricalTools: CategoryItem[] = [];
export const ProductTypeElectricalTools: CategoryItem[] = [];
export const ProductElectricalTools: CategoryItem[] = [];


/* ═══════════════════════════════════════════════════════════
   TOYS (dept 17)
═══════════════════════════════════════════════════════════ */

/* ───────────────────────────────────────────────────────────
   ACTION FIGURES   (parentId: 1701)
   ─────────────────────────────────────────────────────────── */
export const CategoryActionFigures: CategoryItem[] = [];
export const SubCategoryActionFigures: CategoryItem[] = [];
export const ProductTypeActionFigures: CategoryItem[] = [];
export const ProductActionFigures: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   BUILDING TOYS   (parentId: 1702)
   ─────────────────────────────────────────────────────────── */
export const CategoryBuildingToys: CategoryItem[] = [];
export const SubCategoryBuildingToys: CategoryItem[] = [];
export const ProductTypeBuildingToys: CategoryItem[] = [];
export const ProductBuildingToys: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   EDUCATIONAL TOYS   (parentId: 1703)
   ─────────────────────────────────────────────────────────── */
export const CategoryEducationalToys: CategoryItem[] = [];
export const SubCategoryEducationalToys: CategoryItem[] = [];
export const ProductTypeEducationalToys: CategoryItem[] = [];
export const ProductEducationalToys: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   DOLLS   (parentId: 1704)
   ─────────────────────────────────────────────────────────── */
export const CategoryDolls: CategoryItem[] = [];
export const SubCategoryDolls: CategoryItem[] = [];
export const ProductTypeDolls: CategoryItem[] = [];
export const ProductDolls: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   OUTDOOR TOYS   (parentId: 1705)
   ─────────────────────────────────────────────────────────── */
export const CategoryOutdoorToys: CategoryItem[] = [];
export const SubCategoryOutdoorToys: CategoryItem[] = [];
export const ProductTypeOutdoorToys: CategoryItem[] = [];
export const ProductOutdoorToys: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   PUZZLES & GAMES   (parentId: 1706)
   ─────────────────────────────────────────────────────────── */
export const CategoryPuzzlesGames: CategoryItem[] = [];
export const SubCategoryPuzzlesGames: CategoryItem[] = [];
export const ProductTypePuzzlesGames: CategoryItem[] = [];
export const ProductPuzzlesGames: CategoryItem[] = [];

/* ───────────────────────────────────────────────────────────
   REMOTE CONTROL TOYS   (parentId: 1707)
   ─────────────────────────────────────────────────────────── */
export const CategoryRemoteControlToys: CategoryItem[] = [];
export const SubCategoryRemoteControlToys: CategoryItem[] = [];
export const ProductTypeRemoteControlToys: CategoryItem[] = [];
export const ProductRemoteControlToys: CategoryItem[] = [];




/* ═══════════════════════════════════════════════════════════
   AGGREGATED FLAT EXPORT (mirrors AllBabyMaternityProducts) —
   handy for mega menus / global search where you just need
   every CategoryItem in one flat array, regardless of level.
═══════════════════════════════════════════════════════════ */
export const AllCategoriesFlat: CategoryItem[] = [
 ...DEPARTMENTS,

  // ── department → category arrays (the "DEPARTMENT____" blocks) ──
  ...DEPARTMENTARTCRAFTS,
  ...DEPARTMENTAUTOMOTIVE,
  ...DEPARTMENTAVIATION,
  ...DEPARTMENTBABY,
  ...DEPARTMENTBEAUTY,
  ...DEPARTMENTBOOKS,
  ...DEPARTMENTELECTRONICS,
  ...DEPARTMENTAPPAREL,
  ...DEPARTMENTFOOD,
  ...DEPARTMENTFURNITURE,
  ...DEPARTMENTGAMING,
  ...DEPARTMENTGIFTS,
  ...DEPARTMENTKITCHEN,
  ...DEPARTMENTLUGGAGE,
  ...DEPARTMENTPETS,
  ...DEPARTMENTSPORTS,
  ...DEPARTMENTTOOLS,
  ...DEPARTMENTTOYS,

  
  
  /* ── 00 ArtCrafts ─────────────────────────────────────────── */
  ...CategoryPainting,             ...SubCategoryPainting,             ...ProductTypePainting,             ...ProductPainting,
  ...CategoryDrawing,              ...SubCategoryDrawing,              ...ProductTypeDrawing,              ...ProductDrawing,
  ...CategorySculptingPottery,     ...SubCategorySculptingPottery,     ...ProductTypeSculptingPottery,     ...ProductSculptingPottery,
  ...CategoryCraftSupplies,        ...SubCategoryCraftSupplies,        ...ProductTypeCraftSupplies,        ...ProductCraftSupplies,
  ...CategoryScrapbooking,         ...SubCategoryScrapbooking,         ...ProductTypeScrapbooking,         ...ProductScrapbooking,
  ...CategorySewingTextileCrafts,  ...SubCategorySewingTextileCrafts,  ...ProductTypeSewingTextileCrafts,  ...ProductSewingTextileCrafts,
  ...CategoryJewelryMaking,        ...SubCategoryJewelryMaking,        ...ProductTypeJewelryMaking,        ...ProductJewelryMaking,
  ...CategoryPartyPaperCrafts,     ...SubCategoryPartyPaperCrafts,     ...ProductTypePartyPaperCrafts,     ...ProductPartyPaperCrafts,

/* ── 01 Automotive ────────────────────────────────────────── */
  ...CategoryCarParts,             ...SubCategoryCarParts,             ...ProductTypeCarParts,             ...ProductCarParts,
  ...CategoryCarAccessories,       ...SubCategoryCarAccessories,       ...ProductTypeCarAccessories,       ...ProductCarAccessories,
  ...CategoryCarCareDetailing,     ...SubCategoryCarCareDetailing,     ...ProductTypeCarCareDetailing,     ...ProductCarCareDetailing,
  ...CategoryTiresWheels,          ...SubCategoryTiresWheels,          ...ProductTypeTiresWheels,          ...ProductTiresWheels,
  ...CategoryToolsEquipment,       ...SubCategoryToolsEquipment,       ...ProductTypeToolsEquipment,       ...ProductToolsEquipment,
  ...CategoryMotorcycleParts,      ...SubCategoryMotorcycleParts,      ...ProductTypeMotorcycleParts,      ...ProductMotorcycleParts,
  ...CategoryCarElectronics,       ...SubCategoryCarElectronics,       ...ProductTypeCarElectronics,       ...ProductCarElectronics,
  ...CategoryInteriorAccessories,  ...SubCategoryInteriorAccessories,  ...ProductTypeInteriorAccessories,  ...ProductInteriorAccessories,
  ...CategoryExteriorAccessories,  ...SubCategoryExteriorAccessories,  ...ProductTypeExteriorAccessories,  ...ProductExteriorAccessories,
  ...CategoryOilsFluids,           ...SubCategoryOilsFluids,           ...ProductTypeOilsFluids,           ...ProductOilsFluids,

/* ── 02 Aviation ──────────────────────────────────────────── */
  ...CategoryPilotSupplies,        ...SubCategoryPilotSupplies,        ...ProductTypePilotSupplies,        ...ProductPilotSupplies,
  ...CategoryAircraftParts,        ...SubCategoryAircraftParts,        ...ProductTypeAircraftParts,        ...ProductAircraftParts,
  ...CategoryAviationElectronics,  ...SubCategoryAviationElectronics,  ...ProductTypeAviationElectronics,  ...ProductAviationElectronics,
  ...CategoryModelAircraft,        ...SubCategoryModelAircraft,        ...ProductTypeModelAircraft,        ...ProductModelAircraft,
  ...CategoryAviationSafetyGear,   ...SubCategoryAviationSafetyGear,   ...ProductTypeAviationSafetyGear,   ...ProductAviationSafetyGear,
  ...CategoryDronesUAVs,           ...SubCategoryDronesUAVs,           ...ProductTypeDronesUAVs,           ...ProductDronesUAVs,
  ...CategoryAviationBooksCharts,  ...SubCategoryAviationBooksCharts,  ...ProductTypeAviationBooksCharts,  ...ProductAviationBooksCharts,

/* ── 03 Baby ──────────────────────────────────────────────── */
  ...CategoryBabyClothing,         ...SubCategoryBabyClothing,         ...ProductTypeBabyClothing,         ...ProductBabyClothing,
  ...CategoryBabyFeeding,          ...SubCategoryBabyFeeding,          ...ProductTypeBabyFeeding,          ...ProductBabyFeeding,
  ...CategoryBabyGear,             ...SubCategoryBabyGear,             ...ProductTypeBabyGear,             ...ProductBabyGear,
  ...CategoryNursery,              ...SubCategoryNursery,              ...ProductTypeNursery,              ...ProductNursery,
  ...CategoryDiapering,            ...SubCategoryDiapering,            ...ProductTypeDiapering,            ...ProductDiapering,
  ...CategoryBabySafety,           ...SubCategoryBabySafety,           ...ProductTypeBabySafety,           ...ProductBabySafety,
  ...CategoryBabyToys,             ...SubCategoryBabyToys,             ...ProductTypeBabyToys,             ...ProductBabyToys,
  ...CategoryMaternity,            ...SubCategoryMaternity,            ...ProductTypeMaternity,            ...ProductMaternity,

/* ── 04 Beauty ────────────────────────────────────────────── */
  ...CategorySkincare,             ...SubCategorySkincare,             ...ProductTypeSkincare,             ...ProductSkincare,
  ...CategoryMakeup,               ...SubCategoryMakeup,               ...ProductTypeMakeup,               ...ProductMakeup,
  ...CategoryHaircare,             ...SubCategoryHaircare,             ...ProductTypeHaircare,             ...ProductHaircare,
  ...CategoryFragrance,            ...SubCategoryFragrance,            ...ProductTypeFragrance,            ...ProductFragrance,
  ...CategoryBathBody,             ...SubCategoryBathBody,             ...ProductTypeBathBody,             ...ProductBathBody,
  ...CategoryNailCare,             ...SubCategoryNailCare,             ...ProductTypeNailCare,             ...ProductNailCare,
  ...CategoryMensGrooming,         ...SubCategoryMensGrooming,         ...ProductTypeMensGrooming,         ...ProductMensGrooming,
  ...CategoryBeautyToolsAccessories, ...SubCategoryBeautyToolsAccessories, ...ProductTypeBeautyToolsAccessories, ...ProductBeautyToolsAccessories,
  ...CategoryBeautyAppliances,     ...SubCategoryBeautyAppliances,     ...ProductTypeBeautyAppliances,     ...ProductBeautyAppliances,

/* ── 05 Books ─────────────────────────────────────────────── */
  ...CategoryFiction,              ...SubCategoryFiction,              ...ProductTypeFiction,              ...ProductFiction,
  ...CategoryNonFiction,           ...SubCategoryNonFiction,           ...ProductTypeNonFiction,           ...ProductNonFiction,
  ...CategoryChildrensBooks,       ...SubCategoryChildrensBooks,       ...ProductTypeChildrensBooks,       ...ProductChildrensBooks,
  ...CategoryEducationalTextbooks, ...SubCategoryEducationalTextbooks, ...ProductTypeEducationalTextbooks, ...ProductEducationalTextbooks,
  ...CategoryComicsGraphicNovels,  ...SubCategoryComicsGraphicNovels,  ...ProductTypeComicsGraphicNovels,  ...ProductComicsGraphicNovels,
  ...CategoryCookbooks,            ...SubCategoryCookbooks,            ...ProductTypeCookbooks,            ...ProductCookbooks,
  ...CategoryReligiousSpiritual,   ...SubCategoryReligiousSpiritual,   ...ProductTypeReligiousSpiritual,   ...ProductReligiousSpiritual,
  ...CategoryMagazines,            ...SubCategoryMagazines,            ...ProductTypeMagazines,            ...ProductMagazines,
  ...CategoryEBooksAudiobooks,     ...SubCategoryEBooksAudiobooks,     ...ProductTypeEBooksAudiobooks,     ...ProductEBooksAudiobooks,

/* ── 06 Electronics ───────────────────────────────────────── */
  ...CategoryTVHomeTheater,        ...SubCategoryTVHomeTheater,        ...ProductTypeTVHomeTheater,        ...ProductTVHomeTheater,
  ...CategoryITComputers,          ...SubCategoryITComputers,          ...ProductTypeITComputers,          ...ProductITComputers,
  ...CategoryTelephoneMobile,      ...SubCategoryTelephoneMobile,      ...ProductTypeTelephoneMobile,      ...ProductTelephoneMobile,
  ...CategoryAudio,                ...SubCategoryAudio,                ...ProductTypeAudio,                ...ProductAudio,
  ...CategoryHomeAppliances,       ...SubCategoryHomeAppliances,       ...ProductTypeHomeAppliances,       ...ProductHomeAppliances,
  ...CategoryKitchenAppliances,    ...SubCategoryKitchenAppliances,    ...ProductTypeKitchenAppliances,    ...ProductKitchenAppliances,
  ...CategoryEntertainment,        ...SubCategoryEntertainment,        ...ProductTypeEntertainment,        ...ProductEntertainment,
  ...CategoryGymAppliances,        ...SubCategoryGymAppliances,        ...ProductTypeGymAppliances,        ...ProductGymAppliances,
  ...CategoryHealthAppliances,     ...SubCategoryHealthAppliances,     ...ProductTypeHealthAppliances,     ...ProductHealthAppliances,
  ...CategoryFilmPhotography,      ...SubCategoryFilmPhotography,      ...ProductTypeFilmPhotography,      ...ProductFilmPhotography,
  ...CategoryMobilityAppliances,   ...SubCategoryMobilityAppliances,   ...ProductTypeMobilityAppliances,   ...ProductMobilityAppliances,
  ...CategoryHousekeepingAppliances, ...SubCategoryHousekeepingAppliances, ...ProductTypeHousekeepingAppliances, ...ProductHousekeepingAppliances,

/* ── 07 Apparel ───────────────────────────────────────────── */
  ...CategoryClothing,             ...SubCategoryClothing,             ...ProductTypeClothing,             ...ProductClothing,
  ...CategoryShoes,                ...SubCategoryShoes,                ...ProductTypeShoes,                ...ProductShoes,
  ...CategoryAccessories,          ...SubCategoryAccessories,          ...ProductTypeAccessories,          ...ProductAccessories,
  ...CategoryJewelry,              ...SubCategoryJewelry,              ...ProductTypeJewelry,              ...ProductJewelry,
  ...CategoryBags,                 ...SubCategoryBags,                 ...ProductTypeBags,                 ...ProductBags,

/* ── 08 Food ──────────────────────────────────────────────── */
  ...CategoryFastFood,             ...SubCategoryFastFood,             ...ProductTypeFastFood,             ...ProductFastFood,
  ...CategoryGrocery,              ...SubCategoryGrocery,
  ...CategoryFarmProduce,          ...SubCategoryFarmProduce,

/* ── 09 Furniture ─────────────────────────────────────────── */
  ...CategoryLivingRoom,           ...SubCategoryLivingRoom,           ...ProductTypeLivingRoom,           ...ProductLivingRoom,
  ...CategoryBedroom,              ...SubCategoryBedroom,              ...ProductTypeBedroom,              ...ProductBedroom,
  ...CategoryDiningRoom,           ...SubCategoryDiningRoom,           ...ProductTypeDiningRoom,           ...ProductDiningRoom,
  ...CategoryOfficeFurniture,      ...SubCategoryOfficeFurniture,      ...ProductTypeOfficeFurniture,      ...ProductOfficeFurniture,
  ...CategoryOutdoorFurniture,     ...SubCategoryOutdoorFurniture,     ...ProductTypeOutdoorFurniture,     ...ProductOutdoorFurniture,
  ...CategoryStorage,              ...SubCategoryStorage,              ...ProductTypeStorage,              ...ProductStorage,
  ...CategoryKidsFurniture,        ...SubCategoryKidsFurniture,        ...ProductTypeKidsFurniture,        ...ProductKidsFurniture,

/* ── 10 Gaming ────────────────────────────────────────────── */
  ...CategoryVideoGames,           ...SubCategoryVideoGames,           ...ProductTypeVideoGames,           ...ProductVideoGames,
  ...CategoryGamingConsoles,       ...SubCategoryGamingConsoles,       ...ProductTypeGamingConsoles,       ...ProductGamingConsoles,
  ...CategoryGamingAccessories,    ...SubCategoryGamingAccessories,    ...ProductTypeGamingAccessories,    ...ProductGamingAccessories,
  ...CategoryPCGaming,             ...SubCategoryPCGaming,             ...ProductTypePCGaming,             ...ProductPCGaming,
  ...CategoryBoardGames,           ...SubCategoryBoardGames,           ...ProductTypeBoardGames,           ...ProductBoardGames,
  ...CategoryCardGames,            ...SubCategoryCardGames,            ...ProductTypeCardGames,            ...ProductCardGames,
  ...CategoryVRGaming,             ...SubCategoryVRGaming,             ...ProductTypeVRGaming,             ...ProductVRGaming,

/* ── 11 Gifts ─────────────────────────────────────────────── */
  ...CategoryGiftCards,            ...SubCategoryGiftCards,            ...ProductTypeGiftCards,            ...ProductGiftCards,
  ...CategoryPersonalizedGifts,    ...SubCategoryPersonalizedGifts,    ...ProductTypePersonalizedGifts,    ...ProductPersonalizedGifts,
  ...CategoryGiftSets,             ...SubCategoryGiftSets,             ...ProductTypeGiftSets,             ...ProductGiftSets,
  ...CategoryOccasionGifts,        ...SubCategoryOccasionGifts,        ...ProductTypeOccasionGifts,        ...ProductOccasionGifts,
  ...CategoryGiftWrapAccessories,  ...SubCategoryGiftWrapAccessories,  ...ProductTypeGiftWrapAccessories,  ...ProductGiftWrapAccessories,

/* ── 12 Kitchen ───────────────────────────────────────────── */
  ...CategoryCookware,             ...SubCategoryCookware,             ...ProductTypeCookware,             ...ProductCookware,
  ...CategoryBakeware,             ...SubCategoryBakeware,             ...ProductTypeBakeware,             ...ProductBakeware,
  ...CategoryKitchenUtensils,      ...SubCategoryKitchenUtensils,      ...ProductTypeKitchenUtensils,      ...ProductKitchenUtensils,
  ...CategorySmallKitchenAppliances, ...SubCategorySmallKitchenAppliances, ...ProductTypeSmallKitchenAppliances, ...ProductSmallKitchenAppliances,
  ...CategoryTableware,            ...SubCategoryTableware,            ...ProductTypeTableware,            ...ProductTableware,
  ...CategoryStorageOrganization,  ...SubCategoryStorageOrganization,  ...ProductTypeStorageOrganization,  ...ProductStorageOrganization,
  ...CategoryCutlery,              ...SubCategoryCutlery,              ...ProductTypeCutlery,              ...ProductCutlery,

/* ── 13 Luggage ───────────────────────────────────────────── */
  ...CategorySuitcases,            ...SubCategorySuitcases,            ...ProductTypeSuitcases,            ...ProductSuitcases,
  ...CategoryTravelBags,           ...SubCategoryTravelBags,           ...ProductTypeTravelBags,           ...ProductTravelBags,
  ...CategoryBackpacks,            ...SubCategoryBackpacks,            ...ProductTypeBackpacks,            ...ProductBackpacks,
  ...CategoryTravelAccessories,    ...SubCategoryTravelAccessories,    ...ProductTypeTravelAccessories,    ...ProductTravelAccessories,
  ...CategoryGarmentBags,          ...SubCategoryGarmentBags,          ...ProductTypeGarmentBags,          ...ProductGarmentBags,

/* ── 14 Pets ──────────────────────────────────────────────── */
  ...CategoryDogSupplies,          ...SubCategoryDogSupplies,          ...ProductTypeDogSupplies,          ...ProductDogSupplies,
  ...CategoryCatSupplies,          ...SubCategoryCatSupplies,          ...ProductTypeCatSupplies,          ...ProductCatSupplies,
  ...CategoryFishAquatics,         ...SubCategoryFishAquatics,         ...ProductTypeFishAquatics,         ...ProductFishAquatics,
  ...CategoryBirdSupplies,         ...SubCategoryBirdSupplies,         ...ProductTypeBirdSupplies,         ...ProductBirdSupplies,
  ...CategorySmallAnimalSupplies,  ...SubCategorySmallAnimalSupplies,  ...ProductTypeSmallAnimalSupplies,  ...ProductSmallAnimalSupplies,
  ...CategoryPetFood,              ...SubCategoryPetFood,              ...ProductTypePetFood,              ...ProductPetFood,
  ...CategoryPetHealthWellness,    ...SubCategoryPetHealthWellness,    ...ProductTypePetHealthWellness,    ...ProductPetHealthWellness,

/* ── 15 Sports ────────────────────────────────────────────── */
  ...CategoryTeamSports,           ...SubCategoryTeamSports,           ...ProductTypeTeamSports,           ...ProductTeamSports,
  ...CategoryFitnessExercise,      ...SubCategoryFitnessExercise,      ...ProductTypeFitnessExercise,      ...ProductFitnessExercise,
  ...CategoryOutdoorRecreation,    ...SubCategoryOutdoorRecreation,    ...ProductTypeOutdoorRecreation,    ...ProductOutdoorRecreation,
  ...CategoryCycling,              ...SubCategoryCycling,              ...ProductTypeCycling,              ...ProductCycling,
  ...CategoryWaterSports,          ...SubCategoryWaterSports,          ...ProductTypeWaterSports,          ...ProductWaterSports,
  ...CategoryWinterSports,         ...SubCategoryWinterSports,         ...ProductTypeWinterSports,         ...ProductWinterSports,
  ...CategorySportsApparel,        ...SubCategorySportsApparel,        ...ProductTypeSportsApparel,        ...ProductSportsApparel,

/* ── 16 Tools ─────────────────────────────────────────────── */
  ...CategoryHandTools,            ...SubCategoryHandTools,            ...ProductTypeHandTools,            ...ProductHandTools,
  ...CategoryPowerTools,           ...SubCategoryPowerTools,           ...ProductTypePowerTools,           ...ProductPowerTools,
  ...CategoryToolStorage,          ...SubCategoryToolStorage,          ...ProductTypeToolStorage,          ...ProductToolStorage,
  ...CategoryMeasuringTools,       ...SubCategoryMeasuringTools,       ...ProductTypeMeasuringTools,       ...ProductMeasuringTools,
  ...CategorySafetyEquipment,      ...SubCategorySafetyEquipment,      ...ProductTypeSafetyEquipment,      ...ProductSafetyEquipment,
  ...CategoryPlumbingTools,        ...SubCategoryPlumbingTools,        ...ProductTypePlumbingTools,        ...ProductPlumbingTools,
  ...CategoryElectricalTools,      ...SubCategoryElectricalTools,      ...ProductTypeElectricalTools,      ...ProductElectricalTools,

/* ── 17 Toys ──────────────────────────────────────────────── */
  ...CategoryActionFigures,        ...SubCategoryActionFigures,        ...ProductTypeActionFigures,        ...ProductActionFigures,
  ...CategoryBuildingToys,         ...SubCategoryBuildingToys,         ...ProductTypeBuildingToys,         ...ProductBuildingToys,
  ...CategoryEducationalToys,      ...SubCategoryEducationalToys,      ...ProductTypeEducationalToys,      ...ProductEducationalToys,
  ...CategoryDolls,                ...SubCategoryDolls,                ...ProductTypeDolls,                ...ProductDolls,
  ...CategoryOutdoorToys,          ...SubCategoryOutdoorToys,          ...ProductTypeOutdoorToys,          ...ProductOutdoorToys,
  ...CategoryPuzzlesGames,         ...SubCategoryPuzzlesGames,         ...ProductTypePuzzlesGames,         ...ProductPuzzlesGames,
  ...CategoryRemoteControlToys,    ...SubCategoryRemoteControlToys,    ...ProductTypeRemoteControlToys,    ...ProductRemoteControlToys,

];